//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import BaseClient from "./BaseClient";

export class AmlClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    questions(): Promise<AmlQuestion[]> {
        let url_ = this.baseUrl + "/api/aml/questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuestions(_response);
        });
    }

    protected processQuestions(response: Response): Promise<AmlQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AmlQuestion[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmlQuestion[]>(null as any);
    }

    options(): Promise<AmlOptionsResponse> {
        let url_ = this.baseUrl + "/api/aml/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOptions(_response);
        });
    }

    protected processOptions(response: Response): Promise<AmlOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AmlOptionsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmlOptionsResponse>(null as any);
    }
}

export class AuthClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    login(loginModel: LoginModel): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    startBankIDAuth(bankIdLoginModel: BankIdLoginModel): Promise<BankIdAuthResponse> {
        let url_ = this.baseUrl + "/api/auth/bankid/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bankIdLoginModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartBankIDAuth(_response);
        });
    }

    protected processStartBankIDAuth(response: Response): Promise<BankIdAuthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdAuthResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdAuthResponse>(null as any);
    }

    getBankIDAuthStatus(statusModel: BankIdStatusModel): Promise<BankIdAuthStatusResponse> {
        let url_ = this.baseUrl + "/api/auth/bankid/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBankIDAuthStatus(_response);
        });
    }

    protected processGetBankIDAuthStatus(response: Response): Promise<BankIdAuthStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdAuthStatusResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdAuthStatusResponse>(null as any);
    }

    cancelBankIdAuth(orderRef: string): Promise<BankIdCancelResponse> {
        let url_ = this.baseUrl + "/api/auth/bankid/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderRef);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelBankIdAuth(_response);
        });
    }

    protected processCancelBankIdAuth(response: Response): Promise<BankIdCancelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdCancelResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdCancelResponse>(null as any);
    }

    requestNewPassword(username: string): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/password/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(username);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestNewPassword(_response);
        });
    }

    protected processRequestNewPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    ping(): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    refreshToken(): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unixExpirationDate(): Promise<number> {
        let url_ = this.baseUrl + "/api/auth/token/expiration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnixExpirationDate(_response);
        });
    }

    protected processUnixExpirationDate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getSustainabilityAnnualFundReportFile(year: number, isin: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/document/fab/{year}/{isin}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (isin === undefined || isin === null)
            throw new Error("The parameter 'isin' must be defined.");
        url_ = url_.replace("{isin}", encodeURIComponent("" + isin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSustainabilityAnnualFundReportFile(_response);
        });
    }

    protected processGetSustainabilityAnnualFundReportFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getByPermaIdDocumentFile(permaId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/document/quick/{permaId}";
        if (permaId === undefined || permaId === null)
            throw new Error("The parameter 'permaId' must be defined.");
        url_ = url_.replace("{permaId}", encodeURIComponent("" + permaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByPermaIdDocumentFile(_response);
        });
    }

    protected processGetByPermaIdDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class FundClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getPublicFunds(): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/fund/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicFunds(_response);
        });
    }

    protected processGetPublicFunds(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getPublicFundsIsins(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/fund/public/isins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicFundsIsins(_response);
        });
    }

    protected processGetPublicFundsIsins(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getFundsByPackage(packageId: number): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/fund/package/{packageId}";
        if (packageId === undefined || packageId === null)
            throw new Error("The parameter 'packageId' must be defined.");
        url_ = url_.replace("{packageId}", encodeURIComponent("" + packageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundsByPackage(_response);
        });
    }

    protected processGetFundsByPackage(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getFundsByGroup(groupId: number | null): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/fund/group/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundsByGroup(_response);
        });
    }

    protected processGetFundsByGroup(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getFundById(fundId: number): Promise<FundResponse> {
        let url_ = this.baseUrl + "/api/fund/{fundId}";
        if (fundId === undefined || fundId === null)
            throw new Error("The parameter 'fundId' must be defined.");
        url_ = url_.replace("{fundId}", encodeURIComponent("" + fundId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundById(_response);
        });
    }

    protected processGetFundById(response: Response): Promise<FundResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundResponse>(null as any);
    }

    getAllFunds(): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/fund";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllFunds(_response);
        });
    }

    protected processGetAllFunds(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getFundTopList(period: string, take: number): Promise<KeyValuePairOfStringAndNullableDecimal[]> {
        let url_ = this.baseUrl + "/api/fund/top/{take}/for/{period}";
        if (period === undefined || period === null)
            throw new Error("The parameter 'period' must be defined.");
        url_ = url_.replace("{period}", encodeURIComponent("" + period));
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined.");
        url_ = url_.replace("{take}", encodeURIComponent("" + take));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundTopList(_response);
        });
    }

    protected processGetFundTopList(response: Response): Promise<KeyValuePairOfStringAndNullableDecimal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfStringAndNullableDecimal[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfStringAndNullableDecimal[]>(null as any);
    }

    getNavs(fundId: number, fromDate: string | null | undefined, toDate: string | null | undefined, interval: Interval | null | undefined): Promise<Nav[]> {
        let url_ = this.baseUrl + "/api/fund/{fundId}/navs?";
        if (fundId === undefined || fundId === null)
            throw new Error("The parameter 'fundId' must be defined.");
        url_ = url_.replace("{fundId}", encodeURIComponent("" + fundId));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (interval !== undefined && interval !== null)
            url_ += "interval=" + encodeURIComponent("" + interval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNavs(_response);
        });
    }

    protected processGetNavs(response: Response): Promise<Nav[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Nav[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Nav[]>(null as any);
    }

    getLatestNavs(valueHolderIds: number[]): Promise<Nav[]> {
        let url_ = this.baseUrl + "/api/fund/latestnavs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valueHolderIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestNavs(_response);
        });
    }

    protected processGetLatestNavs(response: Response): Promise<Nav[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Nav[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Nav[]>(null as any);
    }

    csvForPublicFunds(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/fund/public/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCsvForPublicFunds(_response);
        });
    }

    protected processCsvForPublicFunds(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    csvByGroupId(groupId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/fund/group/{groupId}/csv";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCsvByGroupId(_response);
        });
    }

    protected processCsvByGroupId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    csvByPackageId(packageId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/fund/package/{packageId}/csv";
        if (packageId === undefined || packageId === null)
            throw new Error("The parameter 'packageId' must be defined.");
        url_ = url_.replace("{packageId}", encodeURIComponent("" + packageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCsvByPackageId(_response);
        });
    }

    protected processCsvByPackageId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    csvByArcaInsuranceId(arcaInsuranceId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/fund/insurance/{arcaInsuranceId}/csv";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCsvByArcaInsuranceId(_response);
        });
    }

    protected processCsvByArcaInsuranceId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFundNewsItem(id: number): Promise<FundNewsItem> {
        let url_ = this.baseUrl + "/api/fund/{id}/news";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundNewsItem(_response);
        });
    }

    protected processGetFundNewsItem(response: Response): Promise<FundNewsItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundNewsItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundNewsItem>(null as any);
    }

    getLatestFundNews(): Promise<FundNewsItem[]> {
        let url_ = this.baseUrl + "/api/fund/latest/news";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestFundNews(_response);
        });
    }

    protected processGetLatestFundNews(response: Response): Promise<FundNewsItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundNewsItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundNewsItem[]>(null as any);
    }

    getFundNews(skip: number | null, take: number | null, fundIsins: string[]): Promise<FundNewsItem[]> {
        let url_ = this.baseUrl + "/api/fund/news/{skip}/{take}";
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined.");
        url_ = url_.replace("{skip}", encodeURIComponent("" + skip));
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined.");
        url_ = url_.replace("{take}", encodeURIComponent("" + take));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fundIsins);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundNews(_response);
        });
    }

    protected processGetFundNews(response: Response): Promise<FundNewsItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundNewsItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundNewsItem[]>(null as any);
    }

    getDocument(documentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/fund/document/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    bankIdSignEnvelope(request: SignEnvelopeRequest): Promise<BankIdSignResponse> {
        let url_ = this.baseUrl + "/api/story/bankid/sign/envelope";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBankIdSignEnvelope(_response);
        });
    }

    protected processBankIdSignEnvelope(response: Response): Promise<BankIdSignResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdSignResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdSignResponse>(null as any);
    }

    getBankIdSignStatus(envelopeId: number, orderRef: string): Promise<BankIdAuthStatusResponse> {
        let url_ = this.baseUrl + "/api/story/{envelopeId}/bankid/sign/status";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderRef);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBankIdSignStatus(_response);
        });
    }

    protected processGetBankIdSignStatus(response: Response): Promise<BankIdAuthStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdAuthStatusResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdAuthStatusResponse>(null as any);
    }
}

export class SystemClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    serverInfo(): Promise<ServerInfo> {
        let url_ = this.baseUrl + "/api/system/serverinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processServerInfo(_response);
        });
    }

    protected processServerInfo(response: Response): Promise<ServerInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServerInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServerInfo>(null as any);
    }
}

export class SigningCaseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    signingUserCases(statuses: CaseStatus[] | null | undefined, skip: number | undefined, take: number | undefined): Promise<Case[]> {
        let url_ = this.baseUrl + "/api/signing/case/signingusers?";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSigningUserCases(_response);
        });
    }

    protected processSigningUserCases(response: Response): Promise<Case[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Case[]>(null as any);
    }
}

export class SigningDocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getDocumentFile(externalId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/signing/document/{externalId}/file";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentFile(_response);
        });
    }

    protected processGetDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SigningInsuranceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getInsuranceByOfficialId(insuranceOfficialId: string): Promise<InsuranceResponse> {
        let url_ = this.baseUrl + "/api/signing/insurance/officialid/{insuranceOfficialId}";
        if (insuranceOfficialId === undefined || insuranceOfficialId === null)
            throw new Error("The parameter 'insuranceOfficialId' must be defined.");
        url_ = url_.replace("{insuranceOfficialId}", encodeURIComponent("" + insuranceOfficialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceByOfficialId(_response);
        });
    }

    protected processGetInsuranceByOfficialId(response: Response): Promise<InsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse>(null as any);
    }
}

export class SigningStoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getStoryAssignment(envelopeId: number): Promise<Envelope> {
        let url_ = this.baseUrl + "/api/signing/story/{envelopeId}/assignment";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStoryAssignment(_response);
        });
    }

    protected processGetStoryAssignment(response: Response): Promise<Envelope> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope>(null as any);
    }

    acceptStoryEnvelope(envelopeId: number): Promise<Envelope> {
        let url_ = this.baseUrl + "/api/signing/story/{envelopeId}/accept";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptStoryEnvelope(_response);
        });
    }

    protected processAcceptStoryEnvelope(response: Response): Promise<Envelope> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope>(null as any);
    }

    denyStory(envelopeId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/signing/story/{envelopeId}/deny";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDenyStory(_response);
        });
    }

    protected processDenyStory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PartnerAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getAgreementById(arcaAgreementId: number): Promise<AgreementResponse> {
        let url_ = this.baseUrl + "/api/partner/agreement/{arcaAgreementId}";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgreementById(_response);
        });
    }

    protected processGetAgreementById(response: Response): Promise<AgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementResponse>(null as any);
    }

    getAgreementDetailsById(arcaAgreementId: number): Promise<AgreementResponse> {
        let url_ = this.baseUrl + "/api/partner/agreement/{arcaAgreementId}/extended";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgreementDetailsById(_response);
        });
    }

    protected processGetAgreementDetailsById(response: Response): Promise<AgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementResponse>(null as any);
    }
}

export class PartnerAuthClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getPartnersByOfficial(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/partner/auth/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartnersByOfficial(_response);
        });
    }

    protected processGetPartnersByOfficial(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    setLoginUser(selectedUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/auth/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedUserId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetLoginUser(_response);
        });
    }

    protected processSetLoginUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    impersonate(model: ImpersonateModel): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/auth/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImpersonate(_response);
        });
    }

    protected processImpersonate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    impersonateByAgreementId(agreementId: number): Promise<ImpersonateModel> {
        let url_ = this.baseUrl + "/api/partner/auth/impersonate/agreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agreementId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImpersonateByAgreementId(_response);
        });
    }

    protected processImpersonateByAgreementId(response: Response): Promise<ImpersonateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpersonateModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpersonateModel>(null as any);
    }

    impersonateByInsuranceId(insuranceOfficialId: string): Promise<ImpersonateModel> {
        let url_ = this.baseUrl + "/api/partner/auth/impersonate/insurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceOfficialId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImpersonateByInsuranceId(_response);
        });
    }

    protected processImpersonateByInsuranceId(response: Response): Promise<ImpersonateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpersonateModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpersonateModel>(null as any);
    }

    impersonateByPersonId(personId: string): Promise<ImpersonateModel> {
        let url_ = this.baseUrl + "/api/partner/auth/impersonate/person";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImpersonateByPersonId(_response);
        });
    }

    protected processImpersonateByPersonId(response: Response): Promise<ImpersonateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImpersonateModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpersonateModel>(null as any);
    }
}

export class PartnerBamClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getBamList(arcaInsuranceId: number | null | undefined, arcaAgreementId: number | null | undefined, bamId: number | undefined): Promise<BamResponse[]> {
        let url_ = this.baseUrl + "/api/partner/bam?";
        if (arcaInsuranceId !== undefined && arcaInsuranceId !== null)
            url_ += "arcaInsuranceId=" + encodeURIComponent("" + arcaInsuranceId) + "&";
        if (arcaAgreementId !== undefined && arcaAgreementId !== null)
            url_ += "arcaAgreementId=" + encodeURIComponent("" + arcaAgreementId) + "&";
        if (bamId === null)
            throw new Error("The parameter 'bamId' cannot be null.");
        else if (bamId !== undefined)
            url_ += "bamId=" + encodeURIComponent("" + bamId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBamList(_response);
        });
    }

    protected processGetBamList(response: Response): Promise<BamResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BamResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BamResponse[]>(null as any);
    }

    updateBam(request: BamRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/bam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBam(_response);
        });
    }

    protected processUpdateBam(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PartnerBrokerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getKeyFigures(): Promise<BrokerNumbers> {
        let url_ = this.baseUrl + "/api/partner/broker/keyfigures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKeyFigures(_response);
        });
    }

    protected processGetKeyFigures(response: Response): Promise<BrokerNumbers> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerNumbers;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerNumbers>(null as any);
    }

    getTopCompanies(): Promise<TopListEntry[]> {
        let url_ = this.baseUrl + "/api/partner/broker/companies/top";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTopCompanies(_response);
        });
    }

    protected processGetTopCompanies(response: Response): Promise<TopListEntry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TopListEntry[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopListEntry[]>(null as any);
    }

    createBrokerDelegation(brokerCode: string): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/broker/{brokerCode}/delegate";
        if (brokerCode === undefined || brokerCode === null)
            throw new Error("The parameter 'brokerCode' must be defined.");
        url_ = url_.replace("{brokerCode}", encodeURIComponent("" + brokerCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateBrokerDelegation(_response);
        });
    }

    protected processCreateBrokerDelegation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeBrokerDelegation(brokerCode: string): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/broker/{brokerCode}/delegate";
        if (brokerCode === undefined || brokerCode === null)
            throw new Error("The parameter 'brokerCode' must be defined.");
        url_ = url_.replace("{brokerCode}", encodeURIComponent("" + brokerCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveBrokerDelegation(_response);
        });
    }

    protected processRemoveBrokerDelegation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getBrokersByBrokerCompany(): Promise<BrokerPersonResponse[]> {
        let url_ = this.baseUrl + "/api/partner/broker/company";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBrokersByBrokerCompany(_response);
        });
    }

    protected processGetBrokersByBrokerCompany(response: Response): Promise<BrokerPersonResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerPersonResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerPersonResponse[]>(null as any);
    }

    getBrokerDelegatesTo(): Promise<BrokerPersonResponse[]> {
        let url_ = this.baseUrl + "/api/partner/broker/delegates/to";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBrokerDelegatesTo(_response);
        });
    }

    protected processGetBrokerDelegatesTo(response: Response): Promise<BrokerPersonResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerPersonResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerPersonResponse[]>(null as any);
    }

    getBrokerDelegatesFrom(): Promise<BrokerPersonResponse[]> {
        let url_ = this.baseUrl + "/api/partner/broker/delegates/from";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBrokerDelegatesFrom(_response);
        });
    }

    protected processGetBrokerDelegatesFrom(response: Response): Promise<BrokerPersonResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerPersonResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerPersonResponse[]>(null as any);
    }

    getBrokerCompanyCode(): Promise<string> {
        let url_ = this.baseUrl + "/api/partner/broker/company/code";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBrokerCompanyCode(_response);
        });
    }

    protected processGetBrokerCompanyCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getBrokerDelegatesByBroker(): Promise<BrokerPersonResponse[]> {
        let url_ = this.baseUrl + "/api/partner/broker/delegates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBrokerDelegatesByBroker(_response);
        });
    }

    protected processGetBrokerDelegatesByBroker(response: Response): Promise<BrokerPersonResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerPersonResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerPersonResponse[]>(null as any);
    }

    addMislifeOrder(request: MisLifeVersionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/broker/mislifeorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMislifeOrder(_response);
        });
    }

    protected processAddMislifeOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMislifeOrders(): Promise<MislifeOrder[]> {
        let url_ = this.baseUrl + "/api/partner/broker/mislifeorder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMislifeOrders(_response);
        });
    }

    protected processGetMislifeOrders(response: Response): Promise<MislifeOrder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MislifeOrder[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MislifeOrder[]>(null as any);
    }

    getMislifeFileById(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/broker/mislifeorder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMislifeFileById(_response);
        });
    }

    protected processGetMislifeFileById(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBrokerRegionalContactInfo(): Promise<BrokerRegionContactResponse> {
        let url_ = this.baseUrl + "/api/partner/broker/regioncontact";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBrokerRegionalContactInfo(_response);
        });
    }

    protected processGetBrokerRegionalContactInfo(response: Response): Promise<BrokerRegionContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrokerRegionContactResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerRegionContactResponse>(null as any);
    }

    getOfferBrokerPlans(): Promise<OfferPlanResponse[]> {
        let url_ = this.baseUrl + "/api/partner/broker/offerbrokerplans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOfferBrokerPlans(_response);
        });
    }

    protected processGetOfferBrokerPlans(response: Response): Promise<OfferPlanResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OfferPlanResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfferPlanResponse[]>(null as any);
    }

    createOffer(request: CreateOfferRequest): Promise<CreateOfferResponse> {
        let url_ = this.baseUrl + "/api/partner/broker/offer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOffer(_response);
        });
    }

    protected processCreateOffer(response: Response): Promise<CreateOfferResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOfferResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOfferResponse>(null as any);
    }
}

export class PartnerCaseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    partnerCases(statuses: CaseStatus[] | null | undefined, skip: number | undefined, take: number | undefined): Promise<Case[]> {
        let url_ = this.baseUrl + "/api/partner/case/partners?";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPartnerCases(_response);
        });
    }

    protected processPartnerCases(response: Response): Promise<Case[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Case[]>(null as any);
    }
}

export class PartnerCommissionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getCommissionReport(fileFormat: FormatType, fromDate: string | null | undefined, toDate: string | null | undefined, payed: boolean | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/commission/file/{fileFormat}?";
        if (fileFormat === undefined || fileFormat === null)
            throw new Error("The parameter 'fileFormat' must be defined.");
        url_ = url_.replace("{fileFormat}", encodeURIComponent("" + fileFormat));
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (payed !== undefined && payed !== null)
            url_ += "payed=" + encodeURIComponent("" + payed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommissionReport(_response);
        });
    }

    protected processGetCommissionReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFileForPaymentId(fileFormat: FormatType, paymentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/commission/{paymentId}/file/{fileFormat}";
        if (fileFormat === undefined || fileFormat === null)
            throw new Error("The parameter 'fileFormat' must be defined.");
        url_ = url_.replace("{fileFormat}", encodeURIComponent("" + fileFormat));
        if (paymentId === undefined || paymentId === null)
            throw new Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileForPaymentId(_response);
        });
    }

    protected processGetFileForPaymentId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPdfFileForPaymentId(paymentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/commission/{paymentId}/file/pdf";
        if (paymentId === undefined || paymentId === null)
            throw new Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPdfFileForPaymentId(_response);
        });
    }

    protected processGetPdfFileForPaymentId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getOutPaymentDetails(fromDate: string | null | undefined, toDate: string | null | undefined): Promise<OutPaymentDetail[]> {
        let url_ = this.baseUrl + "/api/partner/commission/outpayments?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutPaymentDetails(_response);
        });
    }

    protected processGetOutPaymentDetails(response: Response): Promise<OutPaymentDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutPaymentDetail[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutPaymentDetail[]>(null as any);
    }
}

export class PartnerContractClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getAllowedAccessByContractId(contractId: number): Promise<AccessRights> {
        let url_ = this.baseUrl + "/api/partner/contract/{contractId}/access";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedAccessByContractId(_response);
        });
    }

    protected processGetAllowedAccessByContractId(response: Response): Promise<AccessRights> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRights;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRights>(null as any);
    }

    getContractsByPersonId(personId: number, agreementsOnly: boolean | undefined): Promise<ContractContainerResponse> {
        let url_ = this.baseUrl + "/api/partner/contract/person/{personId}?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (agreementsOnly === null)
            throw new Error("The parameter 'agreementsOnly' cannot be null.");
        else if (agreementsOnly !== undefined)
            url_ += "agreementsOnly=" + encodeURIComponent("" + agreementsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContractsByPersonId(_response);
        });
    }

    protected processGetContractsByPersonId(response: Response): Promise<ContractContainerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractContainerResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractContainerResponse>(null as any);
    }
}

export class PartnerDigitalLifeInsuranceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    initiateLifeInsurance(lifeInsuranceStory: InitiateLifeInsuranceStoryCommand): Promise<CreateLifeInsuranceStoryResult> {
        let url_ = this.baseUrl + "/api/partner/digitallife";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lifeInsuranceStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateLifeInsurance(_response);
        });
    }

    protected processInitiateLifeInsurance(response: Response): Promise<CreateLifeInsuranceStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLifeInsuranceStoryResult>(null as any);
    }

    getPrices(priceRequest: DigitalLifePriceRequest): Promise<DigitalLifePrice[]> {
        let url_ = this.baseUrl + "/api/partner/digitallife/prices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priceRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrices(_response);
        });
    }

    protected processGetPrices(response: Response): Promise<DigitalLifePrice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DigitalLifePrice[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DigitalLifePrice[]>(null as any);
    }
}

export class PartnerDocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getDocumentsByEnvelope(envelopeId: number): Promise<DocumentResponse[]> {
        let url_ = this.baseUrl + "/api/partner/document/envelopes/{envelopeId}";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentsByEnvelope(_response);
        });
    }

    protected processGetDocumentsByEnvelope(response: Response): Promise<DocumentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentResponse[]>(null as any);
    }

    getDocumentFile(externalId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/document/{externalId}/file";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentFile(_response);
        });
    }

    protected processGetDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDocuments(request: PartnerDocumentSearchRequest): Promise<PartnerDocumentResponse[]> {
        let url_ = this.baseUrl + "/api/partner/document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<PartnerDocumentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerDocumentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerDocumentResponse[]>(null as any);
    }

    getDocumentTypes(): Promise<PartnerDocumentTypeResponse[]> {
        let url_ = this.baseUrl + "/api/partner/document/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentTypes(_response);
        });
    }

    protected processGetDocumentTypes(response: Response): Promise<PartnerDocumentTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PartnerDocumentTypeResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerDocumentTypeResponse[]>(null as any);
    }

    getCompanyInvoices(legalPersonId: number, skip: number | undefined, take: number | undefined): Promise<GroupedByYearInvoicesResponse[]> {
        let url_ = this.baseUrl + "/api/partner/document/company/{legalPersonId}/invoices?";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyInvoices(_response);
        });
    }

    protected processGetCompanyInvoices(response: Response): Promise<GroupedByYearInvoicesResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupedByYearInvoicesResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupedByYearInvoicesResponse[]>(null as any);
    }

    getCompanyInvoiceFile(documentId: number, legalPersonId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/document/{documentId}/company/{legalPersonId}/file";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyInvoiceFile(_response);
        });
    }

    protected processGetCompanyInvoiceFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFormDocuments(): Promise<QuickDocumentSearchResponse> {
        let url_ = this.baseUrl + "/api/partner/document/forms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormDocuments(_response);
        });
    }

    protected processGetFormDocuments(response: Response): Promise<QuickDocumentSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuickDocumentSearchResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuickDocumentSearchResponse>(null as any);
    }
}

export class PartnerEmploymentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    updateSalaries(salaries: EmploymentTerm[]): Promise<SalaryPlanStoryResult> {
        let url_ = this.baseUrl + "/api/partner/employment/salaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(salaries);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSalaries(_response);
        });
    }

    protected processUpdateSalaries(response: Response): Promise<SalaryPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalaryPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalaryPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalaryPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryPlanStoryResult>(null as any);
    }

    updatePremiums(premiums: EmploymentAdjustment[]): Promise<PremiumPlanStoryResult> {
        let url_ = this.baseUrl + "/api/partner/employment/premiums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(premiums);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePremiums(_response);
        });
    }

    protected processUpdatePremiums(response: Response): Promise<PremiumPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiumPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiumPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiumPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PremiumPlanStoryResult>(null as any);
    }

    endEmployments(employments: EmploymentEnd[]): Promise<EmploymentEndStoryResult> {
        let url_ = this.baseUrl + "/api/partner/employment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employments);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEndEmployments(_response);
        });
    }

    protected processEndEmployments(response: Response): Promise<EmploymentEndStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentEndStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentEndStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentEndStoryResult>(null as any);
    }

    addEmployments(employments: EmploymentAdd[]): Promise<EmploymentAddStoryResult> {
        let url_ = this.baseUrl + "/api/partner/employment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employments);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEmployments(_response);
        });
    }

    protected processAddEmployments(response: Response): Promise<EmploymentAddStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentAddStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentAddStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentAddStoryResult>(null as any);
    }

    getEmploymentsByPrivatePersonId(privatePersonId: number): Promise<EmploymentResponse[]> {
        let url_ = this.baseUrl + "/api/partner/employment/privateperson/{privatePersonId}";
        if (privatePersonId === undefined || privatePersonId === null)
            throw new Error("The parameter 'privatePersonId' must be defined.");
        url_ = url_.replace("{privatePersonId}", encodeURIComponent("" + privatePersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmploymentsByPrivatePersonId(_response);
        });
    }

    protected processGetEmploymentsByPrivatePersonId(response: Response): Promise<EmploymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentResponse[]>(null as any);
    }

    getEmploymentsByLegalPersonId(legalPersonId: number, employmentStatus: EmploymentStatus, skip: number): Promise<EmploymentResponse[]> {
        let url_ = this.baseUrl + "/api/partner/employment/legalperson/{legalPersonId}/{employmentStatus}/{skip}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (employmentStatus === undefined || employmentStatus === null)
            throw new Error("The parameter 'employmentStatus' must be defined.");
        url_ = url_.replace("{employmentStatus}", encodeURIComponent("" + employmentStatus));
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined.");
        url_ = url_.replace("{skip}", encodeURIComponent("" + skip));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmploymentsByLegalPersonId(_response);
        });
    }

    protected processGetEmploymentsByLegalPersonId(response: Response): Promise<EmploymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentResponse[]>(null as any);
    }

    getEmploymentByContractId(incaContractId: number): Promise<EmploymentResponse> {
        let url_ = this.baseUrl + "/api/partner/employment/contract/{incaContractId}";
        if (incaContractId === undefined || incaContractId === null)
            throw new Error("The parameter 'incaContractId' must be defined.");
        url_ = url_.replace("{incaContractId}", encodeURIComponent("" + incaContractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmploymentByContractId(_response);
        });
    }

    protected processGetEmploymentByContractId(response: Response): Promise<EmploymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentResponse>(null as any);
    }
}

export class PartnerFundChangeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    changeFunds(arcaInsuranceId: number, model: FundChange): Promise<FundChangeStoryResult> {
        let url_ = this.baseUrl + "/api/partner/fundchange/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeFunds(_response);
        });
    }

    protected processChangeFunds(response: Response): Promise<FundChangeStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChangeStoryResult>(null as any);
    }

    getWaitForSignFundChanges(personId: number, arcaInsuranceId: number, insuranceOfficialId: string): Promise<Envelope[]> {
        let url_ = this.baseUrl + "/api/partner/fundchange/waitingforsignstories/{personId}/{arcaInsuranceId}/{insuranceOfficialId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (insuranceOfficialId === undefined || insuranceOfficialId === null)
            throw new Error("The parameter 'insuranceOfficialId' must be defined.");
        url_ = url_.replace("{insuranceOfficialId}", encodeURIComponent("" + insuranceOfficialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWaitForSignFundChanges(_response);
        });
    }

    protected processGetWaitForSignFundChanges(response: Response): Promise<Envelope[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope[];
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope[];
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope[]>(null as any);
    }

    getFundChangeByArcaInsuranceId(arcaInsuranceId: number): Promise<FundChange> {
        let url_ = this.baseUrl + "/api/partner/fundchange/broker/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundChangeByArcaInsuranceId(_response);
        });
    }

    protected processGetFundChangeByArcaInsuranceId(response: Response): Promise<FundChange> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChange;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChange>(null as any);
    }
}

export class PartnerFundClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getFundsByBroker(): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/partner/fund/broker";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundsByBroker(_response);
        });
    }

    protected processGetFundsByBroker(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getFundsByBrokerAndProduct(productId: number | undefined, businessAgreementId: number | undefined): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/partner/fund/brokerandproduct?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (businessAgreementId === null)
            throw new Error("The parameter 'businessAgreementId' cannot be null.");
        else if (businessAgreementId !== undefined)
            url_ += "businessAgreementId=" + encodeURIComponent("" + businessAgreementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundsByBrokerAndProduct(_response);
        });
    }

    protected processGetFundsByBrokerAndProduct(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getFundsByInsurance(arcaInsuranceId: number): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/partner/fund/insurance/{arcaInsuranceId}/funds";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundsByInsurance(_response);
        });
    }

    protected processGetFundsByInsurance(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }

    getFundNames(valueHolderIds: number[]): Promise<ValueHolderAllocation[]> {
        let url_ = this.baseUrl + "/api/partner/fund/funds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(valueHolderIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundNames(_response);
        });
    }

    protected processGetFundNames(response: Response): Promise<ValueHolderAllocation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValueHolderAllocation[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueHolderAllocation[]>(null as any);
    }

    generateFundList(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/fund/funds/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateFundList(_response);
        });
    }

    protected processGenerateFundList(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    csvByBroker(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/partner/fund/broker/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCsvByBroker(_response);
        });
    }

    protected processCsvByBroker(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PartnerInPaymentAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createExtraPremiumInvoice(data: FullPremiumInvoice): Promise<ExtraPremiumPlanStoryResult> {
        let url_ = this.baseUrl + "/api/partner/inpaymentagreement/extrapremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateExtraPremiumInvoice(_response);
        });
    }

    protected processCreateExtraPremiumInvoice(response: Response): Promise<ExtraPremiumPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtraPremiumPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtraPremiumPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtraPremiumPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraPremiumPlanStoryResult>(null as any);
    }
}

export class PartnerInsuranceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getInsurancesByPersonId(privatePersonId: number): Promise<InsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/person/{privatePersonId}";
        if (privatePersonId === undefined || privatePersonId === null)
            throw new Error("The parameter 'privatePersonId' must be defined.");
        url_ = url_.replace("{privatePersonId}", encodeURIComponent("" + privatePersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesByPersonId(_response);
        });
    }

    protected processGetInsurancesByPersonId(response: Response): Promise<InsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse[]>(null as any);
    }

    getInsurancesByAgreementId(arcaAgreementId: number, withRiskAssessment: boolean | undefined): Promise<InsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/agreement/{arcaAgreementId}?";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        if (withRiskAssessment === null)
            throw new Error("The parameter 'withRiskAssessment' cannot be null.");
        else if (withRiskAssessment !== undefined)
            url_ += "withRiskAssessment=" + encodeURIComponent("" + withRiskAssessment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesByAgreementId(_response);
        });
    }

    protected processGetInsurancesByAgreementId(response: Response): Promise<InsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse[]>(null as any);
    }

    getInsurancesForBroker(filter: string, skip: number, take: number): Promise<InsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/filter/{filter}/{skip}/{take}";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined.");
        url_ = url_.replace("{filter}", encodeURIComponent("" + filter));
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined.");
        url_ = url_.replace("{skip}", encodeURIComponent("" + skip));
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined.");
        url_ = url_.replace("{take}", encodeURIComponent("" + take));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesForBroker(_response);
        });
    }

    protected processGetInsurancesForBroker(response: Response): Promise<InsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse[]>(null as any);
    }

    getInsuranceByArcaId(arcaInsuranceId: number): Promise<InsuranceResponse> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceByArcaId(_response);
        });
    }

    protected processGetInsuranceByArcaId(response: Response): Promise<InsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse>(null as any);
    }

    getInsuranceMovingAmountByArcaId(arcaInsuranceId: number): Promise<InsuranceAmountResponse> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/movingamount";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceMovingAmountByArcaId(_response);
        });
    }

    protected processGetInsuranceMovingAmountByArcaId(response: Response): Promise<InsuranceAmountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceAmountResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceAmountResponse>(null as any);
    }

    getInsuranceCollapsibleDetailsByArcaId(arcaInsuranceId: number): Promise<InsuranceResponse> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/details";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceCollapsibleDetailsByArcaId(_response);
        });
    }

    protected processGetInsuranceCollapsibleDetailsByArcaId(response: Response): Promise<InsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse>(null as any);
    }

    getInsuranceTransactionsByArcaId(arcaInsuranceId: number, take: number, skip: number): Promise<InsuranceTransaction[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/transactions/{take}/{skip}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (take === undefined || take === null)
            throw new Error("The parameter 'take' must be defined.");
        url_ = url_.replace("{take}", encodeURIComponent("" + take));
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined.");
        url_ = url_.replace("{skip}", encodeURIComponent("" + skip));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceTransactionsByArcaId(_response);
        });
    }

    protected processGetInsuranceTransactionsByArcaId(response: Response): Promise<InsuranceTransaction[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceTransaction[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceTransaction[]>(null as any);
    }

    getInsuranceBenefits(arcaInsuranceId: number): Promise<BenefitResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/benefits";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceBenefits(_response);
        });
    }

    protected processGetInsuranceBenefits(response: Response): Promise<BenefitResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BenefitResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BenefitResponse[]>(null as any);
    }

    getInsurancePremiumPrices(arcaInsuranceId: number): Promise<InsurancePremiumResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/premiumprices";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancePremiumPrices(_response);
        });
    }

    protected processGetInsurancePremiumPrices(response: Response): Promise<InsurancePremiumResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsurancePremiumResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsurancePremiumResponse[]>(null as any);
    }

    getInsuranceGraphValues(arcaInsuranceId: number): Promise<ContractValueResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/graphvalues";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceGraphValues(_response);
        });
    }

    protected processGetInsuranceGraphValues(response: Response): Promise<ContractValueResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractValueResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractValueResponse[]>(null as any);
    }

    endPremium(arcaInsuranceId: number, endDate: string): Promise<GenericStoryResult> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/endpremium/{endDate}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEndPremium(_response);
        });
    }

    protected processEndPremium(response: Response): Promise<GenericStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenericStoryResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenericStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericStoryResult>(null as any);
    }

    changePremium(arcaInsuranceId: number, fromDate: string, contractPrice: number, fullyWorking: boolean | undefined): Promise<GenericStoryResult> {
        let url_ = this.baseUrl + "/api/partner/insurance/{arcaInsuranceId}/changepremium/{fromDate}/{contractPrice}?";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent("" + fromDate));
        if (contractPrice === undefined || contractPrice === null)
            throw new Error("The parameter 'contractPrice' must be defined.");
        url_ = url_.replace("{contractPrice}", encodeURIComponent("" + contractPrice));
        if (fullyWorking === null)
            throw new Error("The parameter 'fullyWorking' cannot be null.");
        else if (fullyWorking !== undefined)
            url_ += "fullyWorking=" + encodeURIComponent("" + fullyWorking) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePremium(_response);
        });
    }

    protected processChangePremium(response: Response): Promise<GenericStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenericStoryResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenericStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenericStoryResult>(null as any);
    }

    getRiskAssessmentsByIds(arcaAgreementId: number, riskAssessmentRequest: RiskAssessmentRequest): Promise<RiskAssessmentResponse[]> {
        let url_ = this.baseUrl + "/api/partner/insurance/riskassessments/{arcaAgreementId}";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(riskAssessmentRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRiskAssessmentsByIds(_response);
        });
    }

    protected processGetRiskAssessmentsByIds(response: Response): Promise<RiskAssessmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiskAssessmentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskAssessmentResponse[]>(null as any);
    }
}

export class PartnerMoveInClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    get(personId: number | null | undefined): Promise<MoveInModelResponse> {
        let url_ = this.baseUrl + "/api/partner/movein?";
        if (personId !== undefined && personId !== null)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MoveInModelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MoveInModelResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MoveInModelResponse>(null as any);
    }

    createMoveIn(personOfficialId: string | null | undefined, brokerCode: string | null | undefined, fullName: string | null | undefined, mobilePhone: string | null | undefined, emailAdress: string | null | undefined, details: MoveInDetailsRequest[] | null | undefined, files: FileParameter[] | null | undefined, assistant: string | null | undefined): Promise<CreateMoveInStoryResponse> {
        let url_ = this.baseUrl + "/api/partner/movein";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (personOfficialId !== null && personOfficialId !== undefined)
            content_.append("PersonOfficialId", personOfficialId.toString());
        if (brokerCode !== null && brokerCode !== undefined)
            content_.append("BrokerCode", brokerCode.toString());
        if (fullName !== null && fullName !== undefined)
            content_.append("FullName", fullName.toString());
        if (mobilePhone !== null && mobilePhone !== undefined)
            content_.append("MobilePhone", mobilePhone.toString());
        if (emailAdress !== null && emailAdress !== undefined)
            content_.append("EmailAdress", emailAdress.toString());
        if (details !== null && details !== undefined)
            details.forEach(item_ => content_.append("Details", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (assistant !== null && assistant !== undefined)
            content_.append("Assistant", assistant.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMoveIn(_response);
        });
    }

    protected processCreateMoveIn(response: Response): Promise<CreateMoveInStoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateMoveInStoryResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateMoveInStoryResponse>(null as any);
    }

    getDownloadFiles(envelopeid: number): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/movein/envelope/{envelopeid}";
        if (envelopeid === undefined || envelopeid === null)
            throw new Error("The parameter 'envelopeid' must be defined.");
        url_ = url_.replace("{envelopeid}", encodeURIComponent("" + envelopeid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDownloadFiles(_response);
        });
    }

    protected processGetDownloadFiles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PartnerNewAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getBusinessAgreementGroups(brokerCode: string | null | undefined): Promise<BusinessAgreementGroupResponse[]> {
        let url_ = this.baseUrl + "/api/partner/newagreement/businessagreementgroups?";
        if (brokerCode !== undefined && brokerCode !== null)
            url_ += "brokerCode=" + encodeURIComponent("" + brokerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBusinessAgreementGroups(_response);
        });
    }

    protected processGetBusinessAgreementGroups(response: Response): Promise<BusinessAgreementGroupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessAgreementGroupResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessAgreementGroupResponse[]>(null as any);
    }

    getBusinessAgreementByArcaAgreementId(arcaAgreementId: number): Promise<BusinessAgreementResponse> {
        let url_ = this.baseUrl + "/api/partner/newagreement/businessagreement/{arcaAgreementId}";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBusinessAgreementByArcaAgreementId(_response);
        });
    }

    protected processGetBusinessAgreementByArcaAgreementId(response: Response): Promise<BusinessAgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessAgreementResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessAgreementResponse>(null as any);
    }

    createAgreement(pensionPlan: CreatePensionPlanStory): Promise<CreatePensionPlanStoryResult> {
        let url_ = this.baseUrl + "/api/partner/newagreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pensionPlan);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAgreement(_response);
        });
    }

    protected processCreateAgreement(response: Response): Promise<CreatePensionPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePensionPlanStoryResult>(null as any);
    }

    createPensionPlanGroups(pensionPlanGroupStorys: CreatePensionPlanGroupStory[]): Promise<CreatePensionPlanStoryResult> {
        let url_ = this.baseUrl + "/api/partner/newagreement/ppg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pensionPlanGroupStorys);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePensionPlanGroups(_response);
        });
    }

    protected processCreatePensionPlanGroups(response: Response): Promise<CreatePensionPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePensionPlanStoryResult>(null as any);
    }

    createIndividualInsurance(insuranceStory: CreateFreestandingWithAmlRequest): Promise<CreateIndividualInsuranceStoryResult> {
        let url_ = this.baseUrl + "/api/partner/newagreement/individualinsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateIndividualInsurance(_response);
        });
    }

    protected processCreateIndividualInsurance(response: Response): Promise<CreateIndividualInsuranceStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateIndividualInsuranceStoryResult>(null as any);
    }

    getCompanyByOfficialId(officialId: string): Promise<Company> {
        let url_ = this.baseUrl + "/api/partner/newagreement/company/{officialId}";
        if (officialId === undefined || officialId === null)
            throw new Error("The parameter 'officialId' must be defined.");
        url_ = url_.replace("{officialId}", encodeURIComponent("" + officialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyByOfficialId(_response);
        });
    }

    protected processGetCompanyByOfficialId(response: Response): Promise<Company> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Company;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company>(null as any);
    }

    getControllingPersons(officialId: string): Promise<ControllingPerson[]> {
        let url_ = this.baseUrl + "/api/partner/newagreement/controllingpersons/{officialId}";
        if (officialId === undefined || officialId === null)
            throw new Error("The parameter 'officialId' must be defined.");
        url_ = url_.replace("{officialId}", encodeURIComponent("" + officialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetControllingPersons(_response);
        });
    }

    protected processGetControllingPersons(response: Response): Promise<ControllingPerson[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ControllingPerson[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControllingPerson[]>(null as any);
    }
}

export class PartnerOutpaymentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createOutPaymentProposal(data: CreateOutPaymentProposalStoryCommand): Promise<CreateOutPaymentStoryResult> {
        let url_ = this.baseUrl + "/api/partner/outpayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOutPaymentProposal(_response);
        });
    }

    protected processCreateOutPaymentProposal(response: Response): Promise<CreateOutPaymentStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOutPaymentStoryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOutPaymentStoryResult>(null as any);
    }

    getOutpaymentAccountDetails(arcaInsuranceId: number): Promise<OutpaymentAccountAndClearing> {
        let url_ = this.baseUrl + "/api/partner/outpayment/{arcaInsuranceId}/accountdetails";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutpaymentAccountDetails(_response);
        });
    }

    protected processGetOutpaymentAccountDetails(response: Response): Promise<OutpaymentAccountAndClearing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutpaymentAccountAndClearing;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutpaymentAccountAndClearing>(null as any);
    }

    getOutpaymentInsuranceByArcaIdForBroker(arcaInsuranceId: number): Promise<OutpaymentInsuranceResponse> {
        let url_ = this.baseUrl + "/api/partner/outpayment/insurance/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutpaymentInsuranceByArcaIdForBroker(_response);
        });
    }

    protected processGetOutpaymentInsuranceByArcaIdForBroker(response: Response): Promise<OutpaymentInsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutpaymentInsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutpaymentInsuranceResponse>(null as any);
    }
}

export class PartnerPensionPlanClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getPensionPlanGroups(arcaAgreementId: number): Promise<PensionPlanGroupResponse[]> {
        let url_ = this.baseUrl + "/api/partner/pensionplan/{arcaAgreementId}/groups";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPensionPlanGroups(_response);
        });
    }

    protected processGetPensionPlanGroups(response: Response): Promise<PensionPlanGroupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PensionPlanGroupResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PensionPlanGroupResponse[]>(null as any);
    }

    getPensionPlanGroupsByIncagateInsuranceId(incaContractId: number): Promise<PensionPlanGroupResponse[]> {
        let url_ = this.baseUrl + "/api/partner/pensionplan/insurance/{incaContractId}/groups";
        if (incaContractId === undefined || incaContractId === null)
            throw new Error("The parameter 'incaContractId' must be defined.");
        url_ = url_.replace("{incaContractId}", encodeURIComponent("" + incaContractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPensionPlanGroupsByIncagateInsuranceId(_response);
        });
    }

    protected processGetPensionPlanGroupsByIncagateInsuranceId(response: Response): Promise<PensionPlanGroupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PensionPlanGroupResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PensionPlanGroupResponse[]>(null as any);
    }
}

export class PartnerPersonClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getPrivatePersonByOfficialId(id: string): Promise<PersonLightResponse> {
        let url_ = this.baseUrl + "/api/partner/person/search/private";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivatePersonByOfficialId(_response);
        });
    }

    protected processGetPrivatePersonByOfficialId(response: Response): Promise<PersonLightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonLightResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonLightResponse>(null as any);
    }

    getOrAddPersonByOfficialId(id: string): Promise<PersonLightResponse> {
        let url_ = this.baseUrl + "/api/partner/person/get/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrAddPersonByOfficialId(_response);
        });
    }

    protected processGetOrAddPersonByOfficialId(response: Response): Promise<PersonLightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonLightResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonLightResponse>(null as any);
    }

    getPrivatePersonById(privatePersonId: number): Promise<PersonResponse> {
        let url_ = this.baseUrl + "/api/partner/person/private/{privatePersonId}";
        if (privatePersonId === undefined || privatePersonId === null)
            throw new Error("The parameter 'privatePersonId' must be defined.");
        url_ = url_.replace("{privatePersonId}", encodeURIComponent("" + privatePersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivatePersonById(_response);
        });
    }

    protected processGetPrivatePersonById(response: Response): Promise<PersonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonResponse>(null as any);
    }

    getLegalPersonById(legalPersonId: number): Promise<PersonResponse> {
        let url_ = this.baseUrl + "/api/partner/person/legal/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalPersonById(_response);
        });
    }

    protected processGetLegalPersonById(response: Response): Promise<PersonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonResponse>(null as any);
    }

    getAccessRights(personId: number): Promise<AccessRights> {
        let url_ = this.baseUrl + "/api/partner/person/{personId}/access";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessRights(_response);
        });
    }

    protected processGetAccessRights(response: Response): Promise<AccessRights> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRights;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRights>(null as any);
    }

    addPersonFromSpar(personOfficialId: string): Promise<PrivatePersonSparStoryResult> {
        let url_ = this.baseUrl + "/api/partner/person/private";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personOfficialId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPersonFromSpar(_response);
        });
    }

    protected processAddPersonFromSpar(response: Response): Promise<PrivatePersonSparStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivatePersonSparStoryResult;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivatePersonSparStoryResult>(null as any);
    }

    getLatestTaxBasis(arcaInsuranceId: number): Promise<number | null> {
        let url_ = this.baseUrl + "/api/partner/person/insurance/{arcaInsuranceId}/taxbasis";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestTaxBasis(_response);
        });
    }

    protected processGetLatestTaxBasis(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }
}

export class PartnerSearchClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    searchByFilter(filter: string | null | undefined, includes: AdminSearchType[] | null | undefined, take: number | null | undefined): Promise<SearchResultResponse> {
        let url_ = this.baseUrl + "/api/partner/search?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (includes !== undefined && includes !== null)
            includes && includes.forEach(item => { url_ += "Includes=" + encodeURIComponent("" + item) + "&"; });
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchByFilter(_response);
        });
    }

    protected processSearchByFilter(response: Response): Promise<SearchResultResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchResultResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultResponse>(null as any);
    }

    searchPersons(request: AdminPersonSearchRequest): Promise<PersonSearchResponse[]> {
        let url_ = this.baseUrl + "/api/partner/search/persons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPersons(_response);
        });
    }

    protected processSearchPersons(response: Response): Promise<PersonSearchResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSearchResponse[]>(null as any);
    }
}

export class PartnerStoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createTransferInformationOrder(code: string | null | undefined, insuranceOfficialId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/partner/story/transferinformationorder?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (insuranceOfficialId !== undefined && insuranceOfficialId !== null)
            url_ += "insuranceOfficialId=" + encodeURIComponent("" + insuranceOfficialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTransferInformationOrder(_response);
        });
    }

    protected processCreateTransferInformationOrder(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    hasUnhandledBrokerStories(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/partner/story/hasunhandledstories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasUnhandledBrokerStories(_response);
        });
    }

    protected processHasUnhandledBrokerStories(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    hidePartnerStory(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/partner/story/{id}/hide";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHidePartnerStory(_response);
        });
    }

    protected processHidePartnerStory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomerAmlClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    customerKnowledge(): Promise<CustomerKnowlegeResponse> {
        let url_ = this.baseUrl + "/api/customer/aml/knowledge";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerKnowledge(_response);
        });
    }

    protected processCustomerKnowledge(response: Response): Promise<CustomerKnowlegeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerKnowlegeResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerKnowlegeResponse>(null as any);
    }

    createAmlPrivatePersonLogin(amlPrivatePersonLoginStory: CreateAmlPrivatePersonLoginStoryCommand): Promise<AmlPrivatePersonLoginStoryResult> {
        let url_ = this.baseUrl + "/api/customer/aml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(amlPrivatePersonLoginStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAmlPrivatePersonLogin(_response);
        });
    }

    protected processCreateAmlPrivatePersonLogin(response: Response): Promise<AmlPrivatePersonLoginStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AmlPrivatePersonLoginStoryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmlPrivatePersonLoginStoryResult>(null as any);
    }
}

export class CustomerBannerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getUserBanners(): Promise<CustomBannerResponse[]> {
        let url_ = this.baseUrl + "/api/customer/banner";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserBanners(_response);
        });
    }

    protected processGetUserBanners(response: Response): Promise<CustomBannerResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomBannerResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomBannerResponse[]>(null as any);
    }
}

export class CustomerCaseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    customerCases(statuses: CaseStatus[] | null | undefined, skip: number | undefined, take: number | undefined): Promise<Case[]> {
        let url_ = this.baseUrl + "/api/customer/case?";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerCases(_response);
        });
    }

    protected processCustomerCases(response: Response): Promise<Case[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Case[]>(null as any);
    }

    customerMessages(skip: number | null | undefined, take: number | null | undefined): Promise<Case[]> {
        let url_ = this.baseUrl + "/api/customer/case/messages?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerMessages(_response);
        });
    }

    protected processCustomerMessages(response: Response): Promise<Case[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Case[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Case[]>(null as any);
    }

    customerHasUnhandledCases(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/case/unhandledcases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerHasUnhandledCases(_response);
        });
    }

    protected processCustomerHasUnhandledCases(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    customerHasUnhandledActions(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/case/unhandledactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerHasUnhandledActions(_response);
        });
    }

    protected processCustomerHasUnhandledActions(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CustomerClaimClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createAccidentClaim(data: WizardItem[] | null | undefined, files: any[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/claim/accident";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            data.forEach(item_ => content_.append("data", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAccidentClaim(_response);
        });
    }

    protected processCreateAccidentClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createAccidentChildClaim(data: WizardItem[] | null | undefined, files: any[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/claim/accident/child";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            data.forEach(item_ => content_.append("data", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAccidentChildClaim(_response);
        });
    }

    protected processCreateAccidentChildClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDisabledClaim(data: WizardItem[] | null | undefined, files: any[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/claim/disabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            data.forEach(item_ => content_.append("data", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDisabledClaim(_response);
        });
    }

    protected processCreateDisabledClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDisabledChildClaim(data: WizardItem[] | null | undefined, files: any[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/claim/disabled/child";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            data.forEach(item_ => content_.append("data", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDisabledChildClaim(_response);
        });
    }

    protected processCreateDisabledChildClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDeathClaim(data: WizardItem[] | null | undefined, files: any[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/claim/death";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            data.forEach(item_ => content_.append("data", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDeathClaim(_response);
        });
    }

    protected processCreateDeathClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createSickleaveClaim(data: WizardItem[] | null | undefined, files: any[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/claim/sickleave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data !== null && data !== undefined)
            data.forEach(item_ => content_.append("data", item_.toString()));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files[]", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSickleaveClaim(_response);
        });
    }

    protected processCreateSickleaveClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomerContractClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getAllowedAccessByContractId(contractId: number): Promise<AccessRights> {
        let url_ = this.baseUrl + "/api/customer/contract/{contractId}/access";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedAccessByContractId(_response);
        });
    }

    protected processGetAllowedAccessByContractId(response: Response): Promise<AccessRights> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRights;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRights>(null as any);
    }
}

export class CustomerDigitalLifeInsuranceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createNewLifeInsurance(lifeInsuranceStory: CreateLifeInsuranceStoryCommand): Promise<CreateLifeInsuranceStoryResult> {
        let url_ = this.baseUrl + "/api/customer/digitallife";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lifeInsuranceStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewLifeInsurance(_response);
        });
    }

    protected processCreateNewLifeInsurance(response: Response): Promise<CreateLifeInsuranceStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLifeInsuranceStoryResult>(null as any);
    }

    getLifeInsuranceStoryResult(request: DigitalLifeRequest): Promise<CreateLifeInsuranceStoryResult> {
        let url_ = this.baseUrl + "/api/customer/digitallife/envelope";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLifeInsuranceStoryResult(_response);
        });
    }

    protected processGetLifeInsuranceStoryResult(response: Response): Promise<CreateLifeInsuranceStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLifeInsuranceStoryResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLifeInsuranceStoryResult>(null as any);
    }

    getPrices(priceRequest: DigitalLifePriceRequest): Promise<DigitalLifePrice[]> {
        let url_ = this.baseUrl + "/api/customer/digitallife/prices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priceRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrices(_response);
        });
    }

    protected processGetPrices(response: Response): Promise<DigitalLifePrice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DigitalLifePrice[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DigitalLifePrice[]>(null as any);
    }
}

export class CustomerDiscussionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getDiscussionsByOfficialId(skip: number | undefined, take: number | undefined): Promise<DiscussionResponse[]> {
        let url_ = this.baseUrl + "/api/customer/discussion?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiscussionsByOfficialId(_response);
        });
    }

    protected processGetDiscussionsByOfficialId(response: Response): Promise<DiscussionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiscussionResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionResponse[]>(null as any);
    }

    createDiscussion(title: string | null | undefined, body: string | null | undefined, type: string | null | undefined, selectedInsurance: string | null | undefined, files: FileParameter[] | null | undefined, envelopeId: string | null | undefined, documentId: string | null | undefined, category: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/customer/discussion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (body !== null && body !== undefined)
            content_.append("Body", body.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (selectedInsurance !== null && selectedInsurance !== undefined)
            content_.append("SelectedInsurance", selectedInsurance.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (envelopeId !== null && envelopeId !== undefined)
            content_.append("EnvelopeId", envelopeId.toString());
        if (documentId !== null && documentId !== undefined)
            content_.append("DocumentId", documentId.toString());
        if (category !== null && category !== undefined)
            content_.append("Category", category.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDiscussion(_response);
        });
    }

    protected processCreateDiscussion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDiscussionByExternalId(externalId: string): Promise<DiscussionMessageResponse> {
        let url_ = this.baseUrl + "/api/customer/discussion/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiscussionByExternalId(_response);
        });
    }

    protected processGetDiscussionByExternalId(response: Response): Promise<DiscussionMessageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiscussionMessageResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionMessageResponse>(null as any);
    }

    createDiscussionMessage(discussionId: string | null | undefined, body: string | null | undefined, files: FileParameter[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/discussion/messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (discussionId !== null && discussionId !== undefined)
            content_.append("DiscussionId", discussionId.toString());
        if (body !== null && body !== undefined)
            content_.append("Body", body.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDiscussionMessage(_response);
        });
    }

    protected processCreateDiscussionMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hideDiscussion(discussionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/discussion/{discussionId}/hide";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHideDiscussion(_response);
        });
    }

    protected processHideDiscussion(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    read(discussionId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/discussion/{discussionId}";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRead(_response);
        });
    }

    protected processRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUnreadCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/customer/discussion/unreadcount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreadCount(_response);
        });
    }

    protected processGetUnreadCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDiscussionByEnvelopeId(envelopeId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/customer/discussion/envelope/{envelopeId}";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiscussionByEnvelopeId(_response);
        });
    }

    protected processGetDiscussionByEnvelopeId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getDiscussionByDocumentId(documentId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/customer/discussion/document/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiscussionByDocumentId(_response);
        });
    }

    protected processGetDiscussionByDocumentId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CustomerDocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getDocumentFile(externalId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/customer/document/{externalId}/file";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentFile(_response);
        });
    }

    protected processGetDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDocuments(request: CustomerDocumentSearchRequest): Promise<CustomerDocumentResponse[]> {
        let url_ = this.baseUrl + "/api/customer/document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<CustomerDocumentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDocumentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDocumentResponse[]>(null as any);
    }

    getDocument(externalId: string): Promise<CustomerDocumentResponse> {
        let url_ = this.baseUrl + "/api/customer/document/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: Response): Promise<CustomerDocumentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerDocumentResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDocumentResponse>(null as any);
    }

    getHasUnreadDocuments(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/document/unread";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHasUnreadDocuments(_response);
        });
    }

    protected processGetHasUnreadDocuments(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CustomerFundChangeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    customerChangeFunds(arcaInsuranceId: number, changeCurrentDistribution: boolean | undefined, holdings: InsuranceHolding[]): Promise<FundChangeStoryResult> {
        let url_ = this.baseUrl + "/api/customer/fundchange/{arcaInsuranceId}?";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (changeCurrentDistribution === null)
            throw new Error("The parameter 'changeCurrentDistribution' cannot be null.");
        else if (changeCurrentDistribution !== undefined)
            url_ += "changeCurrentDistribution=" + encodeURIComponent("" + changeCurrentDistribution) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(holdings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCustomerChangeFunds(_response);
        });
    }

    protected processCustomerChangeFunds(response: Response): Promise<FundChangeStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChangeStoryResult>(null as any);
    }

    getCustomerFundChangeByArcaInsuranceId(arcaInsuranceId: number): Promise<FundChange> {
        let url_ = this.baseUrl + "/api/customer/fundchange/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerFundChangeByArcaInsuranceId(_response);
        });
    }

    protected processGetCustomerFundChangeByArcaInsuranceId(response: Response): Promise<FundChange> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChange;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChange>(null as any);
    }

    getInsuranceFunds(arcaInsuranceId: number): Promise<InsuranceFundResponse[]> {
        let url_ = this.baseUrl + "/api/customer/fundchange/insurance/{arcaInsuranceId}/funds";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceFunds(_response);
        });
    }

    protected processGetInsuranceFunds(response: Response): Promise<InsuranceFundResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceFundResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceFundResponse[]>(null as any);
    }

    getWaitForSignFundChanges(personId: number, arcaInsuranceId: number, insuranceOfficialId: string): Promise<Envelope[]> {
        let url_ = this.baseUrl + "/api/customer/fundchange/waitingforsignstories/{personId}/{arcaInsuranceId}/{insuranceOfficialId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (insuranceOfficialId === undefined || insuranceOfficialId === null)
            throw new Error("The parameter 'insuranceOfficialId' must be defined.");
        url_ = url_.replace("{insuranceOfficialId}", encodeURIComponent("" + insuranceOfficialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWaitForSignFundChanges(_response);
        });
    }

    protected processGetWaitForSignFundChanges(response: Response): Promise<Envelope[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope[];
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope[];
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope[]>(null as any);
    }
}

export class CustomerFundClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getFundsByInsurance(arcaInsuranceId: number): Promise<FundLightResponse[]> {
        let url_ = this.baseUrl + "/api/customer/fund/insurance/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundsByInsurance(_response);
        });
    }

    protected processGetFundsByInsurance(response: Response): Promise<FundLightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundLightResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundLightResponse[]>(null as any);
    }
}

export class CustomerGroupClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createGroupAccident(affiliate: string | null | undefined, groupAccidentData: WizardItem[]): Promise<CreateGroupAccidentStoryResult> {
        let url_ = this.baseUrl + "/api/customer/group/accident?";
        if (affiliate !== undefined && affiliate !== null)
            url_ += "affiliate=" + encodeURIComponent("" + affiliate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupAccidentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroupAccident(_response);
        });
    }

    protected processCreateGroupAccident(response: Response): Promise<CreateGroupAccidentStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateGroupAccidentStoryResult;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGroupAccidentStoryResult>(null as any);
    }

    createGroupDisabledAndAccident(affiliate: string | null | undefined, groupAccidentData: WizardItem[]): Promise<CreateDisabledAccidentResult> {
        let url_ = this.baseUrl + "/api/customer/group/disabledandaccident?";
        if (affiliate !== undefined && affiliate !== null)
            url_ += "affiliate=" + encodeURIComponent("" + affiliate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupAccidentData);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGroupDisabledAndAccident(_response);
        });
    }

    protected processCreateGroupDisabledAndAccident(response: Response): Promise<CreateDisabledAccidentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateDisabledAccidentResult;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateDisabledAccidentResult>(null as any);
    }
}

export class CustomerInsuranceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getInsurancesGraphValues(): Promise<ContractValueResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/graphvalues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesGraphValues(_response);
        });
    }

    protected processGetInsurancesGraphValues(response: Response): Promise<ContractValueResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractValueResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractValueResponse[]>(null as any);
    }

    getInsuranceGraphValues(arcaInsuranceId: number): Promise<ContractValueResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/graphvalues";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceGraphValues(_response);
        });
    }

    protected processGetInsuranceGraphValues(response: Response): Promise<ContractValueResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractValueResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractValueResponse[]>(null as any);
    }

    getInsurances(): Promise<CustomerInsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurances(_response);
        });
    }

    protected processGetInsurances(response: Response): Promise<CustomerInsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInsuranceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInsuranceResponse[]>(null as any);
    }

    getInsurance(arcaInsuranceId: number): Promise<CustomerInsuranceResponse> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurance(_response);
        });
    }

    protected processGetInsurance(response: Response): Promise<CustomerInsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInsuranceResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInsuranceResponse>(null as any);
    }

    getInsuranceCurrentPremiumAmount(arcaInsuranceId: number): Promise<number | null> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/currentpremiumamount";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceCurrentPremiumAmount(_response);
        });
    }

    protected processGetInsuranceCurrentPremiumAmount(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }

    getCanPlanForOutpayment(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/insurance/outpayment/plannable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCanPlanForOutpayment(_response);
        });
    }

    protected processGetCanPlanForOutpayment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getInsurancesFundDistribution(): Promise<CustomerInsuranceDistrubutionResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/distributions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesFundDistribution(_response);
        });
    }

    protected processGetInsurancesFundDistribution(response: Response): Promise<CustomerInsuranceDistrubutionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInsuranceDistrubutionResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInsuranceDistrubutionResponse[]>(null as any);
    }

    getInsuranceContact(arcaInsuranceId: number): Promise<InsuranceContactResponse> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/contacts";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceContact(_response);
        });
    }

    protected processGetInsuranceContact(response: Response): Promise<InsuranceContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceContactResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceContactResponse>(null as any);
    }

    getInsuranceFundDistribution(arcaInsuranceId: number): Promise<CustomerInsuranceDistrubutionResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/distributions";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceFundDistribution(_response);
        });
    }

    protected processGetInsuranceFundDistribution(response: Response): Promise<CustomerInsuranceDistrubutionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInsuranceDistrubutionResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInsuranceDistrubutionResponse[]>(null as any);
    }

    getInsuranceHoldings(arcaInsuranceId: number): Promise<CustomerInsuranceHoldingResponse> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/holdings";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceHoldings(_response);
        });
    }

    protected processGetInsuranceHoldings(response: Response): Promise<CustomerInsuranceHoldingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerInsuranceHoldingResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerInsuranceHoldingResponse>(null as any);
    }

    changeCustomerHoldings(arcaInsuranceId: number, request: InsuranceHoldingRequest): Promise<FundChangeStoryResult> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/holdings";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeCustomerHoldings(_response);
        });
    }

    protected processChangeCustomerHoldings(response: Response): Promise<FundChangeStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChangeStoryResult>(null as any);
    }

    getInsuranceOutpayments(): Promise<InsuranceOutpaymentResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/outpayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceOutpayments(_response);
        });
    }

    protected processGetInsuranceOutpayments(response: Response): Promise<InsuranceOutpaymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceOutpaymentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceOutpaymentResponse[]>(null as any);
    }

    getInsuranceInpayments(): Promise<InsuranceInpaymentResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/inpayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceInpayments(_response);
        });
    }

    protected processGetInsuranceInpayments(response: Response): Promise<InsuranceInpaymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceInpaymentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceInpaymentResponse[]>(null as any);
    }

    getInsuranceTransactions(fromDate: string | null | undefined, toDate: string | null | undefined, contractTransactionSubtype: ContractTransactionSubtype | null | undefined): Promise<InsuranceTransactionResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/transactions?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (contractTransactionSubtype !== undefined && contractTransactionSubtype !== null)
            url_ += "contractTransactionSubtype=" + encodeURIComponent("" + contractTransactionSubtype) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceTransactions(_response);
        });
    }

    protected processGetInsuranceTransactions(response: Response): Promise<InsuranceTransactionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceTransactionResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceTransactionResponse[]>(null as any);
    }

    hasLongTermSickLeaveInsurance(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/insurance/longtermsickleave";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasLongTermSickLeaveInsurance(_response);
        });
    }

    protected processHasLongTermSickLeaveInsurance(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPensionBonusTransactions(): Promise<number> {
        let url_ = this.baseUrl + "/api/customer/insurance/pensionbonus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPensionBonusTransactions(_response);
        });
    }

    protected processGetPensionBonusTransactions(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getInsuranceByOfficialId(insuranceOfficialId: string): Promise<InsuranceResponse> {
        let url_ = this.baseUrl + "/api/customer/insurance/officialid/{insuranceOfficialId}";
        if (insuranceOfficialId === undefined || insuranceOfficialId === null)
            throw new Error("The parameter 'insuranceOfficialId' must be defined.");
        url_ = url_.replace("{insuranceOfficialId}", encodeURIComponent("" + insuranceOfficialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceByOfficialId(_response);
        });
    }

    protected processGetInsuranceByOfficialId(response: Response): Promise<InsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse>(null as any);
    }

    getInsuranceFundChangeTransactionsByArcaId(arcaInsuranceId: number): Promise<FundChangeTransactionResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/fundchangetransactions";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceFundChangeTransactionsByArcaId(_response);
        });
    }

    protected processGetInsuranceFundChangeTransactionsByArcaId(response: Response): Promise<FundChangeTransactionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeTransactionResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChangeTransactionResponse[]>(null as any);
    }

    getInsuranceFundChangeValueHolderDetails(arcaInsuranceId: number, contractTransactionId: number): Promise<FundChangeTransactionValueHolderResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/fundchangetransactions/{contractTransactionId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (contractTransactionId === undefined || contractTransactionId === null)
            throw new Error("The parameter 'contractTransactionId' must be defined.");
        url_ = url_.replace("{contractTransactionId}", encodeURIComponent("" + contractTransactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceFundChangeValueHolderDetails(_response);
        });
    }

    protected processGetInsuranceFundChangeValueHolderDetails(response: Response): Promise<FundChangeTransactionValueHolderResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeTransactionValueHolderResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChangeTransactionValueHolderResponse[]>(null as any);
    }

    getInsuranceFundChangeFutureAllocationDetails(arcaInsuranceId: number, futureAllocationId: number): Promise<FundChangeTransactionFutureAllocationResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/fundchangetransactions/futureallocation/{futureAllocationId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (futureAllocationId === undefined || futureAllocationId === null)
            throw new Error("The parameter 'futureAllocationId' must be defined.");
        url_ = url_.replace("{futureAllocationId}", encodeURIComponent("" + futureAllocationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceFundChangeFutureAllocationDetails(_response);
        });
    }

    protected processGetInsuranceFundChangeFutureAllocationDetails(response: Response): Promise<FundChangeTransactionFutureAllocationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FundChangeTransactionFutureAllocationResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FundChangeTransactionFutureAllocationResponse[]>(null as any);
    }

    getInsurancesWithHoldings(): Promise<InsuranceHoldingResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/holdings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesWithHoldings(_response);
        });
    }

    protected processGetInsurancesWithHoldings(response: Response): Promise<InsuranceHoldingResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceHoldingResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceHoldingResponse[]>(null as any);
    }

    getContractTransactionByArcaId(arcaInsuranceId: number): Promise<InsuranceTransactionPlanEarlyResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/transactions";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContractTransactionByArcaId(_response);
        });
    }

    protected processGetContractTransactionByArcaId(response: Response): Promise<InsuranceTransactionPlanEarlyResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceTransactionPlanEarlyResponse[];
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceTransactionPlanEarlyResponse[];
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceTransactionPlanEarlyResponse[]>(null as any);
    }

    /**
     * @deprecated
     */
    getInsuranceByArcaId(arcaInsuranceId: number): Promise<InsuranceResponse> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/legacy";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceByArcaId(_response);
        });
    }

    protected processGetInsuranceByArcaId(response: Response): Promise<InsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse>(null as any);
    }

    getInsuranceBenefits(arcaInsuranceId: number): Promise<BenefitResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/benefits";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceBenefits(_response);
        });
    }

    protected processGetInsuranceBenefits(response: Response): Promise<BenefitResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BenefitResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BenefitResponse[]>(null as any);
    }

    getInsuranceOutpaymentTransaction(arcaInsuranceId: number, contractTransactionId: number | undefined): Promise<InsuranceTransactionResponse> {
        let url_ = this.baseUrl + "/api/customer/insurance/{arcaInsuranceId}/outpayment/transaction?";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (contractTransactionId === null)
            throw new Error("The parameter 'contractTransactionId' cannot be null.");
        else if (contractTransactionId !== undefined)
            url_ += "contractTransactionId=" + encodeURIComponent("" + contractTransactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceOutpaymentTransaction(_response);
        });
    }

    protected processGetInsuranceOutpaymentTransaction(response: Response): Promise<InsuranceTransactionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceTransactionResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceTransactionResponse>(null as any);
    }

    /**
     * @deprecated
     */
    getCustomerInsurances(): Promise<InsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/customer/insurance/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerInsurances(_response);
        });
    }

    protected processGetCustomerInsurances(response: Response): Promise<InsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse[]>(null as any);
    }
}

export class CustomerNewAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createPrivateSavingsInsurance(insuranceStory: CreateFreestandingWithAmlRequest): Promise<CreateIndividualInsuranceStoryResult> {
        let url_ = this.baseUrl + "/api/customer/newagreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePrivateSavingsInsurance(_response);
        });
    }

    protected processCreatePrivateSavingsInsurance(response: Response): Promise<CreateIndividualInsuranceStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateIndividualInsuranceStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateIndividualInsuranceStoryResult>(null as any);
    }

    getBusinessAgreementGroupsForCapitalInsurance(): Promise<BusinessAgreementGroupResponse> {
        let url_ = this.baseUrl + "/api/customer/newagreement/businessagreementgroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBusinessAgreementGroupsForCapitalInsurance(_response);
        });
    }

    protected processGetBusinessAgreementGroupsForCapitalInsurance(response: Response): Promise<BusinessAgreementGroupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessAgreementGroupResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessAgreementGroupResponse>(null as any);
    }
}

export class CustomerOutpaymentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createOutPayment(data: CreateOutPaymentStoryCommand): Promise<CreateOutPaymentStoryResult> {
        let url_ = this.baseUrl + "/api/customer/outpayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOutPayment(_response);
        });
    }

    protected processCreateOutPayment(response: Response): Promise<CreateOutPaymentStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOutPaymentStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOutPaymentStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOutPaymentStoryResult>(null as any);
    }

    changeOutPayment(data: ChangeOutPaymentStoryCommand): Promise<ChangeOutPaymentStoryResult> {
        let url_ = this.baseUrl + "/api/customer/outpayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeOutPayment(_response);
        });
    }

    protected processChangeOutPayment(response: Response): Promise<ChangeOutPaymentStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOutPaymentStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOutPaymentStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeOutPaymentStoryResult>(null as any);
    }

    postponeOutpaymentDate(story: ChangePensionDateStoryCommand): Promise<CreateOutPaymentStoryResult> {
        let url_ = this.baseUrl + "/api/customer/outpayment/postpone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(story);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostponeOutpaymentDate(_response);
        });
    }

    protected processPostponeOutpaymentDate(response: Response): Promise<CreateOutPaymentStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOutPaymentStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOutPaymentStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOutPaymentStoryResult>(null as any);
    }

    signOutPayment(envelopeId: number): Promise<BankIdSignResponse> {
        let url_ = this.baseUrl + "/api/customer/outpayment/bankid/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(envelopeId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignOutPayment(_response);
        });
    }

    protected processSignOutPayment(response: Response): Promise<BankIdSignResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdSignResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdSignResponse>(null as any);
    }

    getSignStatusOutPayment(envelopeId: number, orderRef: string): Promise<BankIdAuthStatusResponse> {
        let url_ = this.baseUrl + "/api/customer/outpayment/{envelopeId}/bankid/sign/status";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderRef);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignStatusOutPayment(_response);
        });
    }

    protected processGetSignStatusOutPayment(response: Response): Promise<BankIdAuthStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdAuthStatusResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdAuthStatusResponse>(null as any);
    }

    getOutpaymentAccountDetails(arcaInsuranceId: number): Promise<OutpaymentAccountAndClearing> {
        let url_ = this.baseUrl + "/api/customer/outpayment/{arcaInsuranceId}/accountdetails";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutpaymentAccountDetails(_response);
        });
    }

    protected processGetOutpaymentAccountDetails(response: Response): Promise<OutpaymentAccountAndClearing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutpaymentAccountAndClearing;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutpaymentAccountAndClearing>(null as any);
    }

    updateOutpaymentAccountDetails(arcaInsuranceId: number, request: UpdateOutpaymentDetailsRequest): Promise<UpdateOutpaymentDetailsStoryResult> {
        let url_ = this.baseUrl + "/api/customer/outpayment/{arcaInsuranceId}/accountdetails";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOutpaymentAccountDetails(_response);
        });
    }

    protected processUpdateOutpaymentAccountDetails(response: Response): Promise<UpdateOutpaymentDetailsStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateOutpaymentDetailsStoryResult;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateOutpaymentDetailsStoryResult>(null as any);
    }

    getOutpaymentInsuranceByArcaId(arcaInsuranceId: number): Promise<OutpaymentInsuranceResponse> {
        let url_ = this.baseUrl + "/api/customer/outpayment/insurance/{arcaInsuranceId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutpaymentInsuranceByArcaId(_response);
        });
    }

    protected processGetOutpaymentInsuranceByArcaId(response: Response): Promise<OutpaymentInsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutpaymentInsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutpaymentInsuranceResponse>(null as any);
    }

    getOutpaymentInsurances(): Promise<OutpaymentInsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/customer/outpayment/insurances";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOutpaymentInsurances(_response);
        });
    }

    protected processGetOutpaymentInsurances(response: Response): Promise<OutpaymentInsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutpaymentInsuranceResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OutpaymentInsuranceResponse[]>(null as any);
    }
}

export class CustomerPersonClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getPersonByArcaUserId(): Promise<PersonResponse> {
        let url_ = this.baseUrl + "/api/customer/person";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPersonByArcaUserId(_response);
        });
    }

    protected processGetPersonByArcaUserId(response: Response): Promise<PersonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonResponse>(null as any);
    }

    updateElectronicAddresses(updateElectronicAddressesRequest: UpdateElectronicAddressesRequest): Promise<UpdateElectronicAddressesResult> {
        let url_ = this.baseUrl + "/api/customer/person/electronicaddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateElectronicAddressesRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateElectronicAddresses(_response);
        });
    }

    protected processUpdateElectronicAddresses(response: Response): Promise<UpdateElectronicAddressesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateElectronicAddressesResult;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateElectronicAddressesResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateElectronicAddressesResult>(null as any);
    }

    updatePersonNotification(disabled: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/person/notification/disabled?";
        if (disabled === null)
            throw new Error("The parameter 'disabled' cannot be null.");
        else if (disabled !== undefined)
            url_ += "disabled=" + encodeURIComponent("" + disabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePersonNotification(_response);
        });
    }

    protected processUpdatePersonNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLatestTaxBasis(arcaInsuranceId: number): Promise<number | null> {
        let url_ = this.baseUrl + "/api/customer/person/insurance/{arcaInsuranceId}/taxbasis";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestTaxBasis(_response);
        });
    }

    protected processGetLatestTaxBasis(response: Response): Promise<number | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number | null>(null as any);
    }
}

export class CustomerStoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getStoryAssignment(envelopeId: number): Promise<Envelope> {
        let url_ = this.baseUrl + "/api/customer/story/{envelopeId}/assignment";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStoryAssignment(_response);
        });
    }

    protected processGetStoryAssignment(response: Response): Promise<Envelope> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope>(null as any);
    }

    getStoryEnvelope(envelopeId: number): Promise<Status> {
        let url_ = this.baseUrl + "/api/customer/story/{envelopeId}";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStoryEnvelope(_response);
        });
    }

    protected processGetStoryEnvelope(response: Response): Promise<Status> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Status;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Status>(null as any);
    }

    acceptStoryEnvelope(envelopeId: number): Promise<Envelope> {
        let url_ = this.baseUrl + "/api/customer/story/{envelopeId}/accept";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptStoryEnvelope(_response);
        });
    }

    protected processAcceptStoryEnvelope(response: Response): Promise<Envelope> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope>(null as any);
    }

    denyStory(envelopeId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/story/{envelopeId}/deny";
        if (envelopeId === undefined || envelopeId === null)
            throw new Error("The parameter 'envelopeId' must be defined.");
        url_ = url_.replace("{envelopeId}", encodeURIComponent("" + envelopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDenyStory(_response);
        });
    }

    protected processDenyStory(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class CustomerMagnumGoClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getPiggelinStories(): Promise<Envelope[]> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/piggelinstories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPiggelinStories(_response);
        });
    }

    protected processGetPiggelinStories(response: Response): Promise<Envelope[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope[]>(null as any);
    }

    getPiggelinStory(piggelinId: number): Promise<Envelope> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/piggelinstory/{piggelinId}";
        if (piggelinId === undefined || piggelinId === null)
            throw new Error("The parameter 'piggelinId' must be defined.");
        url_ = url_.replace("{piggelinId}", encodeURIComponent("" + piggelinId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPiggelinStory(_response);
        });
    }

    protected processGetPiggelinStory(response: Response): Promise<Envelope> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Envelope;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Envelope>(null as any);
    }

    getAcceptTermsMagnumGo(piggelinId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/acceptterms/{piggelinId}";
        if (piggelinId === undefined || piggelinId === null)
            throw new Error("The parameter 'piggelinId' must be defined.");
        url_ = url_.replace("{piggelinId}", encodeURIComponent("" + piggelinId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAcceptTermsMagnumGo(_response);
        });
    }

    protected processGetAcceptTermsMagnumGo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getSessionIdMagnumGo(piggelinId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/sessionsecuritytoken/{piggelinId}";
        if (piggelinId === undefined || piggelinId === null)
            throw new Error("The parameter 'piggelinId' must be defined.");
        url_ = url_.replace("{piggelinId}", encodeURIComponent("" + piggelinId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSessionIdMagnumGo(_response);
        });
    }

    protected processGetSessionIdMagnumGo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    completeMagnumGo(request: SignEnvelopeRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteMagnumGo(_response);
        });
    }

    protected processCompleteMagnumGo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    signMagnumGo(request: SignEnvelopeRequest): Promise<BankIdSignResponse> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/bankidsign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignMagnumGo(_response);
        });
    }

    protected processSignMagnumGo(response: Response): Promise<BankIdSignResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdSignResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdSignResponse>(null as any);
    }

    getSignStatusMagnumGo(piggelinId: number, orderRef: string): Promise<BankIdAuthStatusResponse> {
        let url_ = this.baseUrl + "/api/customer/magnumgo/bankidsignstatus/{piggelinId}";
        if (piggelinId === undefined || piggelinId === null)
            throw new Error("The parameter 'piggelinId' must be defined.");
        url_ = url_.replace("{piggelinId}", encodeURIComponent("" + piggelinId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderRef);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignStatusMagnumGo(_response);
        });
    }

    protected processGetSignStatusMagnumGo(response: Response): Promise<BankIdAuthStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankIdAuthStatusResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankIdAuthStatusResponse>(null as any);
    }
}

export class CustomerUserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getCustomerSettings(): Promise<User> {
        let url_ = this.baseUrl + "/api/customer/user/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerSettings(_response);
        });
    }

    protected processGetCustomerSettings(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as User;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    updateCustomerTermsAccepted(termsaccepted: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/user/termsaccepted?";
        if (termsaccepted === null)
            throw new Error("The parameter 'termsaccepted' cannot be null.");
        else if (termsaccepted !== undefined)
            url_ += "termsaccepted=" + encodeURIComponent("" + termsaccepted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCustomerTermsAccepted(_response);
        });
    }

    protected processUpdateCustomerTermsAccepted(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateNewsLetter(wantNewsLetter: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/user/newsletter?";
        if (wantNewsLetter === null)
            throw new Error("The parameter 'wantNewsLetter' cannot be null.");
        else if (wantNewsLetter !== undefined)
            url_ += "wantNewsLetter=" + encodeURIComponent("" + wantNewsLetter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNewsLetter(_response);
        });
    }

    protected processUpdateNewsLetter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updatePasswordRecoveryType(allowSendingRecoveryAsEmail: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/user/passwordrecoverytype?";
        if (allowSendingRecoveryAsEmail === null)
            throw new Error("The parameter 'allowSendingRecoveryAsEmail' cannot be null.");
        else if (allowSendingRecoveryAsEmail !== undefined)
            url_ += "allowSendingRecoveryAsEmail=" + encodeURIComponent("" + allowSendingRecoveryAsEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePasswordRecoveryType(_response);
        });
    }

    protected processUpdatePasswordRecoveryType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    changePassword(model: ChangePasswordCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/user/changepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompanyAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getAgreementStatisticsByLegalPerson(legalPersonId: number, skip: number | undefined, take: number | undefined): Promise<AgreementCompanyStatisticsResponse[]> {
        let url_ = this.baseUrl + "/api/company/agreement/{legalPersonId}/statistics?";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgreementStatisticsByLegalPerson(_response);
        });
    }

    protected processGetAgreementStatisticsByLegalPerson(response: Response): Promise<AgreementCompanyStatisticsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementCompanyStatisticsResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementCompanyStatisticsResponse[]>(null as any);
    }

    getAgreementIdsByLegalPerson(legalPersonId: number): Promise<AdministrationAgreementIdResponse[]> {
        let url_ = this.baseUrl + "/api/company/agreement/{legalPersonId}/ids";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgreementIdsByLegalPerson(_response);
        });
    }

    protected processGetAgreementIdsByLegalPerson(response: Response): Promise<AdministrationAgreementIdResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdministrationAgreementIdResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationAgreementIdResponse[]>(null as any);
    }

    getAgreementByAgreementId(legalPersonId: number, agreementId: number): Promise<AdministrationAgreementResponse> {
        let url_ = this.baseUrl + "/api/company/agreement/{legalPersonId}/{agreementId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAgreementByAgreementId(_response);
        });
    }

    protected processGetAgreementByAgreementId(response: Response): Promise<AdministrationAgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdministrationAgreementResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationAgreementResponse>(null as any);
    }

    getCompanyAgreementByLegalId(legalPersonId: number, pensionPlanId: number): Promise<CompanyAgreementResponse> {
        let url_ = this.baseUrl + "/api/company/agreement/{legalPersonId}/pensionplan/{pensionPlanId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (pensionPlanId === undefined || pensionPlanId === null)
            throw new Error("The parameter 'pensionPlanId' must be defined.");
        url_ = url_.replace("{pensionPlanId}", encodeURIComponent("" + pensionPlanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyAgreementByLegalId(_response);
        });
    }

    protected processGetCompanyAgreementByLegalId(response: Response): Promise<CompanyAgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyAgreementResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyAgreementResponse>(null as any);
    }
}

export class CompanyAmlClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    legalCustomerKnowledge(legalPersonId: number): Promise<CustomerKnowlegeResponse> {
        let url_ = this.baseUrl + "/api/company/aml/{legalPersonId}/knowledge";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLegalCustomerKnowledge(_response);
        });
    }

    protected processLegalCustomerKnowledge(response: Response): Promise<CustomerKnowlegeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomerKnowlegeResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerKnowlegeResponse>(null as any);
    }

    createContractAml(legalPersonOfficialId: string | null | undefined, amlContractStory: CreateAmlContractStoryCommand): Promise<CreateAmlUserForCompanyStoryResult> {
        let url_ = this.baseUrl + "/api/company/aml/contract?";
        if (legalPersonOfficialId !== undefined && legalPersonOfficialId !== null)
            url_ += "legalPersonOfficialId=" + encodeURIComponent("" + legalPersonOfficialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(amlContractStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateContractAml(_response);
        });
    }

    protected processCreateContractAml(response: Response): Promise<CreateAmlUserForCompanyStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAmlUserForCompanyStoryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAmlUserForCompanyStoryResult>(null as any);
    }

    createAmlLegalPerson(amlLegalPersonStory: CreateAmlLegalPersonStoryCommand): Promise<AmlLegalPersonResult> {
        let url_ = this.baseUrl + "/api/company/aml/companyperson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(amlLegalPersonStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAmlLegalPerson(_response);
        });
    }

    protected processCreateAmlLegalPerson(response: Response): Promise<AmlLegalPersonResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AmlLegalPersonResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AmlLegalPersonResult>(null as any);
    }

    createAmlUserForCompany(createAmlUserStory: CreateAmlUserForCompanyStoryCommand): Promise<CreateAmlUserForCompanyStoryResult> {
        let url_ = this.baseUrl + "/api/company/aml/privateperson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createAmlUserStory);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAmlUserForCompany(_response);
        });
    }

    protected processCreateAmlUserForCompany(response: Response): Promise<CreateAmlUserForCompanyStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAmlUserForCompanyStoryResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAmlUserForCompanyStoryResult>(null as any);
    }

    getCompanyRepresentative(identifier: string): Promise<CompanyRepresentativeResponse> {
        let url_ = this.baseUrl + "/api/company/aml/representative/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyRepresentative(_response);
        });
    }

    protected processGetCompanyRepresentative(response: Response): Promise<CompanyRepresentativeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyRepresentativeResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyRepresentativeResponse>(null as any);
    }

    getControllingPersons(officialId: string): Promise<ControllingPerson[]> {
        let url_ = this.baseUrl + "/api/company/aml/controllingpersons/{officialId}";
        if (officialId === undefined || officialId === null)
            throw new Error("The parameter 'officialId' must be defined.");
        url_ = url_.replace("{officialId}", encodeURIComponent("" + officialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetControllingPersons(_response);
        });
    }

    protected processGetControllingPersons(response: Response): Promise<ControllingPerson[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ControllingPerson[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControllingPerson[]>(null as any);
    }
}

export class CompanyAuthClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getLegalPersonsForCompanyRepresentative(): Promise<CompanyAuthenticationResponse[]> {
        let url_ = this.baseUrl + "/api/company/auth/persons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalPersonsForCompanyRepresentative(_response);
        });
    }

    protected processGetLegalPersonsForCompanyRepresentative(response: Response): Promise<CompanyAuthenticationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyAuthenticationResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyAuthenticationResponse[]>(null as any);
    }

    updateElectronicAddresses(repId: number | undefined, email: string | null | undefined): Promise<CompanyAuthenticationResponse> {
        let url_ = this.baseUrl + "/api/company/auth?";
        if (repId === null)
            throw new Error("The parameter 'repId' cannot be null.");
        else if (repId !== undefined)
            url_ += "repId=" + encodeURIComponent("" + repId) + "&";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateElectronicAddresses(_response);
        });
    }

    protected processUpdateElectronicAddresses(response: Response): Promise<CompanyAuthenticationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyAuthenticationResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyAuthenticationResponse>(null as any);
    }

    generateVerificationCode(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/company/auth/{id}/code/generate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateVerificationCode(_response);
        });
    }

    protected processGenerateVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    verifyVerificationCode(request: VerifyVerificationCodeRequest): Promise<CompanyRepresentativeResponse> {
        let url_ = this.baseUrl + "/api/company/auth/code/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyVerificationCode(_response);
        });
    }

    protected processVerifyVerificationCode(response: Response): Promise<CompanyRepresentativeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyRepresentativeResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyRepresentativeResponse>(null as any);
    }
}

export class CompanyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getCompany(legalPersonId: number): Promise<CompanyResponse> {
        let url_ = this.baseUrl + "/api/company/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompany(_response);
        });
    }

    protected processGetCompany(response: Response): Promise<CompanyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyResponse>(null as any);
    }

    getCompanyUsers(legalPersonId: number): Promise<CompanyUserResponse[]> {
        let url_ = this.baseUrl + "/api/company/{legalPersonId}/users";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyUsers(_response);
        });
    }

    protected processGetCompanyUsers(response: Response): Promise<CompanyUserResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyUserResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyUserResponse[]>(null as any);
    }

    updateCompanyUser(legalPersonId: number, request: CompanyUserRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/company/{legalPersonId}/user";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyUser(_response);
        });
    }

    protected processUpdateCompanyUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getPremiumReports(legalPersonId: number, from: string, to: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/company/premiumreports/{legalPersonId}/{from}/{to}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent("" + from));
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined.");
        url_ = url_.replace("{to}", encodeURIComponent("" + to));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPremiumReports(_response);
        });
    }

    protected processGetPremiumReports(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CompanyContractClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getAllowedArcaContractAccessCompanyAdmin(arcaContractId: number): Promise<AccessRights> {
        let url_ = this.baseUrl + "/api/company/contract/{arcaContractId}/access";
        if (arcaContractId === undefined || arcaContractId === null)
            throw new Error("The parameter 'arcaContractId' must be defined.");
        url_ = url_.replace("{arcaContractId}", encodeURIComponent("" + arcaContractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedArcaContractAccessCompanyAdmin(_response);
        });
    }

    protected processGetAllowedArcaContractAccessCompanyAdmin(response: Response): Promise<AccessRights> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRights;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRights>(null as any);
    }

    getContractsByCompanyAdmin(legalPersonId: number): Promise<ContractContainerResponse> {
        let url_ = this.baseUrl + "/api/company/contract/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContractsByCompanyAdmin(_response);
        });
    }

    protected processGetContractsByCompanyAdmin(response: Response): Promise<ContractContainerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractContainerResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractContainerResponse>(null as any);
    }
}

export class CompanyDocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getDocuments(legalPersonId: number): Promise<GroupedCompanyDocumentResponse[]> {
        let url_ = this.baseUrl + "/api/company/document/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<GroupedCompanyDocumentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupedCompanyDocumentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupedCompanyDocumentResponse[]>(null as any);
    }

    getDocumentFile(externalId: string, legalPersonId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/company/document/{externalId}/legalperson/{legalPersonId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentFile(_response);
        });
    }

    protected processGetDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CompanyEmployeeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getEmploymentsByLegalPerson(legalPersonId: number): Promise<CompanyAdministrationEmploymentResponse[]> {
        let url_ = this.baseUrl + "/api/company/employee/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmploymentsByLegalPerson(_response);
        });
    }

    protected processGetEmploymentsByLegalPerson(response: Response): Promise<CompanyAdministrationEmploymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyAdministrationEmploymentResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyAdministrationEmploymentResponse[]>(null as any);
    }
}

export class CompanyEmploymentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    updateSalaries(salaries: EmploymentTerm[]): Promise<SalaryPlanStoryResult> {
        let url_ = this.baseUrl + "/api/company/employment/salaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(salaries);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSalaries(_response);
        });
    }

    protected processUpdateSalaries(response: Response): Promise<SalaryPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalaryPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalaryPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalaryPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalaryPlanStoryResult>(null as any);
    }

    updatePremiums(premiums: EmploymentAdjustment[]): Promise<PremiumPlanStoryResult> {
        let url_ = this.baseUrl + "/api/company/employment/premiums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(premiums);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePremiums(_response);
        });
    }

    protected processUpdatePremiums(response: Response): Promise<PremiumPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiumPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiumPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PremiumPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PremiumPlanStoryResult>(null as any);
    }

    endEmployments(employments: EmploymentEnd[]): Promise<EmploymentEndStoryResult> {
        let url_ = this.baseUrl + "/api/company/employment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employments);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEndEmployments(_response);
        });
    }

    protected processEndEmployments(response: Response): Promise<EmploymentEndStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentEndStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentEndStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentEndStoryResult>(null as any);
    }

    addEmployments(employments: EmploymentAdd[]): Promise<EmploymentAddStoryResult> {
        let url_ = this.baseUrl + "/api/company/employment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employments);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddEmployments(_response);
        });
    }

    protected processAddEmployments(response: Response): Promise<EmploymentAddStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentAddStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentAddStoryResult;
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentAddStoryResult>(null as any);
    }

    getEmploymentsByLegalPersonId(legalPersonId: number, employmentStatus: EmploymentStatus, skip: number): Promise<EmploymentResponse[]> {
        let url_ = this.baseUrl + "/api/company/employment/legalperson/{legalPersonId}/{employmentStatus}/{skip}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        if (employmentStatus === undefined || employmentStatus === null)
            throw new Error("The parameter 'employmentStatus' must be defined.");
        url_ = url_.replace("{employmentStatus}", encodeURIComponent("" + employmentStatus));
        if (skip === undefined || skip === null)
            throw new Error("The parameter 'skip' must be defined.");
        url_ = url_.replace("{skip}", encodeURIComponent("" + skip));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmploymentsByLegalPersonId(_response);
        });
    }

    protected processGetEmploymentsByLegalPersonId(response: Response): Promise<EmploymentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentResponse[]>(null as any);
    }
}

export class CompanyInPaymentAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    createExtraPremiumInvoice(data: FullPremiumInvoice): Promise<ExtraPremiumPlanStoryResult> {
        let url_ = this.baseUrl + "/api/company/inpaymentagreement/extrapremium";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateExtraPremiumInvoice(_response);
        });
    }

    protected processCreateExtraPremiumInvoice(response: Response): Promise<ExtraPremiumPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtraPremiumPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtraPremiumPlanStoryResult;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtraPremiumPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtraPremiumPlanStoryResult>(null as any);
    }
}

export class CompanyInsuranceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getEmploymentInsuranceByArcaInsuranceId(arcaInsuranceId: number, legalPersonId: number): Promise<CompanyAdministrationInsuranceResponse> {
        let url_ = this.baseUrl + "/api/company/insurance/{arcaInsuranceId}/legalperson/{legalPersonId}";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmploymentInsuranceByArcaInsuranceId(_response);
        });
    }

    protected processGetEmploymentInsuranceByArcaInsuranceId(response: Response): Promise<CompanyAdministrationInsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyAdministrationInsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyAdministrationInsuranceResponse>(null as any);
    }

    getInsuranceBenefits(arcaInsuranceId: number): Promise<CompanyInsuranceBenefitResponse> {
        let url_ = this.baseUrl + "/api/company/insurance/{arcaInsuranceId}/benefits";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceBenefits(_response);
        });
    }

    protected processGetInsuranceBenefits(response: Response): Promise<CompanyInsuranceBenefitResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyInsuranceBenefitResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyInsuranceBenefitResponse>(null as any);
    }

    getInsuranceCollapsibleDetailsByArcaIdCompanyAdmin(arcaInsuranceId: number): Promise<InsuranceResponse> {
        let url_ = this.baseUrl + "/api/company/insurance/{arcaInsuranceId}/details";
        if (arcaInsuranceId === undefined || arcaInsuranceId === null)
            throw new Error("The parameter 'arcaInsuranceId' must be defined.");
        url_ = url_.replace("{arcaInsuranceId}", encodeURIComponent("" + arcaInsuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceCollapsibleDetailsByArcaIdCompanyAdmin(_response);
        });
    }

    protected processGetInsuranceCollapsibleDetailsByArcaIdCompanyAdmin(response: Response): Promise<InsuranceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse>(null as any);
    }

    getInsurancesForCompanyAdmin(legalPersonId: number): Promise<InsuranceResponse[]> {
        let url_ = this.baseUrl + "/api/company/insurance/legalperson/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurancesForCompanyAdmin(_response);
        });
    }

    protected processGetInsurancesForCompanyAdmin(response: Response): Promise<InsuranceResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InsuranceResponse[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceResponse[]>(null as any);
    }

    getRiskAssessmentsByIds(arcaAgreementId: number, riskAssessmentRequest: RiskAssessmentRequest): Promise<RiskAssessmentResponse[]> {
        let url_ = this.baseUrl + "/api/company/insurance/riskassessments/{arcaAgreementId}";
        if (arcaAgreementId === undefined || arcaAgreementId === null)
            throw new Error("The parameter 'arcaAgreementId' must be defined.");
        url_ = url_.replace("{arcaAgreementId}", encodeURIComponent("" + arcaAgreementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(riskAssessmentRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRiskAssessmentsByIds(_response);
        });
    }

    protected processGetRiskAssessmentsByIds(response: Response): Promise<RiskAssessmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiskAssessmentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskAssessmentResponse[]>(null as any);
    }
}

export class CompanyNewAgreementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getBusinessAgreementGroupsForDirectFlow(): Promise<BusinessAgreementGroupResponse[]> {
        let url_ = this.baseUrl + "/api/company/newagreement/businessagreementgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBusinessAgreementGroupsForDirectFlow(_response);
        });
    }

    protected processGetBusinessAgreementGroupsForDirectFlow(response: Response): Promise<BusinessAgreementGroupResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessAgreementGroupResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessAgreementGroupResponse[]>(null as any);
    }

    createDirectAgreement(pensionPlan: CreatePensionPlanStory): Promise<CreatePensionPlanStoryResult> {
        let url_ = this.baseUrl + "/api/company/newagreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pensionPlan);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDirectAgreement(_response);
        });
    }

    protected processCreateDirectAgreement(response: Response): Promise<CreatePensionPlanStoryResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePensionPlanStoryResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePensionPlanStoryResult>(null as any);
    }

    getCompanyByOfficialId(officialId: string): Promise<Company> {
        let url_ = this.baseUrl + "/api/company/newagreement/company/{officialId}";
        if (officialId === undefined || officialId === null)
            throw new Error("The parameter 'officialId' must be defined.");
        url_ = url_.replace("{officialId}", encodeURIComponent("" + officialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyByOfficialId(_response);
        });
    }

    protected processGetCompanyByOfficialId(response: Response): Promise<Company> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Company;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Company>(null as any);
    }

    getPriceOffers(pensionPlan: CreatePensionPlanStory): Promise<EmploymentPriceOffer[]> {
        let url_ = this.baseUrl + "/api/company/newagreement/priceoffers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pensionPlan);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriceOffers(_response);
        });
    }

    protected processGetPriceOffers(response: Response): Promise<EmploymentPriceOffer[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentPriceOffer[];
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentPriceOffer[];
            return result202;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmploymentPriceOffer[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmploymentPriceOffer[]>(null as any);
    }
}

export class CompanyPersonClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5051";
    }

    getOrAddPersonByOfficialId(id: string): Promise<PersonLightResponse> {
        let url_ = this.baseUrl + "/api/company/person/get/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrAddPersonByOfficialId(_response);
        });
    }

    protected processGetOrAddPersonByOfficialId(response: Response): Promise<PersonLightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonLightResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonLightResponse>(null as any);
    }

    getLegalPersonById(legalPersonId: number): Promise<PersonResponse> {
        let url_ = this.baseUrl + "/api/company/person/legal/{legalPersonId}";
        if (legalPersonId === undefined || legalPersonId === null)
            throw new Error("The parameter 'legalPersonId' must be defined.");
        url_ = url_.replace("{legalPersonId}", encodeURIComponent("" + legalPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalPersonById(_response);
        });
    }

    protected processGetLegalPersonById(response: Response): Promise<PersonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonResponse>(null as any);
    }

    getAccessRights(personId: number): Promise<AccessRights> {
        let url_ = this.baseUrl + "/api/company/person/{personId}/access";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessRights(_response);
        });
    }

    protected processGetAccessRights(response: Response): Promise<AccessRights> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessRights;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessRights>(null as any);
    }
}

export interface AmlQuestion {
    id?: number;
    countryCode?: string | undefined;
    from?: string;
    to?: string | undefined;
    type?: string | undefined;
}

export interface AmlOptionsResponse {
    privateContractOptions?: AmlPrivateContractOptions | undefined;
    legalContractOptions?: AmlLegalContractOptions | undefined;
    controllingPersonOptions?: AmlControllingPersonOptions | undefined;
    amlPrivatePersonOptions?: AmlPrivatePersonOptions | undefined;
}

export interface AmlPrivateContractOptions {
    plannedDepositVolumeOptions?: AmlRangeOption[] | undefined;
    originOfAssetsOptions?: AmlStringOption[] | undefined;
    purposeOfInvestmentOptions?: AmlStringOption[] | undefined;
    plannedDepositsPerYearOptions?: AmlRangeOption[] | undefined;
}

export interface AmlRangeOption {
    id?: number;
    name?: string | undefined;
    value?: AmlRange | undefined;
}

export interface AmlRange {
    min?: number;
    max?: number | undefined;
}

export interface AmlStringOption {
    id?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export interface AmlLegalContractOptions {
    plannedDepositVolumeOptions?: AmlRangeOption[] | undefined;
    originOfAssetsOptions?: AmlStringOption[] | undefined;
    purposeOfInvestmentOptions?: AmlStringOption[] | undefined;
    plannedDepositsPerYearOptions?: AmlRangeOption[] | undefined;
}

export interface AmlControllingPersonOptions {
    citizenshipOptions?: AmlStringOption[] | undefined;
    positionOptions?: AmlStringOption[] | undefined;
    ownershipPercentageOptions?: AmlStringOption[] | undefined;
}

export interface AmlPrivatePersonOptions {
    pepPositionOptions?: AmlStringOption[] | undefined;
    pepInCountryOptions?: AmlStringOption[] | undefined;
    relationToPepOptions?: AmlStringOption[] | undefined;
    occupationOptions?: AmlStringOption[] | undefined;
    monthlyIncomeOptions?: AmlRangeOption[] | undefined;
    taxCountryOptions?: AmlStringOption[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface LoginModel {
    username?: string | undefined;
    password?: string | undefined;
}

export interface BankIdAuthResponse {
    orderRef?: string | undefined;
    autoStartToken?: string | undefined;
    qrToken?: string | undefined;
}

export interface BankIdLoginModel {
    loginType?: LoginType;
}

export enum LoginType {
    Customer = "Customer",
    Partner = "Partner",
    Company = "Company",
    SigningUser = "SigningUser",
}

export interface BankIdAuthStatusResponse {
    status?: BankidPollStatus;
    statusMessageSwedish?: string | undefined;
    statusMessageEnglish?: string | undefined;
    rfaCode?: string | undefined;
    orderRef?: string | undefined;
    ocspResponse?: string | undefined;
    signature?: string | undefined;
    personalNumber?: string | undefined;
    name?: string | undefined;
    qrToken?: string | undefined;
}

export enum BankidPollStatus {
    Unknown = "Unknown",
    Pending = "Pending",
    Failed = "Failed",
    Complete = "Complete",
}

export interface BankIdStatusModel {
    orderRef?: string | undefined;
    loginType?: LoginType;
}

export interface BankIdCancelResponse {
    isCanceled?: boolean;
    statusMessageSwedish?: string | undefined;
    statusMessageEnglish?: string | undefined;
    rfaCode?: string | undefined;
}

export interface FundLightResponse {
    id?: number;
    name?: string | undefined;
    isin?: string | undefined;
    lowCarbonDesignation?: boolean | undefined;
    mdsSustainability?: number | undefined;
    morningstarSustainability?: number | undefined;
    morningstarRating?: number | undefined;
    normscreening?: number;
    isMonthlyTraded?: boolean;
    closeType?: ValueHolderCloseType;
    riskData?: RiskDataResponse | undefined;
    chargesAndFees?: ChargesAndFeesResponse | undefined;
    trailingPerformance?: TrailingPerformanceResponse | undefined;
    movesticSustainabilityData?: MovesticSustainabilityDataResponse | undefined;
    mifid?: MifidResponse | undefined;
    region?: Region;
    fundType?: FundType;
    administratorCompany?: AdministratorCompanyResponse | undefined;
    styleBox?: StyleBoxResponse | undefined;
    lineOfBusiness?: LineOfBusinessResponse | undefined;
}

export enum ValueHolderCloseType {
    None = "None",
    SoftSoftClose = "SoftSoftClose",
    SoftClose = "SoftClose",
    HardClose = "HardClose",
}

export interface RiskDataResponse {
    sharpe3Year?: number | undefined;
    stdDev3Year?: number | undefined;
}

export interface ChargesAndFeesResponse {
    managementFee?: number | undefined;
    performanceFee?: number | undefined;
    ongoingCharge?: number | undefined;
    actualManagementFee?: number | undefined;
}

export interface TrailingPerformanceResponse {
    closePrice?: number | undefined;
    closePriceDate?: string | undefined;
    fiveYearReturn?: number | undefined;
    oneDayReturn?: number | undefined;
    oneYearReturn?: number | undefined;
    thisYearReturn?: number | undefined;
    threeMonthReturn?: number | undefined;
    threeYearAverage?: number | undefined;
    threeYearReturn?: number | undefined;
}

export interface MovesticSustainabilityDataResponse {
    movesticSustainability?: number | undefined;
    excludesWeapons?: boolean;
    excludesNuclearWeapons?: boolean;
    excludesControversialWeapons?: boolean;
    excludesFossileFuels?: boolean;
    excludesAlcohol?: boolean;
    excludesTobacco?: boolean;
    excludesPornography?: boolean;
    swesif?: boolean;
    unpri?: boolean;
    globalCompact?: boolean;
    nordicEcolabelled?: boolean;
}

export interface MifidResponse {
    summaryRiskIndicator?: number | undefined;
    ongoingCostEstimated?: number | undefined;
    occurringCosts?: number | undefined;
    transactionFeeEstimated?: number | undefined;
}

export enum Region {
    NotSet = "NotSet",
    AfricaMiddleEast = "AfricaMiddleEast",
    AsiaExJapan = "AsiaExJapan",
    Europe = "Europe",
    Global = "Global",
    Japan = "Japan",
    NorthAmerica = "NorthAmerica",
    Sweden = "Sweden",
    EmergingMarkets = "EmergingMarkets",
    Asia = "Asia",
    Nordic = "Nordic",
}

export enum FundType {
    NotSet = "NotSet",
    FundPackage = "FundPackage",
    StockFund = "StockFund",
    InterestFund = "InterestFund",
    HedgeFund = "HedgeFund",
    MixFund = "MixFund",
}

export interface AdministratorCompanyResponse {
    name?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    homepage?: string | undefined;
}

export interface StyleBoxResponse {
    size?: StyleBoxSize | undefined;
    style?: StyleBoxStyle | undefined;
}

export enum StyleBoxSize {
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
}

export enum StyleBoxStyle {
    Value = "Value",
    Mix = "Mix",
    Return = "Return",
}

export interface LineOfBusinessResponse {
    mainCategory?: LineOfBusinessCategory | undefined;
    subCategory?: LineOfBusinessSubCategory | undefined;
    smallOrMediumSizedCompanies?: boolean | undefined;
}

export enum LineOfBusinessCategory {
    EjSatt = "EjSatt",
    AktiefonderAsien = "AktiefonderAsien",
    AktiefonderAsienExJapan = "AktiefonderAsienExJapan",
    AktiefonderBransch = "AktiefonderBransch",
    AktiefonderEuropa = "AktiefonderEuropa",
    AktiefonderGlobal = "AktiefonderGlobal",
    AktiefonderJapan = "AktiefonderJapan",
    AktiefonderNordamerika = "AktiefonderNordamerika",
    AktiefonderNorden = "AktiefonderNorden",
    AktiefonderPacific = "AktiefonderPacific",
    AktiefonderSverige = "AktiefonderSverige",
    AktiefonderSverigeHavstang = "AktiefonderSverigeHavstang",
    AktiefonderTillvaxtmarknader = "AktiefonderTillvaxtmarknader",
    Blandfonder = "Blandfonder",
    Fondportfoljer = "Fondportfoljer",
    Hedgefonder = "Hedgefonder",
    RantefonderForetag = "RantefonderForetag",
    RantefonderKorta = "RantefonderKorta",
    RantefonderLanga = "RantefonderLanga",
    RantefonderReala = "RantefonderReala",
    RantefonderUtland = "RantefonderUtland",
    RantefonderValutaexponering = "RantefonderValutaexponering",
}

export enum LineOfBusinessSubCategory {
    EjSatt = "EjSatt",
    AAktier = "AAktier",
    AktiefondIndexnara = "AktiefondIndexnara",
    AktiefondSmaMedelstoraBolag = "AktiefondSmaMedelstoraBolag",
    BlandfondFlexibel = "BlandfondFlexibel",
    BlandfondForsiktig = "BlandfondForsiktig",
    BlandfondKapitalskyddande = "BlandfondKapitalskyddande",
    BlandfondBalanserad = "BlandfondBalanserad",
    BranschfondBioteknik = "BranschfondBioteknik",
    BranschfondFastighetsbolag = "BranschfondFastighetsbolag",
    BranschfondInfrastruktur = "BranschfondInfrastruktur",
    BranschfondKommunikation = "BranschfondKommunikation",
    BranschfondKonsument = "BranschfondKonsument",
    BranschfondLakemedel = "BranschfondLakemedel",
    BranschfondMiljo = "BranschfondMiljo",
    BranschfondNyTeknik = "BranschfondNyTeknik",
    BranschfondOnoterat = "BranschfondOnoterat",
    BranschfondVattenresurser = "BranschfondVattenresurser",
    BranschfondAdelmetaller = "BranschfondAdelmetaller",
    BranschfondFinans = "BranschfondFinans",
    FondportfoljKapitalskyddande = "FondportfoljKapitalskyddande",
    HedgefondLangKort = "HedgefondLangKort",
    HedgefondMarknadsneutral = "HedgefondMarknadsneutral",
    HedgefondModellbaseradTerminshandel = "HedgefondModellbaseradTerminshandel",
    HedgefondMultistrategi = "HedgefondMultistrategi",
}

export interface FundResponse extends FundLightResponse {
    ucits?: boolean | undefined;
    morningstarCategory?: string | undefined;
    inceptionDate?: string | undefined;
    latestNav?: NavResponse | undefined;
    totalMarketValueCurrency?: string | undefined;
    totalMarketValue?: number;
    fundManager?: string | undefined;
    investmentStrategy?: string | undefined;
    primaryIndex?: string | undefined;
    currency?: string | undefined;
    managementType?: ManagementType;
    riskAndRatings?: RiskAndRatingResponse[] | undefined;
    riskStatistics?: RiskStatisticsResponse | undefined;
    assetAllocation?: AssetAllocationResponse | undefined;
    largestHoldings?: LargestHoldingResponse[] | undefined;
    stockSectorBreakdown?: StockSectorBreakdownResponse | undefined;
    regionalExposure?: RegionalExposureResponse | undefined;
    documents?: FundDocumentResponse[] | undefined;
}

export interface NavResponse {
    value?: number;
    valueDate?: string;
    lastPriceCurrency?: string | undefined;
}

export enum ManagementType {
    NotSet = "NotSet",
    Active = "Active",
    Passive = "Passive",
    Unknown = "Unknown",
}

export interface RiskAndRatingResponse {
    timePeriod?: string | undefined;
    ratingValue?: number | undefined;
    riskRatingValue?: number | undefined;
    performanceRatingValue?: number | undefined;
}

export interface RiskStatisticsResponse {
    alpha?: RiskStatisticResponse | undefined;
    beta?: RiskStatisticResponse | undefined;
    rSquared?: RiskStatisticResponse | undefined;
}

export interface RiskStatisticResponse {
    value?: number;
}

export interface AssetAllocationResponse {
    stocks?: number | undefined;
    bonds?: number | undefined;
    cash?: number | undefined;
    other?: number | undefined;
    unclassified?: number | undefined;
}

export interface LargestHoldingResponse {
    name?: string | undefined;
    globalStockSector?: string | undefined;
    weighting?: number;
}

export interface StockSectorBreakdownResponse {
    id?: number;
    basicMaterials?: number | undefined;
    communicationServices?: number | undefined;
    consumerCyclical?: number | undefined;
    consumerDefensive?: number | undefined;
    healthcare?: number | undefined;
    industrials?: number | undefined;
    realEstate?: number | undefined;
    technology?: number | undefined;
    energy?: number | undefined;
    financialServices?: number | undefined;
    utilities?: number | undefined;
}

export interface RegionalExposureResponse {
    id?: number;
    unitedStates?: number | undefined;
    canada?: number | undefined;
    latinAmerica?: number | undefined;
    unitedKingdom?: number | undefined;
    eurozone?: number | undefined;
    europeExEuro?: number | undefined;
    europeEmerging?: number | undefined;
    africa?: number | undefined;
    middleEast?: number | undefined;
    japan?: number | undefined;
    australasia?: number | undefined;
    asiaDeveloped?: number | undefined;
    asiaEmerging?: number | undefined;
}

export interface FundDocumentResponse {
    encodedDocumentId?: string | undefined;
    fundDocumentType?: FundDocumentType;
}

export enum FundDocumentType {
    Prospectus = "Prospectus",
    UCITS_KIID = "UCITS_KIID",
    PRIIP_KID = "PRIIP_KID",
    UNKNOWN = "UNKNOWN",
}

export interface KeyValuePairOfStringAndNullableDecimal {
    key?: string | undefined;
    value?: number | undefined;
}

export interface Nav {
    id?: number;
    valueHolderId?: number;
    value?: number;
    valueDate?: string;
    isFictive?: boolean;
    created?: string;
    createdBy?: string | undefined;
    lastPriceCurrency?: string | undefined;
}

export enum Interval {
    Day = "Day",
    Week = "Week",
    Month = "Month",
}

export interface FundNewsItem {
    id?: number;
    externalId?: string | undefined;
    publicationDate?: string;
    title?: string | undefined;
    newsText?: string | undefined;
    language?: string | undefined;
    agency?: string | undefined;
    links?: FundNewsLink[] | undefined;
}

export interface FundNewsLink {
    id?: number;
    value?: string | undefined;
}

export interface BankIdSignResponse {
    orderRef?: string | undefined;
    autoStartToken?: string | undefined;
    qrToken?: string | undefined;
}

export interface SignEnvelopeRequest {
    envelopeId?: number;
    personOfficialId?: string | undefined;
}

export interface ServerInfo {
    build?: string | undefined;
    instance?: string | undefined;
}

export interface Case {
    caseId?: string | undefined;
    caseGroup?: CaseGroup;
    caseType?: CaseType;
    caseStatus?: CaseStatus;
    date?: string | undefined;
    lastModified?: string | undefined;
    person?: CasePerson | undefined;
    caseName?: string | undefined;
    insuranceOfficialId?: string | undefined;
    origin?: string | undefined;
}

export enum CaseGroup {
    Active = "Active",
    History = "History",
    Unhandled = "Unhandled",
    Default = "Default",
}

export enum CaseType {
    AllocationSimple = "AllocationSimple",
    AllocationPrinciple = "AllocationPrinciple",
    CreateLifeInsurance = "CreateLifeInsurance",
    InitiateLifeInsurance = "InitiateLifeInsurance",
    CompanyPensionPDepot = "CompanyPensionPDepot",
    CompanyPensionTDepot = "CompanyPensionTDepot",
    CompanySaving = "CompanySaving",
    CompanySavingDepot = "CompanySavingDepot",
    PrivatePension = "PrivatePension",
    PrivatePensionDepot = "PrivatePensionDepot",
    PrivateSaving = "PrivateSaving",
    PrivateSavingDepot = "PrivateSavingDepot",
    PensionPlan = "PensionPlan",
    StartOutpayment = "StartOutpayment",
    ChangeOutpayment = "ChangeOutpayment",
    StartOutpaymentFixedAmount = "StartOutpaymentFixedAmount",
    CreateMaiaAllocation = "CreateMaiaAllocation",
    Piggelin = "Piggelin",
    MoveIn = "MoveIn",
    DocumentMessage = "DocumentMessage",
    SustainabilityReportDocumentsMessage = "SustainabilityReportDocumentsMessage",
    UpdateOutpaymentDetails = "UpdateOutpaymentDetails",
}

export enum CaseStatus {
    New = "New",
    Stored = "Stored",
    WaitForSign = "WaitForSign",
    Error = "Error",
    Expired = "Expired",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Denied = "Denied",
    HealthDeclarationSigned = "HealthDeclarationSigned",
    HealthDeclarationNotSigned = "HealthDeclarationNotSigned",
    HealtDeclarationStart = "HealtDeclarationStart",
    HealtDeclarationClosed = "HealtDeclarationClosed",
    ManuallyHandled = "ManuallyHandled",
    Received = "Received",
    WaitForProcessing = "WaitForProcessing",
}

export interface CasePerson {
    name?: string | undefined;
    personOfficialId?: string | undefined;
    brokerCode?: string | undefined;
}

export interface InsuranceResponse {
    incaInsuranceId?: number;
    arcaInsuranceId?: number;
    arcaAgreementId?: number | undefined;
    officialId?: string | undefined;
    friendlyName?: string | undefined;
    isRiskInsurance?: boolean;
    employmentId?: number | undefined;
    marketValue?: number | undefined;
    pensionPlanGroupName?: string | undefined;
    ongoingTradeCount?: number;
    currentUserHasWriteAccess?: boolean;
    contract?: InsuranceContractReponse | undefined;
    currentPremiumAmount?: number | undefined;
    riskAssessment?: InsuranceHasActiveRiskAssessmentResponse | undefined;
    outpaymentDate?: string | undefined;
    outpaymentStatus?: OutPaymentStatus;
    roles?: InsuranceRolesResponse | undefined;
    status?: InsuranceStatus;
    amounts?: InsuranceAmountResponse | undefined;
    historyPremiums?: InsurancePremiumResponse[] | undefined;
    currentPremium?: InsurancePremiumResponse | undefined;
    product?: InsuranceProductResponse | undefined;
    agreement?: InsuranceAgreementResponse | undefined;
    inPaymentsAgreement?: InsuranceInPaymentsAgreementResponse | undefined;
    benefits?: InsuranceBenefitResponse[] | undefined;
    holdings?: InsuranceHoldingLightResponse[] | undefined;
    editableGroup?: InsuranceEditableGroupResponse | undefined;
    contractSubtype?: ContractSubtype | undefined;
    isSalaryChangeable?: boolean;
    isPcRisk?: boolean;
    bamId?: number | undefined;
    startDate?: string | undefined;
    isOwnerPostalCountryBlocked?: boolean;
}

export interface InsuranceContractReponse {
    contractStatus?: string | undefined;
    contractStartDate?: string | undefined;
}

export interface InsuranceHasActiveRiskAssessmentResponse {
    hasActiveCase?: boolean;
}

export enum OutPaymentStatus {
    UnLocked = "UnLocked",
    Started = "Started",
    Locked = "Locked",
}

export interface InsuranceRolesResponse {
    insured?: InsurancePersonReponse | undefined;
    owner?: InsurancePersonReponse | undefined;
    payee?: InsurancePersonReponse | undefined;
    pledgee?: InsurancePersonReponse | undefined;
    broker?: InsurancePersonReponse | undefined;
    customers?: InsurancePersonReponse[] | undefined;
}

export interface InsurancePersonReponse {
    arcaPersonId?: number;
    externalId?: number;
    officialId?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    personStatus?: PersonStatus;
    birthDate?: string | undefined;
    personType?: PersonType;
    electronicAddresses?: ElectronicAddressResponse[] | undefined;
    code?: string | undefined;
}

export enum PersonStatus {
    Active = "Active",
    Deceased = "Deceased",
    Expired = "Expired",
    NotSet = "NotSet",
}

export enum PersonType {
    PrivatePerson = "PrivatePerson",
    LegalPerson = "LegalPerson",
}

export interface ElectronicAddressResponse {
    value?: string | undefined;
    type?: ElectronicAddressType;
}

export enum ElectronicAddressType {
    Email = "Email",
    Fax = "Fax",
    Mobile = "Mobile",
    Homepage = "Homepage",
    Phone = "Phone",
    ElectronicInvoice = "ElectronicInvoice",
    Workmail = "Workmail",
    Workphone = "Workphone",
    CommissionEmail = "CommissionEmail",
    DispatchEmail = "DispatchEmail",
    PoAEmailRecipient = "PoAEmailRecipient",
    TransferRecipient = "TransferRecipient",
}

export enum InsuranceStatus {
    Applied = "Applied",
    InForce = "InForce",
    Cancelled = "Cancelled",
    OutPayment = "OutPayment",
    PaidUp = "PaidUp",
}

export interface InsuranceAmountResponse {
    totalOutPaymentAmount?: number | undefined;
    totalSavingsInPaymentAmount?: number | undefined;
    premiumPriceAmount?: number | undefined;
    acqusitionValue?: number | undefined;
    transactionExternalMovingAmount?: number | undefined;
    transactionCompensationExternalMovingAmount?: number | undefined;
}

export interface InsurancePremiumResponse {
    premiumLifeAmount?: number | undefined;
    premiumFreeAmount?: number | undefined;
    premiumDisabledAmount?: number | undefined;
    priceAmount?: number;
    priceEnd?: string;
    priceFrom?: string;
    priceTo?: string;
}

export interface InsuranceProductResponse {
    name?: string | undefined;
    productSubTypeName?: string | undefined;
    taxCategory?: TaxCategory | undefined;
    productGroup?: InsuranceProductGroup;
    sourceSystem?: SourceSystem;
    arcaProductId?: number | undefined;
}

export enum TaxCategory {
    K = "K",
    P = "P",
    T = "T",
}

export enum InsuranceProductGroup {
    PensionPlan = "PensionPlan",
    OccupationalPension = "OccupationalPension",
    StandAlone = "StandAlone",
    RiskInsurance = "RiskInsurance",
    Other = "Other",
}

export enum SourceSystem {
    Inca = "Inca",
    Genesis = "Genesis",
    Bam = "Bam",
}

export interface InsuranceAgreementResponse {
    arcaAgreementId?: number;
    agreementOfficialId?: string | undefined;
    name?: string | undefined;
    isManagable?: boolean;
}

export interface InsuranceInPaymentsAgreementResponse {
    inPaymentFrequency?: InPaymentFrequency | undefined;
    inPaymentMethod?: string | undefined;
}

export enum InPaymentFrequency {
    HalfAYear = "HalfAYear",
    Month = "Month",
    Quarter = "Quarter",
    Year = "Year",
}

export interface InsuranceBenefitResponse {
    name?: string | undefined;
    typeAsString?: string | undefined;
    type?: BenefitType | undefined;
    calculationMethodName?: string | undefined;
    insurancePaymentTime?: number;
    outpaymentAmount?: number | undefined;
    paymentToDate?: string | undefined;
    paymentFromDate?: string;
    startDate?: string;
    calculationMethodAmount?: number | undefined;
    calculationMethodUnitType?: QuantityUnitType | undefined;
    status?: ContractStatus | undefined;
}

export enum BenefitType {
    CoveredExpensesAccident = "CoveredExpensesAccident",
    CoveredExpensesHealthCare = "CoveredExpensesHealthCare",
    CriticalIllness = "CriticalIllness",
    Death = "Death",
    DeathCapital = "DeathCapital",
    DeathCapitalAccident = "DeathCapitalAccident",
    Disable = "Disable",
    DisableCapital = "DisableCapital",
    Healthcare = "Healthcare",
    Life = "Life",
    PremiumFree = "PremiumFree",
    Unemployment = "Unemployment",
    AnonymousCoinsured = "AnonymousCoinsured",
    DisableCapitalDueToIllness = "DisableCapitalDueToIllness",
    TerminalIllness = "TerminalIllness",
    CoveredExpenses = "CoveredExpenses",
    DisableCapitalDueToAccident = "DisableCapitalDueToAccident",
    GenesisSurvivorsProtection = "GenesisSurvivorsProtection",
    GenesisPreTimeCapital = "GenesisPreTimeCapital",
    GenesisAccident = "GenesisAccident",
    GenesisDisable = "GenesisDisable",
    GenesisHealthCare = "GenesisHealthCare",
    GenesisChild = "GenesisChild",
    GenesisPremiumFree = "GenesisPremiumFree",
}

export interface QuantityUnitType {
    quantityUnitTypeId?: number | undefined;
    quantityUnitTypeAttributeName?: string | undefined;
    quantityUnitTypeName?: string | undefined;
    quantityUnitTypeSymbol?: string | undefined;
    type?: QuantityUnitTypeType;
    values?: QuantityUnitIndexValue[] | undefined;
}

export enum QuantityUnitTypeType {
    PBB = "PBB",
    FPBB = "FPBB",
    IBB = "IBB",
    PGI = "PGI",
    AnnualSalary = "AnnualSalary",
    Currency = "Currency",
    GSLR = "GSLR",
    SLR_1130 = "SLR_1130",
    Grunnbelop = "Grunnbelop",
    Arbejdsmarkedsbidrag = "Arbejdsmarkedsbidrag",
    Skataldersopsparing = "Skataldersopsparing",
    Danskskatkapitalindkomst = "Danskskatkapitalindkomst",
    Skatafkastfaktor = "Skatafkastfaktor",
    Maksindskudratepension = "Maksindskudratepension",
    Maksindskudaldersopsparing = "Maksindskudaldersopsparing",
    Maksindskudkapitalpension = "Maksindskudkapitalpension",
    SI = "SI",
    FSI = "FSI",
    KPI_09 = "KPI_09",
    Unknown = "Unknown",
}

export interface QuantityUnitIndexValue {
    value?: number | undefined;
    currency?: string | undefined;
}

export enum ContractStatus {
    Applied = "Applied",
    AppliedOutPayment = "AppliedOutPayment",
    AppliedReactivated = "AppliedReactivated",
    Cancelled = "Cancelled",
    InForce = "InForce",
    Obliterated = "Obliterated",
    OutPayment = "OutPayment",
    PendingCancellation = "PendingCancellation",
    PendingPayment = "PendingPayment",
    Quote = "Quote",
}

export interface InsuranceHoldingLightResponse {
    holderId?: number;
    holderName?: string | undefined;
    isCashAccount?: boolean;
    allocation?: number;
    holdingTotalAmountValue?: number;
    holdingTotalAcquisitionValue?: number;
    allocationRoundedPercentage?: number;
    fundQuantity?: number;
    allocationPrinciple?: number;
    fundUnitPrice?: number;
    valueHolderPriceDatetime?: string | undefined;
    subHoldings?: InsuranceHoldingLightResponse[] | undefined;
    fundType?: FundType;
}

export interface InsuranceEditableGroupResponse {
    canEndPremium?: boolean;
    canDoFundChange?: boolean;
    canChangePremium?: boolean;
}

export enum ContractSubtype {
    Benefit = "Benefit",
    InpaymentsAgreement = "InpaymentsAgreement",
    Insurance = "Insurance",
    ParentInsurance = "ParentInsurance",
}

export interface Envelope {
    officialId?: string | undefined;
    id?: number | undefined;
    itemId?: number;
    itemOfficialId?: string | undefined;
    modified?: string | undefined;
    type?: EnvelopeType;
    status?: Status;
    origin?: Origin;
    story?: Story | undefined;
    children?: Envelope[] | undefined;
    signature?: Signature | undefined;
    magnumGo?: MagnumGo | undefined;
    documentExternalId?: string | undefined;
}

export enum EnvelopeType {
    AllocationSimple = "AllocationSimple",
    AllocationAdvanced = "AllocationAdvanced",
    AllocationPrinciple = "AllocationPrinciple",
    CreateMaiaAllocationStory = "CreateMaiaAllocationStory",
    ChangePremium = "ChangePremium",
    ChangePremiumPlan = "ChangePremiumPlan",
    ExtraPremium = "ExtraPremium",
    PremiumEnded = "PremiumEnded",
    ChangePremiumPlans = "ChangePremiumPlans",
    NewEmploymentPlanStory = "NewEmploymentPlanStory",
    PremiumsEnded = "PremiumsEnded",
    EndEmployment = "EndEmployment",
    EndEmployments = "EndEmployments",
    PremiumDeferral = "PremiumDeferral",
    ChangePremiums = "ChangePremiums",
    CreateCoinsured = "CreateCoinsured",
    CreateSickInsurance = "CreateSickInsurance",
    CreateWaiverOfPremiumInsurance = "CreateWaiverOfPremiumInsurance",
    CreateFamilyProtectionInsurance = "CreateFamilyProtectionInsurance",
    CreateGroupInsurance = "CreateGroupInsurance",
    ChangeRiskSalary = "ChangeRiskSalary",
    ChangeRiskBenefitAmount = "ChangeRiskBenefitAmount",
    CancelRiskInsurance = "CancelRiskInsurance",
    SalaryPlan = "SalaryPlan",
    SalaryPlans = "SalaryPlans",
    PersonalList = "PersonalList",
    PrivatePerson = "PrivatePerson",
    PrivatePersonFromSpar = "PrivatePersonFromSpar",
    UpdateElectronicAddresses = "UpdateElectronicAddresses",
    LegalPerson = "LegalPerson",
    CreateExternalInvoice = "CreateExternalInvoice",
    PensionPlan = "PensionPlan",
    PensionPlanGroup = "PensionPlanGroup",
    PensionPlanProduct = "PensionPlanProduct",
    PensionPlanGroups = "PensionPlanGroups",
    PensionPlanFromTemplate = "PensionPlanFromTemplate",
    CreateLifeInsurance = "CreateLifeInsurance",
    PrivateSaving = "PrivateSaving",
    PrivatePension = "PrivatePension",
    CompanySaving = "CompanySaving",
    PrivatePensionDepot = "PrivatePensionDepot",
    PrivateSavingDepot = "PrivateSavingDepot",
    CompanySavingDepot = "CompanySavingDepot",
    CompanyPensionTDepot = "CompanyPensionTDepot",
    CompanyPensionPDepot = "CompanyPensionPDepot",
    InitiateLifeInsurance = "InitiateLifeInsurance",
    IndivudualInsuranceInformationStory = "IndivudualInsuranceInformationStory",
    AccidentInsuranceStory = "AccidentInsuranceStory",
    SickAndAccidentInsuranceStory = "SickAndAccidentInsuranceStory",
    MaiaOnboardingStory = "MaiaOnboardingStory",
    MaiaOffboardingStory = "MaiaOffboardingStory",
    StartOutpayment = "StartOutpayment",
    ChangePensionDate = "ChangePensionDate",
    UpdateOutpaymentDetails = "UpdateOutpaymentDetails",
    ChangeOutpayment = "ChangeOutpayment",
    FeeDiscountAdjustment = "FeeDiscountAdjustment",
    AddCompanyAdminRole = "AddCompanyAdminRole",
    TerminateCompanyAdminRole = "TerminateCompanyAdminRole",
    CreateTransferInformationOrder = "CreateTransferInformationOrder",
    CreateBrokerDelegate = "CreateBrokerDelegate",
    ChangeContractRetailAgreement = "ChangeContractRetailAgreement",
    ChangeContractRetailAgreements = "ChangeContractRetailAgreements",
    AmlPrivatePerson = "AmlPrivatePerson",
    AmlLegalPerson = "AmlLegalPerson",
    AmlContractStory = "AmlContractStory",
    AmlControllingPerson = "AmlControllingPerson",
    AmlPersonNoteStory = "AmlPersonNoteStory",
    CreateAmlUserForCompany = "CreateAmlUserForCompany",
    CreateAdminUserForCompany = "CreateAdminUserForCompany",
    TerminateAdminUserForCompany = "TerminateAdminUserForCompany",
    KnowYourCustomer = "KnowYourCustomer",
    KnowYourCustomerLegal = "KnowYourCustomerLegal",
    KnowYourCustomerPrivate = "KnowYourCustomerPrivate",
    RelocationAssistanceStory = "RelocationAssistanceStory",
    AmlControllingPersonV2 = "AmlControllingPersonV2",
    CreateControllingPerson = "CreateControllingPerson",
    CreateCompanyRepresentative = "CreateCompanyRepresentative",
    UpdateVerificationCode = "UpdateVerificationCode",
    PiggelinStory = "PiggelinStory",
    Unknown = "Unknown",
}

export enum Status {
    New = "New",
    Stored = "Stored",
    WaitForSign = "WaitForSign",
    Error = "Error",
    Expired = "Expired",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Denied = "Denied",
    Closed = "Closed",
    Open = "Open",
    Pending = "Pending",
}

export enum Origin {
    Unknown = "Unknown",
    TeckenTolkning = "TeckenTolkning",
    Customer = "Customer",
    Partner = "Partner",
    Ssek = "Ssek",
    Admin = "Admin",
    JustInCase = "JustInCase",
    Noa = "Noa",
    CompanyWeb = "CompanyWeb",
    Api = "Api",
}

export interface Story {
    officialId?: string | undefined;
    id?: number | undefined;
    itemId?: number;
    itemOfficialId?: string | undefined;
    modified?: string | undefined;
    type?: EnvelopeType;
    status?: Status;
    origin?: Origin;
    children?: Story[] | undefined;
}

export interface AllocationPrincipleStory extends Story {
    data?: AllocationPrincipleStoryData | undefined;
}

export interface AllocationPrincipleStoryData {
    maiaProposalId?: number | undefined;
    insuranceOfficialID?: string | undefined;
    allocationDetails?: AllocationDetail[] | undefined;
}

export interface AllocationDetail {
    valueHolderId?: number;
    valueHolderName?: string | undefined;
    allocation?: number;
}

export interface AllocationSimpleStory extends Story {
    data?: AllocationPrincipleStoryData | undefined;
}

export interface InitiateLifeInsuranceStory extends Story {
    data?: InitiateLifeInsuranceStoryData | undefined;
}

export interface InitiateLifeInsuranceStoryData {
    socialSecurityNumber?: string | undefined;
    brokerCode?: string | undefined;
    email?: string | undefined;
    defaultAmount?: number;
    initiatingEnvelopeId?: number | undefined;
    brokerName?: string | undefined;
    fullName?: string | undefined;
}

export interface CreateOutPaymentStory extends Story {
    personOfficialId?: string | undefined;
    insuranceOfficialId?: string | undefined;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    pensionDate?: string | undefined;
    paymentTimeInYears?: number | undefined;
    fixedAmount?: number | undefined;
    outPaymentType?: OutPaymentType;
    taxBasisPercent?: number | undefined;
    customerEmailAddress?: string | undefined;
}

export enum OutPaymentType {
    FixedAmount = "FixedAmount",
    FixedTime = "FixedTime",
    RemainingLife = "RemainingLife",
    Other = "Other",
}

export interface UpdateOutpaymentDetailsStory extends Story {
    personOfficialId?: string | undefined;
    insuranceOfficialId?: string | undefined;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    taxBasisPercent?: number | undefined;
}

export interface ChangeOutPaymentStory extends Story {
    insuranceOfficialId?: string | undefined;
    paymentTimeInYears?: number | undefined;
    fixedAmount?: number | undefined;
    outPaymentType?: OutPaymentType | undefined;
}

export interface Signature {
    id?: number;
    personId?: number | undefined;
    signatureType?: NoaSignatureType;
    signed?: string | undefined;
}

export enum NoaSignatureType {
    Implicit = "Implicit",
    Ok = "Ok",
    BankId = "BankId",
    Physical = "Physical",
    Attest = "Attest",
    PhysicalWithControl = "PhysicalWithControl",
}

export interface MagnumGo {
    piggelinId?: number;
    riskAssessmentCaseStatus?: RiskAssessmentCaseStatus;
    riskAssessmentCaseProgress?: RiskAssessmentCaseProgress;
    hasStartedInterview?: boolean;
}

export enum RiskAssessmentCaseStatus {
    Closed = "Closed",
    Open = "Open",
    Pending = "Pending",
}

export enum RiskAssessmentCaseProgress {
    Received = "Received",
    Inform = "Inform",
    Informed = "Informed",
    Reminded = "Reminded",
    Rejected = "Rejected",
    DigitalHealthDeclarationReceived = "DigitalHealthDeclarationReceived",
    DigitalHealthDeclarationSigned = "DigitalHealthDeclarationSigned",
    CreatingCaseInSweet = "CreatingCaseInSweet",
    CaseCreatedInSweet = "CaseCreatedInSweet",
}

export interface AgreementResponse {
    arcaAgreementId?: number;
    agreementOfficialId?: string | undefined;
    name?: string | undefined;
    owner?: PersonResponse | undefined;
    brokerPerson?: BrokerPersonResponse | undefined;
    isManagable?: boolean;
    retailAgreement?: RetailAgreementResponse | undefined;
    agreementDetails?: AgreementDetailsResponse | undefined;
}

export interface PersonResponse {
    arcaPersonId?: number;
    officialId?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    personType?: PersonType;
    externalId?: number;
    postalAddresses?: PostalAddressResponse[] | undefined;
    electronicAddresses?: ElectronicAddressResponse[] | undefined;
}

export interface PostalAddressResponse {
    primary?: boolean;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    type?: PostalAddressType;
    incaId?: number | undefined;
}

export enum PostalAddressType {
    Regular = "Regular",
    CareOf = "CareOf",
    PosteRestante = "PosteRestante",
}

export interface BrokerPersonResponse {
    code?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
}

export interface RetailAgreementResponse {
    businessAgreementId?: number | undefined;
    businessAgreementName?: string | undefined;
}

export interface AgreementDetailsResponse {
    inPaymentMethod?: string | undefined;
    inPaymentFrequency?: InPaymentFrequency | undefined;
    holdingAmount?: number | undefined;
    inPaymentAddressIncaId?: number | undefined;
    totalPremium?: number | undefined;
    insuranceCount?: number | undefined;
    isInPaymentPremieCentral?: boolean;
}

export interface ImpersonateModel {
    userNameToImpersonate?: string | undefined;
    userType?: string | undefined;
    arcaAgreementId?: number | undefined;
    arcaInsuranceId?: number | undefined;
    personId?: number | undefined;
    isBam?: boolean | undefined;
}

export interface BamResponse {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    bamType?: BamType;
    value?: number | undefined;
    arcaInsuranceId?: number | undefined;
    arcaAgreementId?: number | undefined;
}

export enum BamType {
    Anstallda = "Anstallda",
    PremieBefriade = "PremieBefriade",
}

export interface BamRequest {
    arcaInsuranceId?: number;
    benefitAgreementContractId?: number;
    employmentCount?: number | undefined;
    employmentFrom?: string | undefined;
    waiverOfPremiumCount?: number | undefined;
    waiverOfPremiumFrom?: string | undefined;
}

export interface BrokerNumbers {
    brokerCode?: string | undefined;
    numberOfCompanies?: number | undefined;
    numberOfInsurances?: number | undefined;
    numberOfInsurancesLastYear?: number | undefined;
    numberOfAgreements?: number | undefined;
    premiumsPerMonth?: BrokerRecurringPremium[] | undefined;
    holdingAmount?: number | undefined;
    holdingAmountLastYear?: number | undefined;
    updatedDate?: string | undefined;
    numberOfInsurancesWithPremiumLastYear?: number | undefined;
    numberOfInsurancesWithPremium?: number | undefined;
}

export interface BrokerRecurringPremium {
    premium?: number;
    snapshotDate?: string;
    updatedDate?: string;
}

export interface TopListEntry {
    name?: string | undefined;
    value?: number;
    updatedDate?: string;
}

export interface MisLifeVersionRequest {
    misLifeVersionType?: MisLifeVersionType;
}

export enum MisLifeVersionType {
    Version162 = "Version162",
    Version200 = "Version200",
}

export interface MislifeOrder {
    id?: number;
    arcaBrokerId?: number;
    generated?: boolean;
    versionType?: MisLifeVersionType;
    requestDate?: string | undefined;
    generatedDate?: string | undefined;
    fileName?: string | undefined;
}

export interface BrokerRegionContactResponse {
    name?: string | undefined;
    email?: string | undefined;
    region?: string | undefined;
}

export interface OfferPlanResponse {
    name?: string | undefined;
    code?: string | undefined;
}

export interface CreateOfferResponse {
    disabledAmount?: number | undefined;
    familyPensionAmount?: number | undefined;
    dividendSickAmount?: number | undefined;
    pensionPlanAmount?: number | undefined;
    premiumExcemptionAmount?: number | undefined;
    healthInsuranceAmount?: number | undefined;
    tglTfoAmount?: number | undefined;
    totalAmount?: number | undefined;
    brokerName?: string | undefined;
    plan?: string | undefined;
    companyName?: string | undefined;
    companyOrgNumber?: string | undefined;
    employees?: CreateOfferEmployeeResponse[] | undefined;
    documentExternalId?: string;
}

export interface CreateOfferEmployeeResponse {
    fullName?: string | undefined;
    salary?: number;
    age?: number;
    personalNumber?: string | undefined;
    disabledPremium?: number | undefined;
    disabledAmounts?: DisabledAmounts | undefined;
    healthInsurancePremium?: number | undefined;
    familyPension?: number | undefined;
    familyPensionAmount?: number | undefined;
    dividendSickPremium?: number | undefined;
    dividendSickAmount?: number | undefined;
    premiumExcemption?: number | undefined;
    premiumExcemtionAmount?: number | undefined;
    tglTfoPremium?: number | undefined;
    planAmount?: number | undefined;
    totalAmount?: number | undefined;
}

export interface DisabledAmounts {
    _3m?: number | undefined;
    _12m?: number | undefined;
    r?: number | undefined;
}

export interface CreateOfferRequest {
    broker?: string | undefined;
    plan?: string | undefined;
    companyName?: string | undefined;
    companyOrgNumber?: string | undefined;
    premiumExcemption?: boolean;
    premiumExcemptionFrame?: OfferWithinFrame | undefined;
    familyPension?: boolean;
    familyPensionYears?: number | undefined;
    familyPensionFrame?: OfferWithinFrame | undefined;
    disabledInsurance?: boolean;
    disabledInsuranceFrame?: OfferWithinFrame | undefined;
    disabledInsuranceType?: OfferDisabledType | undefined;
    healthInsurance?: boolean;
    healthInsuranceType?: OfferHealthType | undefined;
    tgltfo?: boolean;
    tgltfoType?: OfferTglTfoType | undefined;
    dividendsick?: boolean;
    dividendsickType?: OfferDividendSickType | undefined;
    employees?: OfferEmployee[] | undefined;
}

export enum OfferWithinFrame {
    WithinFrame = "WithinFrame",
    OutsideFrame = "OutsideFrame",
}

export enum OfferDisabledType {
    ITP = "ITP",
    ITPKOMP = "ITPKOMP",
    MAXSJUK = "MAXSJUK",
    KONS = "KONS",
}

export enum OfferHealthType {
    Smart = "Smart",
    Optimal = "Optimal",
    Other = "Other",
}

export enum OfferTglTfoType {
    TGL = "TGL",
    TGLTFO = "TGLTFO",
}

export enum OfferDividendSickType {
    _6M = "_6M",
    _12M = "_12M",
}

export interface OfferEmployee {
    fullName?: string | undefined;
    salary?: number;
    personalNumber?: string | undefined;
    planAmountPerMonth?: number | undefined;
    familyPensionAmountPerMonth?: number | undefined;
    dividendAmountPerMonth?: number | undefined;
}

export enum FormatType {
    Xml = "Xml",
    Csv = "Csv",
    Pdf = "Pdf",
}

export interface OutPaymentDetail {
    paymentDetailId?: number;
    outPaymentDate?: string;
}

export enum AccessRights {
    None = "None",
    Read = "Read",
    Write = "Write",
}

export interface ContractContainerResponse {
    agreements?: ContractAgreementResponse[] | undefined;
    insurances?: ContractInsuranceResponse[] | undefined;
}

export interface ContractAgreementResponse {
    arcaAgreementId?: number;
    pensionPlanPensionPlanGroups?: ContractPensionPlanGroupResponse[] | undefined;
    isInPaymentPremieCentral?: boolean | undefined;
    ownerArcaPersonId?: number | undefined;
    brokerPersonBrokerGroupName?: string | undefined;
    externalId?: number;
    officialId?: string | undefined;
    isManagable?: boolean;
    isGenesisAgreement?: boolean;
    holdingAmount?: number | undefined;
    totalPremium?: number | undefined;
    name?: string | undefined;
    inPaymentFrequency?: InPaymentFrequency | undefined;
    inPaymentMethod?: string | undefined;
}

export interface ContractPensionPlanGroupResponse {
    id?: number | undefined;
    name?: string | undefined;
    externalId?: number | undefined;
    products?: ContractPensionPlanGroupTermProductResponse[] | undefined;
}

export interface ContractPensionPlanGroupTermProductResponse {
    isOnetimePremiumPaymentIncaProduct?: boolean;
    premiumCalculationMethod?: PremiumCalculationMethodType | undefined;
    isDirectlyTunedMooseWithHugeHorns?: boolean;
    canChangeSalary?: boolean;
}

export enum PremiumCalculationMethodType {
    SalaryToPremiumTable = "SalaryToPremiumTable",
    SalaryToPremiumTableBasedOnExisting = "SalaryToPremiumTableBasedOnExisting",
    SimpleCalculationMethod = "SimpleCalculationMethod",
    StandardCalculationMethod = "StandardCalculationMethod",
}

export interface ContractInsuranceResponse {
    arcaInsuranceId?: number;
    arcaAgreementId?: number | undefined;
    agreementOfficialId?: string | undefined;
    productProductGroup?: InsuranceProductGroup | undefined;
    productSourceSystem?: SourceSystem | undefined;
    productName?: string | undefined;
    productSubTypeName?: string | undefined;
    insuredArcaPersonId?: number | undefined;
    insuredFullName?: string | undefined;
    insuredOfficialId?: string | undefined;
    insuredBirthDate?: string | undefined;
    status?: InsuranceStatus;
    ownerPersonType?: string | undefined;
    ownerArcaPersonId?: number | undefined;
    ownerOfficialId?: string | undefined;
    ownerName?: string | undefined;
    officialId?: string | undefined;
    marketValue?: number | undefined;
    currentPremiumPriceAmount?: number | undefined;
}

export interface CreateLifeInsuranceStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    insuranceOfficialId?: string | undefined;
    sendToRisk?: boolean;
    envelopeId?: number | undefined;
}

export enum StoryStatus {
    New = "New",
    Stored = "Stored",
    WaitForSign = "WaitForSign",
    Error = "Error",
    Expired = "Expired",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Denied = "Denied",
    ManuallyHandled = "ManuallyHandled",
    Processing = "Processing",
}

export interface StoryMessage {
    text?: string | undefined;
    type?: MessageType;
}

export enum MessageType {
    Information = "Information",
    Error = "Error",
    Fatal = "Fatal",
}

export interface InitiateLifeInsuranceStoryCommand {
    socialSecurityNumber?: string | undefined;
    brokerCode?: string | undefined;
    email?: string | undefined;
    defaultAmount?: number;
    initiatingEnvelopeId?: number | undefined;
    brokerName?: string | undefined;
    fullName?: string | undefined;
    assistant?: string | undefined;
}

export interface DigitalLifePrice {
    amount?: number | undefined;
    price?: number | undefined;
    isCustom?: boolean | undefined;
}

export interface DigitalLifePriceRequest {
    personOfficialId?: string | undefined;
    isSmoker?: boolean;
    monthlySalary?: number | undefined;
    initiatedLifeInsurance?: boolean;
    amounts?: DigitalLifePrice[] | undefined;
}

export interface DocumentResponse {
    fileName?: string | undefined;
    externalId?: string;
}

export interface PartnerDocumentResponse {
    brokerCode?: string | undefined;
    personOfficialId?: string | undefined;
    name?: string[] | undefined;
    documentTypeName?: string | undefined;
    created?: string;
    externalId?: string;
}

export interface PartnerDocumentSearchRequest {
    search?: string | undefined;
    types?: string[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export interface PartnerDocumentTypeResponse {
    code?: string | undefined;
    name?: string | undefined;
}

export interface GroupedByYearInvoicesResponse {
    year?: number;
    groupedByMonthInvoices?: GroupedByMonthInvoicesResponse[] | undefined;
}

export interface GroupedByMonthInvoicesResponse {
    month?: number;
    invoices?: InvoiceDocumentResponse[] | undefined;
}

export interface InvoiceDocumentResponse {
    fileName?: string | undefined;
    documentId?: number;
    externalId?: string;
    typeCode?: string | undefined;
    created?: string;
    periodFromDate?: string | undefined;
    periodToDate?: string | undefined;
    amount?: number | undefined;
    expirationDate?: string | undefined;
    invoiceNumber?: string | undefined;
    hasAccess?: boolean;
    documentTypeName?: string | undefined;
}

export interface QuickDocumentSearchResponse {
    groups?: QuickDocumentGroupResponse[] | undefined;
    subGroups?: QuickDocumentSubGroupResponse[] | undefined;
    result?: QuickDocumentResponse[] | undefined;
}

export interface QuickDocumentGroupResponse {
    id?: string | undefined;
    name?: string | undefined;
    subGroups?: QuickDocumentSubGroupResponse[] | undefined;
}

export interface QuickDocumentSubGroupResponse {
    id?: string | undefined;
    name?: string | undefined;
}

export interface QuickDocumentResponse {
    id?: number;
    name?: string | undefined;
    permaId?: string | undefined;
    dateUpdated?: string | undefined;
    groups?: QuickDocumentGroupResponse[] | undefined;
    subGroups?: QuickDocumentSubGroupResponse[] | undefined;
    isPdf?: boolean;
}

export interface SalaryPlanStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: SalaryPlanStoryValidationResult[] | undefined;
    riskAssessments?: HasActiveRiskAssessment[] | undefined;
}

export interface SalaryPlanStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    incaEmploymentId?: number;
}

export interface HasActiveRiskAssessment {
    incaPersonId?: number;
    hasActiveCase?: boolean;
}

export interface EmploymentTerm {
    employmentId?: number;
    currentSalary?: number | undefined;
    salary?: number | undefined;
    reportedDate?: string | undefined;
    fromDate?: string | undefined;
    riskAssesment?: RiskAssesment;
}

export enum RiskAssesment {
    Full = "Full",
    NeedsWork = "NeedsWork",
}

export interface PremiumPlanStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: PremiumPlanStoryValidationResult[] | undefined;
    riskAssessments?: HasActiveRiskAssessment[] | undefined;
}

export interface PremiumPlanStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    incaEmploymentId?: number;
}

export interface EmploymentAdjustment {
    employmentId?: number;
    currentPremium?: number | undefined;
    premium?: number | undefined;
    reportedDate?: string | undefined;
    fromDate?: string | undefined;
    riskAssesment?: RiskAssesment;
}

export interface EmploymentEndStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: EmploymentEndStoryValidationResult[] | undefined;
}

export interface EmploymentEndStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    incaEmploymentId?: number;
}

export interface EmploymentEnd {
    employmentId?: number;
    endDate?: string;
    reportedDate?: string | undefined;
}

export interface EmploymentAddStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: EmploymentAddStoryValidationResult[] | undefined;
}

export interface EmploymentAddStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    incaPersonId?: number;
    personOfficialId?: string | undefined;
}

export interface EmploymentAdd {
    legalPersonId?: number;
    pensionPlanId?: number;
    pensionPlanGroupId?: number;
    personOfficialId?: string | undefined;
    incaPersonId?: number;
    insuranceProductId?: number | undefined;
    employmentExternalId?: string | undefined;
    from?: string | undefined;
    salary?: number | undefined;
    premium?: number | undefined;
    reportedDate?: string | undefined;
    isFullyWorking?: boolean | undefined;
    riskClassId?: number | undefined;
    isCollective?: boolean | undefined;
    isBusinessman?: boolean | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    isOneTimePayment?: boolean;
    oneTimePaymentPremium?: number | undefined;
}

export interface EmploymentResponse {
    employmentId?: number | undefined;
    arcaAgreementId?: number;
    employedToDate?: string | undefined;
    latestEmploymentAdjustmentPremium?: number | undefined;
    latestEmploymentTermsRiskAssesment?: RiskAssesment | undefined;
    latestEmploymentAdjustmentCurrentPremium?: number | undefined;
    latestEmploymentTermsSalary?: number | undefined;
    latestEmploymentTermsCurrentSalary?: number | undefined;
    latestChangedDate?: string | undefined;
    status?: EmploymentStatus | undefined;
    pensionPlanGroupId?: number;
    ownerFirstName?: string | undefined;
    ownerName?: string | undefined;
    ownerOfficialId?: string | undefined;
    ownerExternalId?: number | undefined;
    latestReportedDate?: string | undefined;
    insurances?: EmploymentInsuranceResponse[] | undefined;
}

export enum EmploymentStatus {
    InForce = "InForce",
    Ended = "Ended",
    Removed = "Removed",
}

export interface EmploymentInsuranceResponse {
    arcaInsuranceId?: number;
    incaInsuranceId?: number;
    arcaAgreementId?: number | undefined;
    officialId?: string | undefined;
    currentPremiumPriceEnd?: string | undefined;
    currentPremiumPriceAmount?: number | undefined;
    productSourceSystem?: SourceSystem | undefined;
    productSubType?: string | undefined;
    currentUserHasWriteAccess?: boolean;
    productSubTypeId?: number | undefined;
    productName?: string | undefined;
    productArcaProductId?: number | undefined;
    isPcRisk?: boolean;
    employmentId?: number | undefined;
    agreementIsManagable?: boolean | undefined;
    canEndPremium?: boolean;
    isRiskInsurance?: boolean;
    ongoingTradeCount?: number;
    canDoFundChange?: boolean;
    outpaymentStatus?: OutPaymentStatus;
    status?: InsuranceStatus;
    insuredFullName?: string | undefined;
    insuredOfficialId?: string | undefined;
    contractStatus?: string | undefined;
}

export interface FundChangeStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: FundChangeStoryValidationResult[] | undefined;
    envelopeId?: number | undefined;
}

export interface FundChangeStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
}

export interface FundChange {
    holdings?: InsuranceHolding[] | undefined;
    electronicAddresses?: ElectronicAddressModel[] | undefined;
    changeCurrentDistribution?: boolean;
    marketValue?: number | undefined;
    arcaInsuranceId?: number;
    arcaInsuranceRoleInsuredPersonId?: number | undefined;
    insuranceOfficialId?: string | undefined;
    isTrading?: boolean;
    ongoingTradeCount?: number;
    insuredPersonName?: string | undefined;
    personsWithCustomerRole?: PersonModel[] | undefined;
    signingPersonId?: number;
    isOwnerPostalCountryBlocked?: boolean;
}

export interface InsuranceHolding {
    holderId?: number;
    holderName?: string | undefined;
    holdingTotalAcquisitionValue?: number;
    holdingTotalAmountValue?: number;
    valueHolderPriceDatetime?: string | undefined;
    allocation?: number;
    allocationPrinciple?: number;
    fundQuantity?: number;
    fundUnitPrice?: number;
    allocationRoundedPercentage?: number;
    fundType?: FundType;
    ongoingCharge?: number | undefined;
    srri?: number;
    closeType?: ValueHolderCloseType;
    isCashAccount?: boolean;
    excludeFromReallocation?: boolean;
    isMonthlyTraded?: boolean;
    holdingType?: ValueHoldingType;
    isInOffer?: boolean;
    subHoldings?: InsuranceHolding[] | undefined;
}

export enum ValueHoldingType {
    Fund = "Fund",
    Portfolio = "Portfolio",
    MovesticPortfolio = "MovesticPortfolio",
    TradingAccount = "TradingAccount",
    Cash = "Cash",
    Unknown = "Unknown",
}

export interface ElectronicAddressModel {
    arcaId?: number;
    value?: string | undefined;
    type?: ElectronicAddressType;
}

export interface PersonModel {
    externalId?: number;
    arcaPersonId?: number;
    officialId?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
    electronicAddresses?: ElectronicAddressModel[] | undefined;
    postalAddresses?: PostalAddressModel[] | undefined;
    personType?: PersonType;
    personStatus?: PersonStatus;
    contactName?: string | undefined;
    companyType?: string | undefined;
    sniCode?: string | undefined;
    birthDate?: string | undefined;
}

export interface PostalAddressModel {
    arcaId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    primary?: boolean;
    type?: PostalAddressType;
    incaId?: number | undefined;
}

export interface ValueHolderAllocation {
    valueHolderId?: number | undefined;
    name?: string | undefined;
    percentage?: number | undefined;
}

export interface ExtraPremiumPlanStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
}

export interface FullPremiumInvoice {
    list?: PremiumInvoice[] | undefined;
}

export interface PremiumInvoice {
    contractId?: number;
    periodFrom?: string;
    periodTo?: string;
    amount?: number;
}

export interface InsuranceTransaction {
    contractTransactionId?: number;
    contractId?: number;
    completedDatetime?: string | undefined;
    completedDatetimeString?: string | undefined;
    icon?: string | undefined;
    expandable?: boolean;
    orderedDatetime?: string | undefined;
    completedAmount?: number | undefined;
    contractTransactionStatus?: TransactionStatus;
    name?: string | undefined;
    officialId?: string | undefined;
    parentTransactionId?: number | undefined;
    subTransactions?: InsuranceTransaction[] | undefined;
    contractTransactionSubtype?: ContractTransactionSubtype | undefined;
    requestedCompletionDate?: string | undefined;
    categoryType?: InsuranceTransactionCategoryType | undefined;
    categoryName?: string | undefined;
    grossAmount?: number;
    taxAmount?: number;
    outpaymentAmount?: number;
}

export enum TransactionStatus {
    AttestationRequired = "AttestationRequired",
    Cancelled = "Cancelled",
    CancelRequested = "CancelRequested",
    Created = "Created",
    Executed = "Executed",
    Ordered = "Ordered",
    Queued = "Queued",
    ReversalOrdered = "ReversalOrdered",
    Reversed = "Reversed",
}

export enum ContractTransactionSubtype {
    AccruedEventFeePremium = "AccruedEventFeePremium",
    AccruedFeeImportedValue = "AccruedFeeImportedValue",
    AmbTaxTransaction = "AmbTaxTransaction",
    AutomaticReallocation = "AutomaticReallocation",
    AutomaticReallocationRebalance = "AutomaticReallocationRebalance",
    BonusOutPayment = "BonusOutPayment",
    BufferFee = "BufferFee",
    CancelCca = "CancelCca",
    CashAccountCorrection = "CashAccountCorrection",
    CashAccountInterest = "CashAccountInterest",
    CashAccountWriteOff = "CashAccountWriteOff",
    CommissionBalanceTransaction = "CommissionBalanceTransaction",
    CommissionOutPayment = "CommissionOutPayment",
    ContractOutPayment = "ContractOutPayment",
    ContractOutPaymentReclaim = "ContractOutPaymentReclaim",
    ContractOutPaymentRedemption = "ContractOutPaymentRedemption",
    CorporateActionCompensation = "CorporateActionCompensation",
    CorporateActionDividend = "CorporateActionDividend",
    CorrectionForGainOrLossAtDeath = "CorrectionForGainOrLossAtDeath",
    CorrCorporateActionDividend = "CorrCorporateActionDividend",
    CorrCustomerBonus = "CorrCustomerBonus",
    CorrCustomerCompensation = "CorrCustomerCompensation",
    CorrNavQuote = "CorrNavQuote",
    CorrPremiumWaiverCompensation = "CorrPremiumWaiverCompensation",
    CorrValue = "CorrValue",
    DeathCompensationReserveOutPayment = "DeathCompensationReserveOutPayment",
    DebitedPriceDetailRisk = "DebitedPriceDetailRisk",
    DebitedPriceDetailRiskReimbursement = "DebitedPriceDetailRiskReimbursement",
    DebitedPriceDetailValueByDirectCcaDeposit = "DebitedPriceDetailValueByDirectCcaDeposit",
    DebitedPriceDetailValueOptional = "DebitedPriceDetailValueOptional",
    DebitedPriceDetailValueOptionalReimbursement = "DebitedPriceDetailValueOptionalReimbursement",
    DelayedInternalOrderCompletionByUnitStock = "DelayedInternalOrderCompletionByUnitStock",
    DpdValueContractualTargetPrice = "DpdValueContractualTargetPrice",
    DpdValueContractualTargetPriceReimbursement = "DpdValueContractualTargetPriceReimbursement",
    DpdValueInvoicedExtraPremium = "DpdValueInvoicedExtraPremium",
    DpdValueInvoicedExtraPremiumReimbursement = "DpdValueInvoicedExtraPremiumReimbursement",
    DpdValueOptionalFromInsurance = "DpdValueOptionalFromInsurance",
    DpdValueOptionalFromInsuranceReimbursement = "DpdValueOptionalFromInsuranceReimbursement",
    EndPortfolioHolding = "EndPortfolioHolding",
    ExportedValueExternal = "ExportedValueExternal",
    ExportedValueExternalEu = "ExportedValueExternalEu",
    ExportedValueExternalGroupPurchase = "ExportedValueExternalGroupPurchase",
    ExportedValueInternal = "ExportedValueInternal",
    ExportedValueInternalGroupPurchase = "ExportedValueInternalGroupPurchase",
    ExternalBonus = "ExternalBonus",
    ExternalCompensation = "ExternalCompensation",
    ExternalContractTransaction = "ExternalContractTransaction",
    ExternalCorrection = "ExternalCorrection",
    ExternalDividend = "ExternalDividend",
    ExternalFundOrderCompletedAndConfirmedDifference = "ExternalFundOrderCompletedAndConfirmedDifference",
    FeeAdministrative = "FeeAdministrative",
    FeeCommission = "FeeCommission",
    FeeExport = "FeeExport",
    FeeExternalValueHolder = "FeeExternalValueHolder",
    FeeExternalValueHolderDetail = "FeeExternalValueHolderDetail",
    FeeGuarantee = "FeeGuarantee",
    FeeImport = "FeeImport",
    FeeInheritanceGain = "FeeInheritanceGain",
    FeeManual = "FeeManual",
    FeeManualAdministrative = "FeeManualAdministrative",
    FeeManualCommission = "FeeManualCommission",
    FeePeriodicFee = "FeePeriodicFee",
    FeePremium = "FeePremium",
    FeeReleasedRiskSumPremiumWaiver = "FeeReleasedRiskSumPremiumWaiver",
    FeeRiskDeath = "FeeRiskDeath",
    FeeRiskDeathCapital = "FeeRiskDeathCapital",
    FeeRiskDisable = "FeeRiskDisable",
    FeeRiskPremiumWaiver = "FeeRiskPremiumWaiver",
    FeeSurrender = "FeeSurrender",
    FeeTransactionYieldTax = "FeeTransactionYieldTax",
    FeeValueHolder = "FeeValueHolder",
    FeeValueHolderAdministrative = "FeeValueHolderAdministrative",
    FeeValueHolderCommission = "FeeValueHolderCommission",
    FeeValueHolderDepot = "FeeValueHolderDepot",
    FeeValueHolderPortfolio = "FeeValueHolderPortfolio",
    FeeValueHolderPortfolioDetail = "FeeValueHolderPortfolioDetail",
    FeeVat = "FeeVat",
    FeeYieldTax = "FeeYieldTax",
    FeeYieldTaxRedemption = "FeeYieldTaxRedemption",
    FeeYieldTaxReversalToPolicyholderCollective = "FeeYieldTaxReversalToPolicyholderCollective",
    ForcedValueHolderReallocation = "ForcedValueHolderReallocation",
    FundFeeDiscount = "FundFeeDiscount",
    GuaranteeCompensation = "GuaranteeCompensation",
    GuaranteeOutPayment = "GuaranteeOutPayment",
    ImportedValueByDirectCcaDeposit = "ImportedValueByDirectCcaDeposit",
    ImportedValueExternal = "ImportedValueExternal",
    ImportedValueExternalCompensation = "ImportedValueExternalCompensation",
    ImportedValueExternalEu = "ImportedValueExternalEu",
    ImportedValueExternalGroupPurchase = "ImportedValueExternalGroupPurchase",
    ImportedValueInternal = "ImportedValueInternal",
    ImportedValueInternalGroupPurchase = "ImportedValueInternalGroupPurchase",
    ImportOutPayment = "ImportOutPayment",
    InstantInternalOrderCompletionByUnitStock = "InstantInternalOrderCompletionByUnitStock",
    InternalCompensation = "InternalCompensation",
    OutPaymentTransferTransaction = "OutPaymentTransferTransaction",
    PaidRiskSumDeath = "PaidRiskSumDeath",
    PaidRiskSumDisable = "PaidRiskSumDisable",
    PaidRiskSumPremiumWaiver = "PaidRiskSumPremiumWaiver",
    PartialExportedValue = "PartialExportedValue",
    PremiumReclaimCorrection = "PremiumReclaimCorrection",
    PremiumReimbursement = "PremiumReimbursement",
    PremiumReimbursementCorrection = "PremiumReimbursementCorrection",
    PremiumRiskSumPurchase = "PremiumRiskSumPurchase",
    PremiumRiskSumRedemption = "PremiumRiskSumRedemption",
    PremiumValueTransferFrom = "PremiumValueTransferFrom",
    PremiumValueTransferTo = "PremiumValueTransferTo",
    PurchaseDebitedPriceDetailTransaction = "PurchaseDebitedPriceDetailTransaction",
    PurchaseImportedValue = "PurchaseImportedValue",
    PurchaseReleasedRiskSumPremiumWaiver = "PurchaseReleasedRiskSumPremiumWaiver",
    PurchaseTransaction = "PurchaseTransaction",
    PurchaseValueTransaction = "PurchaseValueTransaction",
    ReallocationTransaction = "ReallocationTransaction",
    RedemptionAndUnitTransferValueTransferFrom = "RedemptionAndUnitTransferValueTransferFrom",
    RedemptionContractOutPayment = "RedemptionContractOutPayment",
    RedemptionCorporateActionCompensation = "RedemptionCorporateActionCompensation",
    RedemptionCorporateActionDividend = "RedemptionCorporateActionDividend",
    RedemptionDebitedPriceDetailTransaction = "RedemptionDebitedPriceDetailTransaction",
    RedemptionExportedValue = "RedemptionExportedValue",
    RedemptionPremiumReimbursement = "RedemptionPremiumReimbursement",
    RedemptionReleasedRiskSumPremiumWaiver = "RedemptionReleasedRiskSumPremiumWaiver",
    RedemptionRiskSumRedemption = "RedemptionRiskSumRedemption",
    RedemptionSurrender = "RedemptionSurrender",
    RedemptionTransaction = "RedemptionTransaction",
    RedemptionValueTransaction = "RedemptionValueTransaction",
    RedemptionValueTransferFrom = "RedemptionValueTransferFrom",
    RefundablePal = "RefundablePal",
    ReimbValueRedemption = "ReimbValueRedemption",
    RiskPremiumCompensation = "RiskPremiumCompensation",
    RiskSumPurchase = "RiskSumPurchase",
    RiskSumRedemption = "RiskSumRedemption",
    SalaryPaymentTransaction = "SalaryPaymentTransaction",
    SavingsPremiumCompensation = "SavingsPremiumCompensation",
    SolvencyAdjustment = "SolvencyAdjustment",
    SurForcedSurrender = "SurForcedSurrender",
    SurFullSurrender = "SurFullSurrender",
    SurManualOutPaymentDeath = "SurManualOutPaymentDeath",
    SurManualOutPaymentLife = "SurManualOutPaymentLife",
    SurPartialSurrender = "SurPartialSurrender",
    TaxAccountOutPayment = "TaxAccountOutPayment",
    TradeAccountOrderRowTransaction = "TradeAccountOrderRowTransaction",
    TradPeriodicReallocationTransaction = "TradPeriodicReallocationTransaction",
    TradStabilizationReallocationTransaction = "TradStabilizationReallocationTransaction",
    UnitAndValueTransferTo = "UnitAndValueTransferTo",
    UnitStockTargetLevel = "UnitStockTargetLevel",
    UnitStockTradingResult = "UnitStockTradingResult",
    ValueHolderPortfolioAdministrative = "ValueHolderPortfolioAdministrative",
    ValueHolderPortfolioManagement = "ValueHolderPortfolioManagement",
    ValueHolderPortfolioPeriodicReallocation = "ValueHolderPortfolioPeriodicReallocation",
    ValueHolderPortfolioProvision = "ValueHolderPortfolioProvision",
    ValueHolderPortfolioReallocation = "ValueHolderPortfolioReallocation",
    ValueHolderPriceCorrectionTransaction = "ValueHolderPriceCorrectionTransaction",
    ValueHolderSplit = "ValueHolderSplit",
    ValueManagerReallocation = "ValueManagerReallocation",
    ValueMigrationTransaction = "ValueMigrationTransaction",
    ValueTransferFrom = "ValueTransferFrom",
    ValueTransferTo = "ValueTransferTo",
    ZeroCashAccount = "ZeroCashAccount",
    LegacyDelayedUnitStockAdjustment = "LegacyDelayedUnitStockAdjustment",
    LegacyInstantUnitStockAdjustment = "LegacyInstantUnitStockAdjustment",
    UnitStockAdjustmentTransaction = "UnitStockAdjustmentTransaction",
    UnitStockOrderForInternalOrderTransaction = "UnitStockOrderForInternalOrderTransaction",
    UnitStockOrderOrderedAndCompletedDifference = "UnitStockOrderOrderedAndCompletedDifference",
    DebitedPriceDetailGuarantyIndexPremium = "DebitedPriceDetailGuarantyIndexPremium",
    ReturnedRefund = "ReturnedRefund",
    UnitStockFxPriceDifference = "UnitStockFxPriceDifference",
    UnitStockSpreadInAmount = "UnitStockSpreadInAmount",
    UnitStockSpreadInUnits = "UnitStockSpreadInUnits",
    DebitedPriceDetailGuarantyIndexPremiumReimbursement = "DebitedPriceDetailGuarantyIndexPremiumReimbursement",
    ExportedValueExternalViaBenefitAgreement = "ExportedValueExternalViaBenefitAgreement",
    ImportedValueExternalViaBenefitAgreement = "ImportedValueExternalViaBenefitAgreement",
    CcaUnitTransferFrom = "CcaUnitTransferFrom",
    CcaUnitTransferTo = "CcaUnitTransferTo",
    DirectCcaWithdrawal = "DirectCcaWithdrawal",
    FeeRiskCapitalAdjustment = "FeeRiskCapitalAdjustment",
    Reclaim = "Reclaim",
    SimpleUnitTransfer = "SimpleUnitTransfer",
    FundMerge = "FundMerge",
    UnitStockFundMergeFrom = "UnitStockFundMergeFrom",
    UnitStockFundMergeTo = "UnitStockFundMergeTo",
    FeeExternal = "FeeExternal",
    FeeExternalAdministrative = "FeeExternalAdministrative",
    FeeExternalCommission = "FeeExternalCommission",
    UnitConversion = "UnitConversion",
    DebitedPriceDetailValueContractualReimbursementOnce = "DebitedPriceDetailValueContractualReimbursementOnce",
    DebitedPriceDetailValueContractualReimbursementPeriodic = "DebitedPriceDetailValueContractualReimbursementPeriodic",
    DebitedPriceDetailValueContractualOnce = "DebitedPriceDetailValueContractualOnce",
    DebitedPriceDetailValueContractualPeriodic = "DebitedPriceDetailValueContractualPeriodic",
    DpdValueInvoicedExternalPremiumReimbursementOnce = "DpdValueInvoicedExternalPremiumReimbursementOnce",
    DpdValueInvoicedExternalPremiumReimbursementPeriodic = "DpdValueInvoicedExternalPremiumReimbursementPeriodic",
    DpdValueOptionalFromInsuranceReimbursementOnce = "DpdValueOptionalFromInsuranceReimbursementOnce",
    DpdValueOptionalFromInsuranceReimbursementPeriodic = "DpdValueOptionalFromInsuranceReimbursementPeriodic",
    DpdValueInvoicedExternalPremiumOnce = "DpdValueInvoicedExternalPremiumOnce",
    DpdValueInvoicedExternalPremiumPeriodic = "DpdValueInvoicedExternalPremiumPeriodic",
}

export enum InsuranceTransactionCategoryType {
    Undefined = "Undefined",
    Fee = "Fee",
    YieldTax = "YieldTax",
    FundChange = "FundChange",
    InPayment = "InPayment",
    MoveInCapital = "MoveInCapital",
    OutPayment = "OutPayment",
    Dividend = "Dividend",
    Order = "Order",
    ReversedSavingsPremium = "ReversedSavingsPremium",
    CustomerBonus = "CustomerBonus",
    ShowIfNoSubtransactions = "ShowIfNoSubtransactions",
    FundChangeDiscount = "FundChangeDiscount",
}

export interface BenefitResponse {
    name?: string | undefined;
    typeAsString?: string | undefined;
    variantId?: number;
    type?: BenefitType | undefined;
    status?: ContractStatus | undefined;
    startDate?: string;
    endDate?: string | undefined;
    cancelledDate?: string | undefined;
    paymentFromDate?: string;
    paymentToDate?: string | undefined;
    paymentCalculatedStartAge?: number;
    benefitAmountPaymentType?: string | undefined;
    calculationMethodUnitType?: QuantityUnitType | undefined;
    paymentProcentageAsDecimal?: number;
    calculationMethodAmount?: number | undefined;
    benefitAmountQuantity?: number | undefined;
    appliedBenefitAmountQuantity?: number | undefined;
    calculationMethodName?: string | undefined;
    latestAppliedContractPrice?: ContractPriceResponse | undefined;
    latestContractPrice?: ContractPriceResponse | undefined;
    beneficiary?: BeneficiaryResponse | undefined;
    benefitValues?: BenefitValueResponse[] | undefined;
    contractPrices?: ContractPriceResponse[] | undefined;
    coInsured?: CoInsuredResponse | undefined;
    paymentFrequency?: string | undefined;
    amountPaymentTime?: number | undefined;
    ignoreVariant?: boolean;
}

export interface ContractPriceResponse {
    amount?: number;
    disabledPriceAmount90?: number | undefined;
    disabledPriceAmount360?: number | undefined;
    disabledPriceAmountR?: number | undefined;
    from?: string;
    to?: string;
}

export interface BeneficiaryResponse {
    type?: string | undefined;
    valueToRemoveFromType?: string | undefined;
    disposition?: boolean;
    cancelable?: boolean;
    privateProperty?: PrivateProperty;
}

export enum PrivateProperty {
    Changeable = "Changeable",
    No = "No",
    Text = "Text",
    Yes = "Yes",
}

export interface BenefitValueResponse {
    variantId?: number;
    title?: string | undefined;
    amount?: number | undefined;
    type?: BenefitValueType;
    contractPrices?: ContractPriceResponse[] | undefined;
    text?: string | undefined;
    date?: string;
    ignoreVariant?: boolean;
}

export enum BenefitValueType {
    Currency = "Currency",
    PBB = "PBB",
    Date = "Date",
    Text = "Text",
    Unknown = "Unknown",
}

export interface CoInsuredResponse {
    name?: string | undefined;
}

export interface ContractValueResponse {
    date?: string;
    value?: number | undefined;
    inOutAmount?: number | undefined;
    inAmount?: number | undefined;
    outAmount?: number | undefined;
}

export interface GenericStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
}

export interface RiskAssessmentResponse {
    employmentId?: number;
    incaInsuranceId?: number;
    hasActiveCase?: boolean;
}

export interface RiskAssessmentRequest {
    riskAssessmentIds?: RiskAssessmentId[] | undefined;
}

export interface RiskAssessmentId {
    incaInsuranceId?: number;
    employmentId?: number;
}

export interface MoveInModelResponse {
    person?: MoveInPersonResponse | undefined;
    pepPositionOptions?: AmlStringOption[] | undefined;
    pepInCountryOptions?: AmlStringOption[] | undefined;
    relationToPepOptions?: AmlStringOption[] | undefined;
    taxCountryOptions?: AmlStringOption[] | undefined;
}

export interface MoveInPersonResponse {
    officialId?: string | undefined;
    fullName?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
}

export interface CreateMoveInStoryResponse {
    envelopeId?: number;
    officialId?: string | undefined;
}

export interface MoveInDetailsRequest {
    externalInsuranceId?: string | undefined;
    externalInsuranceAmount?: number;
    externalInsuranceCompany?: string | undefined;
    externalInsuranceType?: string | undefined;
    insuranceOwner?: string | undefined;
    insurnaceOwnerCompanyName?: string | undefined;
    insurnaceOwnerOrganisationNumber?: string | undefined;
    insurnaceOwnerContactperson?: string | undefined;
    insurnaceOwnerEmail?: string | undefined;
    transferInsuranceOwner?: boolean;
    transferInsuranceOwnerName?: string | undefined;
    transferInsuranceOwnerOrganisationNumber?: string | undefined;
    destinationInsurance?: string | undefined;
    destinationInsuranceOfficialId?: string | undefined;
    destinationInsuranceInformation?: string | undefined;
    moveinAgreement?: string | undefined;
    moveInOtherInformation?: string | undefined;
    moveInOffer?: string | undefined;
    newPolicyHolderContactPerson?: string | undefined;
    newInsurance?: MoveInDetailsNewInsuranceRequest | undefined;
}

export interface MoveInDetailsNewInsuranceRequest {
    insuranceType?: string | undefined;
    feeAdministrative?: string | undefined;
    funds?: FundDetail[] | undefined;
    taxCountries?: AmlTaxCountry[] | undefined;
    isPep?: boolean | undefined;
    pepInCountry?: string | undefined;
    pepPosition?: string | undefined;
    rca?: boolean | undefined;
    rcaFirstNameOfPep?: string | undefined;
    rcaLastNameOfPep?: string | undefined;
    rcaInCountry?: string | undefined;
    rcaPepPosition?: string | undefined;
    rcaRelationToPep?: string | undefined;
    pensionAge?: number;
    outpaymentTime?: number;
    repayment?: boolean;
    repaymentBeneficiary?: string | undefined;
}

export interface FundDetail {
    name?: string | undefined;
    percentage?: number;
}

export interface AmlTaxCountry {
    countryCode?: string | undefined;
    tin?: string | undefined;
}

export interface BusinessAgreementGroupResponse {
    id?: number;
    groupName?: string | undefined;
    businessAgreements?: BusinessAgreementResponse[] | undefined;
}

export interface BusinessAgreementResponse {
    id?: number | undefined;
    name?: string | undefined;
    defaultRetailAgreementId?: number | undefined;
    availableInpaymentServices?: DefaultOptionOfInpaymentServiceTypeResponse[] | undefined;
    businessProductGroups?: BusinessProductGroupResponse[] | undefined;
    agreementProductId?: number | undefined;
    arcaAgreementId?: number | undefined;
    incaAgreementId?: number | undefined;
    agreementName?: string | undefined;
}

export interface DefaultOptionOfInpaymentServiceTypeResponse {
    option?: InpaymentServiceType;
    default?: boolean;
}

export enum InpaymentServiceType {
    Ocr = "Ocr",
    Autogiro = "Autogiro",
    PremieCentral = "PremieCentral",
}

export interface BusinessProductGroupResponse {
    id?: number;
    name?: string | undefined;
    businessProducts?: BusinessProductResponse[] | undefined;
}

export interface BusinessProductResponse {
    id?: number;
    name?: string | undefined;
    variantId?: number;
    productId?: number;
    productSubTypeName?: string | undefined;
    insuranceType?: InsuranceType | undefined;
    defaultAllocationPrinciples?: BusinessProductAllocationPrincipleResponse[] | undefined;
    feeConfiguration?: BusinessProductFeeConfigurationResponse[] | undefined;
    category?: ProductCategory | undefined;
    ownerType?: OwnerType | undefined;
    allowedCompanyTypesForOwner?: CompanyTypeAbbreviation[] | undefined;
    allowedCompanyTypesForEmployee?: CompanyTypeAbbreviation[] | undefined;
    availablePremiumTypes?: BusinessProductContractPremiumTypeResponse[] | undefined;
    availableAmountCalculationMethods?: BusinessBenefitAmountCalculationMethodResponse[] | undefined;
    availableSelectOptions?: BusinessProductSelectOptionResponse[] | undefined;
    baseCalculationTypes?: BaseCalculationType[] | undefined;
    usingSalaryPaymentContract?: boolean;
    contractPriceWithinParentPrice?: boolean | undefined;
    priceAdjustment?: number | undefined;
    benefits?: BusinessProductResponse[] | undefined;
    defaultPensionAge?: number | undefined;
    availablePremiumCalculationMethods?: BusinessBenefitPremiumCalculationMethodResponse[] | undefined;
    riskAssessmentRuleSet?: RiskAssessmentRuleSetType;
    pensionPlanProduct?: BusinessProductSubTypeResponse | undefined;
    availableRiskTypes?: RiskClassType[] | undefined;
    defaultPaymentTime?: number | undefined;
}

export enum InsuranceType {
    Plan = "Plan",
    Individual = "Individual",
}

export interface BusinessProductAllocationPrincipleResponse {
    valueHolderId?: number;
    percentage?: number;
}

export interface BusinessProductFeeConfigurationResponse {
    isDefault?: boolean;
    retailAgreement?: number;
    feeTypes?: BusinessProductFeeTypeResponse[] | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface BusinessProductFeeTypeResponse {
    feeTypeIds?: number[] | undefined;
    originalFee?: number;
    name?: string | undefined;
    canChange?: boolean;
}

export enum ProductCategory {
    Death = "Death",
    Life = "Life",
    PremiumFree = "PremiumFree",
    Disable = "Disable",
    Savings = "Savings",
    Risk = "Risk",
}

export enum OwnerType {
    Private = "Private",
    Company = "Company",
}

export enum CompanyTypeAbbreviation {
    Ab = "Ab",
    Ef = "Ef",
    Hb = "Hb",
    Kb = "Kb",
    St = "St",
}

export interface BusinessProductContractPremiumTypeResponse {
    premiumType?: ContractPremiumType;
    availablePremiumTerm?: PeriodType;
}

export enum ContractPremiumType {
    SinglePremium = "SinglePremium",
    ContractPremium = "ContractPremium",
    ContractualSinglePremium = "ContractualSinglePremium",
}

export enum PeriodType {
    HalfAYear = "HalfAYear",
    Month = "Month",
    Once = "Once",
    Quarter = "Quarter",
    Year = "Year",
}

export interface BusinessBenefitAmountCalculationMethodResponse {
    quantityCalculationMethodType?: QuantityCalculationMethodType;
    bnfAmtCmthdType?: BnfAmtCmthdType;
    isDefault?: boolean;
    benefitSimpleAmount?: number | undefined;
}

export enum QuantityCalculationMethodType {
    BeloppIForsakringsvalutaDf = "BeloppIForsakringsvalutaDf",
    AntalPrisBbdf = "AntalPrisBbdf",
    IndividuellPremiePremiejustering = "IndividuellPremiePremiejustering",
    FrilagdItpAlectaMaskinell = "FrilagdItpAlectaMaskinell",
    ItpLiknandeTrappa = "ItpLiknandeTrappa",
    FrilagdItpAlectaManuell = "FrilagdItpAlectaManuell",
    FrilagdItpSppManuell = "FrilagdItpSppManuell",
    FastBeloppIndividuelltVal = "FastBeloppIndividuelltVal",
    ProcentAvLonIndividuelltVal = "ProcentAvLonIndividuelltVal",
    AntalPrisBb = "AntalPrisBb",
    DelvisPremiebefriadPremie = "DelvisPremiebefriadPremie",
    FrilagdItpSppMaskinell = "FrilagdItpSppMaskinell",
    Forsakringskassan = "Forsakringskassan",
    BeloppIForsakringsValuta = "BeloppIForsakringsValuta",
    PremieProcentIbb4530 = "PremieProcentIbb4530",
    IndividuelltBeloppFastArligt = "IndividuelltBeloppFastArligt",
    ItpNiva90 = "ItpNiva90",
    ItpNiva360 = "ItpNiva360",
    ItpNivaR = "ItpNivaR",
    Kronor = "Kronor",
    AntalArslonerPgi = "AntalArslonerPgi",
    FullPbMedTak = "FullPbMedTak",
    KomplItpNiva90 = "KomplItpNiva90",
    KomplItpNiva360 = "KomplItpNiva360",
    KomplItpNivaR = "KomplItpNivaR",
    MaxNiva90 = "MaxNiva90",
    MaxNiva360 = "MaxNiva360",
    MaxNivaR = "MaxNivaR",
    KonsolideringsNiva90 = "KonsolideringsNiva90",
    KonsolideringsNiva360 = "KonsolideringsNiva360",
    KonsolideringsNivaR = "KonsolideringsNivaR",
    AntalInkomstbasbelopp = "AntalInkomstbasbelopp",
    AntalForhojdaPrisbasbelopp = "AntalForhojdaPrisbasbelopp",
    HeltPremiebefriadPremie = "HeltPremiebefriadPremie",
    Aterbetalningsskydd = "Aterbetalningsskydd",
    EjandringsbartIe30Pbb = "EjandringsbartIe30Pbb",
    EjandringsbartIe40Pbb = "EjandringsbartIe40Pbb",
    EjandringsbartIe50Pbb = "EjandringsbartIe50Pbb",
    Pro903090180 = "Pro903090180",
    Pro90360 = "Pro90360",
    Pro90R = "Pro90R",
    Pro1083090180 = "Pro1083090180",
    Pro108360 = "Pro108360",
    Pro108R = "Pro108R",
    Itp3090180 = "Itp3090180",
    Itp360 = "Itp360",
    ItpR = "ItpR",
    Itp90Pro3090180 = "Itp90Pro3090180",
    Itp90Pro360 = "Itp90Pro360",
    Itp90ProR = "Itp90ProR",
    FastBeloppSj = "FastBeloppSj",
    FastBeloppPb = "FastBeloppPb",
    GenItpSjuk90 = "GenItpSjuk90",
    GenItpSjuk360 = "GenItpSjuk360",
    GenItpSjukR = "GenItpSjukR",
    FrilagdItpkpaMaskinell = "FrilagdItpkpaMaskinell",
    DodsfallskapitalmedfastaPbbDk510152025354550Pbb = "DodsfallskapitalmedfastaPbbDk510152025354550Pbb",
    IndividuellnivaPrisbasbelopp = "IndividuellnivaPrisbasbelopp",
    Individuellniva = "Individuellniva",
    DodsfallskapitalmedfastaPbbDk3510152025Pbb = "DodsfallskapitalmedfastaPbbDk3510152025Pbb",
    DodsfallskapitalmedfastaPbbDk3610Pbb = "DodsfallskapitalmedfastaPbbDk3610Pbb",
    DodsfallskapitalmedfastaPbbDk4610Pbb = "DodsfallskapitalmedfastaPbbDk4610Pbb",
    EjandringsbartDk4Pbb = "EjandringsbartDk4Pbb",
    DodsfallskapitalmedfastaPbbDk51015Pbb = "DodsfallskapitalmedfastaPbbDk51015Pbb",
    DodsfallskapitalmedfastaPbbDk5101520304050Pbb = "DodsfallskapitalmedfastaPbbDk5101520304050Pbb",
    DodsfallskapitalmedfastaPbbDk51015202530Pbb = "DodsfallskapitalmedfastaPbbDk51015202530Pbb",
    DodsfallskapitalmedfastaPbbDk510152025304050Pbb = "DodsfallskapitalmedfastaPbbDk510152025304050Pbb",
    DodsfallskapitalmedfastaPbbDk510152025Pbb = "DodsfallskapitalmedfastaPbbDk510152025Pbb",
    DodsfallskapitalmedfastaPbbDk5101520Pbb = "DodsfallskapitalmedfastaPbbDk5101520Pbb",
    DodsfallskapitalmedfastaPbbDk51020304050Pbb = "DodsfallskapitalmedfastaPbbDk51020304050Pbb",
    DodsfallskapitalmedfastaPbbDk68101218Pbb = "DodsfallskapitalmedfastaPbbDk68101218Pbb",
    DodsfallskapitalmedfastaPbbDk6101530Pbb = "DodsfallskapitalmedfastaPbbDk6101530Pbb",
    DodsfallskapitalmedfastaPbbDk6101525Pbb = "DodsfallskapitalmedfastaPbbDk6101525Pbb",
    DodsfallskapitalmedfastaPbbDk610152025303540Pbb = "DodsfallskapitalmedfastaPbbDk610152025303540Pbb",
    DodsfallskapitalmedfastaPbbDk6101520Pbb = "DodsfallskapitalmedfastaPbbDk6101520Pbb",
    DodsfallskapitalmedfastaPbbDk61015Pbb = "DodsfallskapitalmedfastaPbbDk61015Pbb",
    DodsfallskapitalmedfastaPbbDk610203050Pbb = "DodsfallskapitalmedfastaPbbDk610203050Pbb",
    DodsfallskapitalmedfastaPbbDk61020Pbb = "DodsfallskapitalmedfastaPbbDk61020Pbb",
    DodsfallskapitalmedfastaPbbDk61218Pbb = "DodsfallskapitalmedfastaPbbDk61218Pbb",
    DodsfallskapitalmedfastaPbbDk7515Pbb = "DodsfallskapitalmedfastaPbbDk7515Pbb",
    DodsfallskapitalmedfastaPbbDk102030Pbb = "DodsfallskapitalmedfastaPbbDk102030Pbb",
    DodsfallskapitalmedfastaPbbDk1020304050Pbb = "DodsfallskapitalmedfastaPbbDk1020304050Pbb",
    EjandringsbartDk10Pbb = "EjandringsbartDk10Pbb",
    EjandringsbartDk15Pbb = "EjandringsbartDk15Pbb",
    DodsfallskapitalmedfastaFvDk200400800120016002000FvTkr = "DodsfallskapitalmedfastaFvDk200400800120016002000FvTkr",
    DodsfallskapitalmedfastaFvDk4001600FvTkr = "DodsfallskapitalmedfastaFvDk4001600FvTkr",
    DodsfallskapitalejandringsbarDk1000FvTkr = "DodsfallskapitalejandringsbarDk1000FvTkr",
    DodsfallskapitalejandringsbarDk1800FvTkr = "DodsfallskapitalejandringsbarDk1800FvTkr",
    FortidskapitalmedfastaPbbFk5101520Pbb = "FortidskapitalmedfastaPbbFk5101520Pbb",
    FortidskapitalmedfastaPbbFk610203050Pbb = "FortidskapitalmedfastaPbbFk610203050Pbb",
    FortidskapitalmedfastaPbbFk4610Pbb = "FortidskapitalmedfastaPbbFk4610Pbb",
    FortidskapitalmedfastaPbbFk5101520304050Pbb = "FortidskapitalmedfastaPbbFk5101520304050Pbb",
    FortidskapitalmedfastaPbbFk51015202530Pbb = "FortidskapitalmedfastaPbbFk51015202530Pbb",
    FortidskapitalmedfastaPbbFk510152025304050Pbb = "FortidskapitalmedfastaPbbFk510152025304050Pbb",
    FortidskapitalmedfastaPbbFk510152025Pbb = "FortidskapitalmedfastaPbbFk510152025Pbb",
    FortidskapitalmedfastaPbbFk510152025303545Pbb = "FortidskapitalmedfastaPbbFk510152025303545Pbb",
    FortidskapitalmedfastaPbbFk51015Pbb = "FortidskapitalmedfastaPbbFk51015Pbb",
    FortidskapitalmedfastaPbbFk6101520Pbb = "FortidskapitalmedfastaPbbFk6101520Pbb",
    FortidskapitalmedfastaPbbFk610152030Pbb = "FortidskapitalmedfastaPbbFk610152030Pbb",
    FortidskapitalmedfastaPbbFk6101520253540Pbb = "FortidskapitalmedfastaPbbFk6101520253540Pbb",
    FortidskapitalmedfastaPbbFk61020304050Pbb = "FortidskapitalmedfastaPbbFk61020304050Pbb",
    FortidskapitalmedfastaPbbFk61220Pbb = "FortidskapitalmedfastaPbbFk61220Pbb",
    FortidskapitalmedfastaPbbFk81220Pbb = "FortidskapitalmedfastaPbbFk81220Pbb",
    FortidskapitalmedfastaPbbFk102030Pbb = "FortidskapitalmedfastaPbbFk102030Pbb",
    FortidskapitalmedfastaPbbFk1020304050Pbb = "FortidskapitalmedfastaPbbFk1020304050Pbb",
    FortidskapitalmedfastaPbbFk1216202436Pbb = "FortidskapitalmedfastaPbbFk1216202436Pbb",
    FortidskapitalmedfastaPbbFk12203040Pbb = "FortidskapitalmedfastaPbbFk12203040Pbb",
    FortidskapitalmedfastaPbbFk12203050Pbb = "FortidskapitalmedfastaPbbFk12203050Pbb",
    FortidskapitalmedfastaPbbFk122436Pbb = "FortidskapitalmedfastaPbbFk122436Pbb",
    FortidskapitalmedfastaPbbFk1530Pbb = "FortidskapitalmedfastaPbbFk1530Pbb",
    FortidskapitalmedfastaFvFk200400800120016002000TkrFv = "FortidskapitalmedfastaFvFk200400800120016002000TkrFv",
    EjandringsbartFk12Pbb = "EjandringsbartFk12Pbb",
    EjandringsbartFk20Pbb = "EjandringsbartFk20Pbb",
    EjandringsbartFk30Pbb = "EjandringsbartFk30Pbb",
    FortidskapitalmedfastaPbbFk204060Pbb = "FortidskapitalmedfastaPbbFk204060Pbb",
    SjukersattningmedfastaFvSj68412168182425230336Tkr = "SjukersattningmedfastaFvSj68412168182425230336Tkr",
    SjukersattningmedfastaFvSj612182430TkrFv = "SjukersattningmedfastaFvSj612182430TkrFv",
    SjukersattningmedfastaFvSj61218TkrFv = "SjukersattningmedfastaFvSj61218TkrFv",
    SjukersattningmedfastaFvSj6121824TkrFv = "SjukersattningmedfastaFvSj6121824TkrFv",
    SjukersattningmedfastaFvSj78117156195234273312351390Hkr = "SjukersattningmedfastaFvSj78117156195234273312351390Hkr",
    SjukersattningmedfastaFvSj8416825233642504TkrFv = "SjukersattningmedfastaFvSj8416825233642504TkrFv",
    SjukersattningmedfastaFvSj8416825233642TkrFv = "SjukersattningmedfastaFvSj8416825233642TkrFv",
    SjukersattningmedfastaFvSj84168252336TkrFv = "SjukersattningmedfastaFvSj84168252336TkrFv",
    SjukersattningmedfastaFvSj8416825242TkrFv = "SjukersattningmedfastaFvSj8416825242TkrFv",
    SjukersattningmedfastaFvSj84168252TkrFv = "SjukersattningmedfastaFvSj84168252TkrFv",
    SjukersattningmedfastaFvSj168336TkrFv = "SjukersattningmedfastaFvSj168336TkrFv",
    EjandringsbartSj12000Fv = "EjandringsbartSj12000Fv",
    EjandringsbartSj18000Fv = "EjandringsbartSj18000Fv",
    InvaliditetsersattningolycksfallmedfastaPbbIe51015Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe51015Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe101520Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe101520Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe10152030Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe10152030Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe10152025Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe10152025Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe1015Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe1015Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe102025Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe102025Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe1020304050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe1020304050Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe1030Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe1030Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe15202540Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe15202540Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe1520304050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe1520304050Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe20304050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe20304050Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe203040Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe203040Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe2030Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe2030Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe2040Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe2040Pbb",
    EjandringsbartIe10Pbb = "EjandringsbartIe10Pbb",
    EjandringsbartIe15Pbb = "EjandringsbartIe15Pbb",
    EjandringsbartIe20Pbb = "EjandringsbartIe20Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe304050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe304050Pbb",
    InvaliditetsersattningolycksfallmedfastFvIe80016002200TkrFv = "InvaliditetsersattningolycksfallmedfastFvIe80016002200TkrFv",
    InvaliditetsersattningolycksfallmedfastFvIe8001600TkrFv = "InvaliditetsersattningolycksfallmedfastFvIe8001600TkrFv",
    InvaliditetsersattningolycksfallmedfastFvIe12002000TkrFv = "InvaliditetsersattningolycksfallmedfastFvIe12002000TkrFv",
    EjandringsbartDk05Pbb = "EjandringsbartDk05Pbb",
    EjandringsbartDk5Pbb = "EjandringsbartDk5Pbb",
    EjandringsbartIe25Pbb = "EjandringsbartIe25Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe3050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe3050Pbb",
    EjandringsbartDk6Pbb = "EjandringsbartDk6Pbb",
    InvaliditetsersattningejandringsbarIe900FvTkr = "InvaliditetsersattningejandringsbarIe900FvTkr",
    DodsfallskapitalmedfastaPbbDk10203050Pbb = "DodsfallskapitalmedfastaPbbDk10203050Pbb",
    EjandringsbartDk50Pbb = "EjandringsbartDk50Pbb",
    DodsfallskapitalejandringsbarDk500FvTkr = "DodsfallskapitalejandringsbarDk500FvTkr",
    DodsfallskapitalejandringsbarDk400FvTkr = "DodsfallskapitalejandringsbarDk400FvTkr",
    EjandringsbartDk30Pbb = "EjandringsbartDk30Pbb",
    KritisksjukdommedfastaPbbAs51015203040Pbb = "KritisksjukdommedfastaPbbAs51015203040Pbb",
    KritisksjukdommedfastaPbbAs510203040Pbb = "KritisksjukdommedfastaPbbAs510203040Pbb",
    KritisksjukdommedfastaFvAs50000100000200000400000Fv = "KritisksjukdommedfastaFvAs50000100000200000400000Fv",
    KritisksjukdommedfastaFvAs50000100000Fv = "KritisksjukdommedfastaFvAs50000100000Fv",
    KritisksjukdommedfastaFvAs50000Fv = "KritisksjukdommedfastaFvAs50000Fv",
    KritisksjukdommedfastaPbbAs5101520304050Pbb = "KritisksjukdommedfastaPbbAs5101520304050Pbb",
    AnonymmedforsakradfastaFvAmf12000002000000Fv = "AnonymmedforsakradfastaFvAmf12000002000000Fv",
    AnonymmedforsakradfastaPbbAmf304050Pbb = "AnonymmedforsakradfastaPbbAmf304050Pbb",
    AnonymmedforsakradfastaPbbAmf1520304050Pbb = "AnonymmedforsakradfastaPbbAmf1520304050Pbb",
    AnonymmedforsakradfastaPbbAmf30Pbb = "AnonymmedforsakradfastaPbbAmf30Pbb",
    EjandringsbartIe5Pbb = "EjandringsbartIe5Pbb",
    DodsfallskapitalmedfastaFvDk500100015002000FvTkr = "DodsfallskapitalmedfastaFvDk500100015002000FvTkr",
    DodsfallskapitalmedfastaFvFk500100015002000FvTkr = "DodsfallskapitalmedfastaFvFk500100015002000FvTkr",
    InvaliditetsersattningolycksfallmedfastFvIe1000150020002500TkrFv = "InvaliditetsersattningolycksfallmedfastFvIe1000150020002500TkrFv",
    AnonymmedforsakradfastaFvAmf10000001500000Fv = "AnonymmedforsakradfastaFvAmf10000001500000Fv",
    DodsfallskapitalmedfastaPbbDk56101520304050Pbb = "DodsfallskapitalmedfastaPbbDk56101520304050Pbb",
    DodsfallskapitalmedfastaPbbDk1561020304050Pbb = "DodsfallskapitalmedfastaPbbDk1561020304050Pbb",
    FortidskapitalmedfastaPbbFk51020304050Pbb = "FortidskapitalmedfastaPbbFk51020304050Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe31020304050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe31020304050Pbb",
    InvaliditetsersattningolycksfallmedfastaPbbIe620304050Pbb = "InvaliditetsersattningolycksfallmedfastaPbbIe620304050Pbb",
    AnonymmedforsakradfastaPbbAmf1020304050Pbb = "AnonymmedforsakradfastaPbbAmf1020304050Pbb",
    KritisksjukdommedfastaPbbAs520Pbb = "KritisksjukdommedfastaPbbAs520Pbb",
    SjukersattningmedfastaFvSj12182430364248546072Tkr = "SjukersattningmedfastaFvSj12182430364248546072Tkr",
    DodsfallskapitalmedfastaFvDk3005001000150020002500FvTkr = "DodsfallskapitalmedfastaFvDk3005001000150020002500FvTkr",
    InvaliditetsersattningolycksfallmedfastFvIe5001000150020002500TkrFv = "InvaliditetsersattningolycksfallmedfastFvIe5001000150020002500TkrFv",
    InvaliditetsersattningolycksfallmedfastFvIe500100015002000TkrFv = "InvaliditetsersattningolycksfallmedfastFvIe500100015002000TkrFv",
    AnonymmedforsakradfastaFvAmf1000150020002500FvTkr = "AnonymmedforsakradfastaFvAmf1000150020002500FvTkr",
    Fk108Pro = "Fk108Pro",
    Fk90Pro = "Fk90Pro",
    Pro3090180 = "Pro3090180",
    Pro80360 = "Pro80360",
    Pro80R = "Pro80R",
    Fk80 = "Fk80",
    Itp90ProFk = "Itp90ProFk",
    ItpNivaFk = "ItpNivaFk",
    DodsfallskapitalejandringsbarDk900FvTkr = "DodsfallskapitalejandringsbarDk900FvTkr",
    EjandringsbartDko05Pbb = "EjandringsbartDko05Pbb",
    Itp80Pro3090180 = "Itp80Pro3090180",
    DodsfallskapitalmedfastaFvDk400500FvTkr = "DodsfallskapitalmedfastaFvDk400500FvTkr",
    Itp80Pro360 = "Itp80Pro360",
    DodsfallskapitalmedfastaPbbDk10203040Pbb = "DodsfallskapitalmedfastaPbbDk10203040Pbb",
    Itp80ProR = "Itp80ProR",
    Itp80ProFk = "Itp80ProFk",
    Itp80ProDfk = "Itp80ProDfk",
    Dfk80Pro = "Dfk80Pro",
    Dfk90Pro = "Dfk90Pro",
    Dfk108Pro = "Dfk108Pro",
    Itp90ProDfk = "Itp90ProDfk",
    MlItpNivaDfk = "MlItpNivaDfk",
    DodsfallskapitalejandringsbarDk20FvTkr = "DodsfallskapitalejandringsbarDk20FvTkr",
    DodsfallskapitalolycksfallmedfastaPbbDko10203040Pbb = "DodsfallskapitalolycksfallmedfastaPbbDko10203040Pbb",
    DodsfallskapitalmedfastaPbbDk51015202535404550Pbb = "DodsfallskapitalmedfastaPbbDk51015202535404550Pbb",
    KritisksjukdommedfastaPbbas51020304050Pbb = "KritisksjukdommedfastaPbbas51020304050Pbb",
    DödsfallskapitalmedfastaPbbdk610152030Pbb = "DödsfallskapitalmedfastaPbbdk610152030Pbb",
    FörtidskapitalmedfastaFvfk1000200030004000TkrFv = "FörtidskapitalmedfastaFvfk1000200030004000TkrFv",
    FörtidskapitalmedfastaPbbfk10203040Pbb = "FörtidskapitalmedfastaPbbfk10203040Pbb",
    FörtidskapitalmedfastaPbbfk510152025354550Pbb = "FörtidskapitalmedfastaPbbfk510152025354550Pbb",
    FörtidskapitalmedfastaPbbfk610152025303540Pbb = "FörtidskapitalmedfastaPbbfk610152025303540Pbb",
    InvaliditetsersättningolycksfallmedfastFvie10001500TkrFv = "InvaliditetsersättningolycksfallmedfastFvie10001500TkrFv",
    InvaliditetsersättningolycksfallmedfastaPbbie10152025304050Pbb = "InvaliditetsersättningolycksfallmedfastaPbbie10152025304050Pbb",
    InvaliditetsersättningolycksfallmedfastaPbbie102030Pbb = "InvaliditetsersättningolycksfallmedfastaPbbie102030Pbb",
    InvaliditetsersättningolycksfallmedfastaPbbie1020Pbb = "InvaliditetsersättningolycksfallmedfastaPbbie1020Pbb",
    InvaliditetsersättningolycksfallmedfastaPbbie152025304050Pbb = "InvaliditetsersättningolycksfallmedfastaPbbie152025304050Pbb",
    InvaliditetsersättningolycksfallmedfastaPbbie204050Pbb = "InvaliditetsersättningolycksfallmedfastaPbbie204050Pbb",
    InvaliditetsersättningolycksfallmedfastaPbbie510152025Pbb = "InvaliditetsersättningolycksfallmedfastaPbbie510152025Pbb",
    SjukersättningmedfastaFvsj121824TkrFv = "SjukersättningmedfastaFvsj121824TkrFv",
    AntalPrisBb430224 = "AntalPrisBb430224",
    AntalPrisBb430225 = "AntalPrisBb430225",
    AntalPrisBb430226 = "AntalPrisBb430226",
    AntalPrisBb430227 = "AntalPrisBb430227",
    AntalPrisBb430228 = "AntalPrisBb430228",
    AntalÅrslönerPgi = "AntalÅrslönerPgi",
    Amf20304050Pbb = "Amf20304050Pbb",
    Arsbelopp = "Arsbelopp",
    Ies30PBB = "Ies30PBB",
    Ies40PBB = "Ies40PBB",
    Ies50PBB = "Ies50PBB",
    Ies51015PBB = "Ies51015PBB",
    Ies101520PBB = "Ies101520PBB",
    Ies10152030PBB = "Ies10152030PBB",
    Ies10152025PBB = "Ies10152025PBB",
    Ies1015PBB = "Ies1015PBB",
    Ies102025PBB = "Ies102025PBB",
    Ies1020304050PBB = "Ies1020304050PBB",
    Ies1030PBB = "Ies1030PBB",
    Ies15202540PBB = "Ies15202540PBB",
    Ies1520304050PBB = "Ies1520304050PBB",
    Ies20304050PBB = "Ies20304050PBB",
    Ies203040PBB = "Ies203040PBB",
    Ies2030PBB = "Ies2030PBB",
    Ies2040PBB = "Ies2040PBB",
    Ies10PBB = "Ies10PBB",
    Ies15PBB = "Ies15PBB",
    Ies20PBB = "Ies20PBB",
    Ies304050PBB = "Ies304050PBB",
    Ies80016002200FV = "Ies80016002200FV",
    Ies8001600FV = "Ies8001600FV",
    Ies12002000FV = "Ies12002000FV",
    Ies25PBB = "Ies25PBB",
    Ies3050PBB = "Ies3050PBB",
    Ies900FV = "Ies900FV",
    Ies5PBB = "Ies5PBB",
    Ies1000150020002500FV = "Ies1000150020002500FV",
    Ies31020304050PBB = "Ies31020304050PBB",
    Ies620304050PBB = "Ies620304050PBB",
    Ies5001000150020002500FV = "Ies5001000150020002500FV",
    Ies500100015002000FV = "Ies500100015002000FV",
    Ies10001500FV = "Ies10001500FV",
    Ies10152025304050PBB = "Ies10152025304050PBB",
    Ies102030PBB = "Ies102030PBB",
    Ies1020PBB = "Ies1020PBB",
    Ies152025304050PBB = "Ies152025304050PBB",
    Ies204050PBB = "Ies204050PBB",
    Ies510152025PBB = "Ies510152025PBB",
    AntalPrisBB = "AntalPrisBB",
    FrilagdItpppMaskinell = "FrilagdItpppMaskinell",
    FrilagdItpppManuell = "FrilagdItpppManuell",
    IncomeProtection90days10653250GenIp90 = "IncomeProtection90days10653250GenIp90",
    IncomePlt15653250GenIplt = "IncomePlt15653250GenIplt",
    FullPremiumWaiveronly1dvs100AllowedFullPremiumWaiver100 = "FullPremiumWaiveronly1dvs100AllowedFullPremiumWaiver100",
    MlitpNiva90180dgrPcmlitpNiva90180dgrPc = "MlitpNiva90180dgrPcmlitpNiva90180dgrPc",
    MlitPniva360dgrPcmlitPniva360dgrPc = "MlitPniva360dgrPcmlitPniva360dgrPc",
    MlitPnivaRkarensPcmlitPnivaRkarensPc = "MlitPnivaRkarensPcmlitPnivaRkarensPc",
    MlMaxnivaRkarensPcmlMaxnivaRkarensPc = "MlMaxnivaRkarensPcmlMaxnivaRkarensPc",
    MlKomplItPniva90180dgrPcmlKomplItPniva90180dgrPc = "MlKomplItPniva90180dgrPcmlKomplItPniva90180dgrPc",
    MlKomplItPniva360dgrPcmlKomplItPniva360dgrPc = "MlKomplItPniva360dgrPcmlKomplItPniva360dgrPc",
    MlKomplItPnivaRkarensPcmlKomplItPnivaRkarensPc = "MlKomplItPnivaRkarensPcmlKomplItPnivaRkarensPc",
    MlMaxniva90180dgrPcmlMaxniva90180dgrPc = "MlMaxniva90180dgrPcmlMaxniva90180dgrPc",
    MlMaxniva360dgrPcmlMaxniva360dgrPc = "MlMaxniva360dgrPcmlMaxniva360dgrPc",
    MlitpNiva90180dgrMlitpNiva90180dgr = "MlitpNiva90180dgrMlitpNiva90180dgr",
    MlitPniva360dgrMlitPniva360dgr = "MlitPniva360dgrMlitPniva360dgr",
    MlitPnivaRkarensMlitPnivaRkarens = "MlitPnivaRkarensMlitPnivaRkarens",
    Individuellpremie = "Individuellpremie",
    FrilagdItpAlectaMaskinellIp = "FrilagdItpAlectaMaskinellIp",
    FrilagdItpAnnatbolagManuellIp = "FrilagdItpAnnatbolagManuellIp",
    FrilagdItpsppManuellIp = "FrilagdItpsppManuellIp",
    FrilagdItpsppMaskinellIp = "FrilagdItpsppMaskinellIp",
    FrilagdItpkpaMaskinellIp = "FrilagdItpkpaMaskinellIp",
    IndividuellnivaIp = "IndividuellnivaIp",
    FrilagdItpppMaskinellIp = "FrilagdItpppMaskinellIp",
    FrilagdItpppManuellIp = "FrilagdItpppManuellIp",
    DodsfallskapitalMedFastaPbb = "DodsfallskapitalMedFastaPbb",
    FastBeloppAr = "FastBeloppAr",
    PCKonsolideringsNiva360 = "PCKonsolideringsNiva360",
    PCKonsolideringsNiva90_180 = "PCKonsolideringsNiva90_180",
    PCKonsolideringsNivaRKarens = "PCKonsolideringsNivaRKarens",
}

export enum BnfAmtCmthdType {
    BasedOnExisting = "BasedOnExisting",
    BaseCalculationMethod = "BaseCalculationMethod",
    SimpleCalculationMethod = "SimpleCalculationMethod",
    StandardCalculationMethod = "StandardCalculationMethod",
}

export interface BusinessProductSelectOptionResponse {
    option?: SelectOptionType;
    default?: boolean;
}

export enum SelectOptionType {
    Optional = "Optional",
    Required = "Required",
    Standard = "Standard",
    Unavailable = "Unavailable",
}

export enum BaseCalculationType {
    Underlagdödlighet1 = "Underlagdödlighet1",
    Underlagdödlighet2 = "Underlagdödlighet2",
    Msjp90R = "Msjp90R",
    TradPb = "TradPb",
    MovesticÅpStd = "MovesticÅpStd",
    MovesticEsåsStd = "MovesticEsåsStd",
    MovesticPb90Mtgpb = "MovesticPb90Mtgpb",
    MovesticS360Mfsjuk = "MovesticS360Mfsjuk",
    MovesticS360Mf = "MovesticS360Mf",
    MovesticS360Nysjuk = "MovesticS360Nysjuk",
    MovesticS90Mfsjuk = "MovesticS90Mfsjuk",
    MovesticS90Mf = "MovesticS90Mf",
    MovesticS90Nysjuk = "MovesticS90Nysjuk",
    MovesticSrMfsjuk = "MovesticSrMfsjuk",
    MovesticSrMf = "MovesticSrMf",
    MovesticSrNysjuk = "MovesticSrNysjuk",
    MovesticPb9045 = "MovesticPb9045",
    MovesticPb9039 = "MovesticPb9039",
    MovesticPb9030 = "MovesticPb9030",
    MovesticPb90Max = "MovesticPb90Max",
    MovesticPb9027 = "MovesticPb9027",
    MovesticPb9000 = "MovesticPb9000",
    EkDemo = "EkDemo",
    Pb30Rak = "Pb30Rak",
    Pb34Rak = "Pb34Rak",
    Sjuk201890 = "Sjuk201890",
    Sjuk2018360 = "Sjuk2018360",
    Sjuk2018R = "Sjuk2018R",
    Pb295Rak = "Pb295Rak",
    FondutbetalningMovestic = "FondutbetalningMovestic",
    TradutangarantiutbetalningMovestic = "TradutangarantiutbetalningMovestic",
    Dödsfallskapital = "Dödsfallskapital",
    DödsfallskapitalTgl = "DödsfallskapitalTgl",
    SafloDröjsmålsränta = "SafloDröjsmålsränta",
    ItpitpkDröjsmålsränta = "ItpitpkDröjsmålsränta",
    IntervallPbRak = "IntervallPbRak",
    IntervallPb9030 = "IntervallPb9030",
    IntervallPb90Max = "IntervallPb90Max",
    IntervallMfmtg = "IntervallMfmtg",
    IntervallNysjuk = "IntervallNysjuk",
    IntervallMfsjuk = "IntervallMfsjuk",
    IntervallSjuk2018 = "IntervallSjuk2018",
    UWårPbRak = "UWårPbRak",
    UWårPb9030 = "UWårPb9030",
    UWårPb90Max = "UWårPb90Max",
    UWårMfmtg = "UWårMfmtg",
    UWårNysjuk = "UWårNysjuk",
    UWårMfsjuk = "UWårMfsjuk",
    UWårSjuk2018 = "UWårSjuk2018",
    MovesticItp2018Utbetalningsdödlighet = "MovesticItp2018Utbetalningsdödlighet",
    MovesticItp2018Arvsvinst = "MovesticItp2018Arvsvinst",
    IndividuellLivförsäkringKönsneutral20121221 = "IndividuellLivförsäkringKönsneutral20121221",
    IndividuellLivförsäkringKönsdifferentieradInnan20121221 = "IndividuellLivförsäkringKönsdifferentieradInnan20121221",
    IndividuellLivforsakringKonsneutral20121221 = "IndividuellLivforsakringKonsneutral20121221",
    Familjepension = "Familjepension",
    GruppforsakringLivforsakringOracleMedlemkr = "GruppforsakringLivforsakringOracleMedlemkr",
    GrupplivforsakringAdvokatfirmanCederqvistobligkr = "GrupplivforsakringAdvokatfirmanCederqvistobligkr",
    Gruppsjukforsakringfrom2012120130 = "Gruppsjukforsakringfrom2012120130",
    Gruppsjukforsakringfrom2012120190 = "Gruppsjukforsakringfrom2012120190",
    Gruppsjukforsakringfrom20121201180 = "Gruppsjukforsakringfrom20121201180",
    Gruppsjukforsakringfrom20121201360 = "Gruppsjukforsakringfrom20121201360",
    Gruppsjukforsakringfrom20121201R = "Gruppsjukforsakringfrom20121201R",
    GruppsjukforsakringTillaggsformanFortidsochdodsfallskapitalfrom20121201 = "GruppsjukforsakringTillaggsformanFortidsochdodsfallskapitalfrom20121201",
    Gruppsjukforsakringinnan2012120130 = "Gruppsjukforsakringinnan2012120130",
    Gruppsjukforsakringinnan2012120190 = "Gruppsjukforsakringinnan2012120190",
    Gruppsjukforsakringinnan20121201180 = "Gruppsjukforsakringinnan20121201180",
    Gruppsjukforsakringinnan20121201360 = "Gruppsjukforsakringinnan20121201360",
    Gruppsjukforsakringinnan20121201R = "Gruppsjukforsakringinnan20121201R",
    IndividuellSjukforsakringfrom20121201Konsneutral30 = "IndividuellSjukforsakringfrom20121201Konsneutral30",
    IndividuellSjukforsakringfrom20121201Konsneutral90 = "IndividuellSjukforsakringfrom20121201Konsneutral90",
    IndividuellSjukforsakringfrom20121201Konsneutral180 = "IndividuellSjukforsakringfrom20121201Konsneutral180",
    IndividuellSjukforsakringfrom20121201Konsneutral360 = "IndividuellSjukforsakringfrom20121201Konsneutral360",
    IndividuellSjukforsakringfrom20121201KonsneutralR = "IndividuellSjukforsakringfrom20121201KonsneutralR",
    IndividuellSjukforsakringfrom20121201Konsntillaggfortidsochdodsfkap = "IndividuellSjukforsakringfrom20121201Konsntillaggfortidsochdodsfkap",
    IndividuellSjukforsakringtom20121201Konsdifferentierad30 = "IndividuellSjukforsakringtom20121201Konsdifferentierad30",
    IndividuellSjukforsakringtom20121201Konsdifferentierad90 = "IndividuellSjukforsakringtom20121201Konsdifferentierad90",
    IndividuellSjukforsakringtom20121201Konsdifferentierad180 = "IndividuellSjukforsakringtom20121201Konsdifferentierad180",
    IndividuellSjukforsakringtom20121201Konsdifferentierad360 = "IndividuellSjukforsakringtom20121201Konsdifferentierad360",
    IndividuellSjukforsakringtom20121201KonsdifferentieradR = "IndividuellSjukforsakringtom20121201KonsdifferentieradR",
    Sjuk201830 = "Sjuk201830",
    Sjuk2018180 = "Sjuk2018180",
    Sjukforsakringforvinstutdelning30 = "Sjukforsakringforvinstutdelning30",
    Sjukforsakringforvinstutdelning90 = "Sjukforsakringforvinstutdelning90",
    Sjukforsakringforvinstutdelning180 = "Sjukforsakringforvinstutdelning180",
    Sjukforsakringforvinstutdelning360 = "Sjukforsakringforvinstutdelning360",
    Sjukforsakringforvinstutdelning720 = "Sjukforsakringforvinstutdelning720",
    SjukforsakringforvinstutdelningR = "SjukforsakringforvinstutdelningR",
    GruppforsakringLivforsakringCivilekonomernaMedlempbb = "GruppforsakringLivforsakringCivilekonomernaMedlempbb",
    GruppforsakringLivforsakringmedfortidskapitalCivilekonomernaMedlempbb = "GruppforsakringLivforsakringmedfortidskapitalCivilekonomernaMedlempbb",
    GruppforsakringOlycksfallsforsakringCivilekonomernaMedlempbb = "GruppforsakringOlycksfallsforsakringCivilekonomernaMedlempbb",
    GruppforsakringBarnforsakringCivilekonomernaMedlempbb = "GruppforsakringBarnforsakringCivilekonomernaMedlempbb",
    GruppforsakringSjukforsakringCivilekonomernaMedlemkr = "GruppforsakringSjukforsakringCivilekonomernaMedlemkr",
    GruppforsakringOlycksfallsforsakringCivilekonomernaMedlemkr = "GruppforsakringOlycksfallsforsakringCivilekonomernaMedlemkr",
    GruppforsakringBarnforsakringCivilekonomernaMedlemkr = "GruppforsakringBarnforsakringCivilekonomernaMedlemkr",
    GruppforsakringAllvarligsjukdomCivilekonomernaMedlempbb = "GruppforsakringAllvarligsjukdomCivilekonomernaMedlempbb",
    GruppforsakringLivforsakringCivilekonomernaMedlemkr = "GruppforsakringLivforsakringCivilekonomernaMedlemkr",
    GruppforsakringLivforsakringmedfkCivilekonomernaMedlemkr = "GruppforsakringLivforsakringmedfkCivilekonomernaMedlemkr",
    GruppforsakringAllvarligsjukdomCivilekonomernaMedlemkr = "GruppforsakringAllvarligsjukdomCivilekonomernaMedlemkr",
    GruppforsakringLivforsakringmeddubbeltfortidskapGolderAssociatespbb = "GruppforsakringLivforsakringmeddubbeltfortidskapGolderAssociatespbb",
    GruppforsakringSjukocholycksfallsforsakringGolderAssociatespbb = "GruppforsakringSjukocholycksfallsforsakringGolderAssociatespbb",
    GruppforsakringLivforsakringModernaForsakringarpbb = "GruppforsakringLivforsakringModernaForsakringarpbb",
    GruppforsakringFortidskapitalModernaForsakringarpbb = "GruppforsakringFortidskapitalModernaForsakringarpbb",
    GruppforsakringOlycksfallsforsakringModernaForsakringarpbb = "GruppforsakringOlycksfallsforsakringModernaForsakringarpbb",
    GruppforsakringSjukocholycksfallsforsakringModernaForsakringarpbb = "GruppforsakringSjukocholycksfallsforsakringModernaForsakringarpbb",
    GruppforsakringBarnforsakringModernaForsakringarpbb = "GruppforsakringBarnforsakringModernaForsakringarpbb",
    GruppforsakringSjukforsakringModernaForsakringarkr = "GruppforsakringSjukforsakringModernaForsakringarkr",
    GruppforsakringOlycksfallsforsakringSumerkr = "GruppforsakringOlycksfallsforsakringSumerkr",
    GruppforsakringOlycksfallforsakringbarnSumerkr = "GruppforsakringOlycksfallforsakringbarnSumerkr",
    GruppforsakringLivforsakringSumerkr = "GruppforsakringLivforsakringSumerkr",
    GruppforsakringSjukforsakringSumerkr = "GruppforsakringSjukforsakringSumerkr",
    GruppforsakringAllvarligsjukdomSumerkr = "GruppforsakringAllvarligsjukdomSumerkr",
    GruppforsakringLivforsakringSyngentaSeedspbb = "GruppforsakringLivforsakringSyngentaSeedspbb",
    GruppforsakringLivforsakringmedfkSyngentaSeedspbb = "GruppforsakringLivforsakringmedfkSyngentaSeedspbb",
    GruppforsakringSjukforsakringSyngentaSeedskr = "GruppforsakringSjukforsakringSyngentaSeedskr",
    GruppforsakringSjukocholycksfallsforsakringSyngentaSeedspbb = "GruppforsakringSjukocholycksfallsforsakringSyngentaSeedspbb",
    GruppforsakringBarnforsakringSyngentaSeedspbb = "GruppforsakringBarnforsakringSyngentaSeedspbb",
    GruppforsakringAllvarligsjukdomGrundskyddkr = "GruppforsakringAllvarligsjukdomGrundskyddkr",
    GruppforsakringOlycksfallsforsakringGrundskyddpbb = "GruppforsakringOlycksfallsforsakringGrundskyddpbb",
    GruppforsakringLivforsakringAcoNordicobligpbb = "GruppforsakringLivforsakringAcoNordicobligpbb",
    GruppforsakringOlycksfallsforsakringAcoNordicobligpbb = "GruppforsakringOlycksfallsforsakringAcoNordicobligpbb",
    GruppforsakringLivforsakringAcuschnetSverigeobligpbb = "GruppforsakringLivforsakringAcuschnetSverigeobligpbb",
    GruppforsakringOlycksfallsforsakringAcushnetSverigeobligpbb = "GruppforsakringOlycksfallsforsakringAcushnetSverigeobligpbb",
    GruppforsakringLivforsakringmfkAnxiousSwedenpbb = "GruppforsakringLivforsakringmfkAnxiousSwedenpbb",
    GruppforsakringOlycksfallsforsakringAnxiousSwedenpbb = "GruppforsakringOlycksfallsforsakringAnxiousSwedenpbb",
    GruppforsakringBarnforsakringAnxiousSwedenpbb = "GruppforsakringBarnforsakringAnxiousSwedenpbb",
    GruppforsakringLivforsakringApoteksgruppenpbb = "GruppforsakringLivforsakringApoteksgruppenpbb",
    GruppforsakringLivforsakringmfkApoteksgruppenpbb = "GruppforsakringLivforsakringmfkApoteksgruppenpbb",
    GruppforsakringOlycksfallsforsakringAutodeskpbb = "GruppforsakringOlycksfallsforsakringAutodeskpbb",
    GruppforsakringSjukocholycksfallsforsakringApoteksgruppenpbb = "GruppforsakringSjukocholycksfallsforsakringApoteksgruppenpbb",
    GruppforsakringBarnforsakringApoteksgruppenpbb = "GruppforsakringBarnforsakringApoteksgruppenpbb",
    GruppforsakringFortidskapitalApoteksgruppenpbb = "GruppforsakringFortidskapitalApoteksgruppenpbb",
    GruppforsakringSjukforsakringApoteksgruppenkr = "GruppforsakringSjukforsakringApoteksgruppenkr",
    GruppforsakringLivforsakringmdubbeltfkAutodeskpbb = "GruppforsakringLivforsakringmdubbeltfkAutodeskpbb",
    GruppforsakringSjukforsakringAutodeskkr = "GruppforsakringSjukforsakringAutodeskkr",
    GruppforsakringBarnforsakringAutodeskpbb = "GruppforsakringBarnforsakringAutodeskpbb",
    GruppforsakringLivforsakringAvlmtCpbb = "GruppforsakringLivforsakringAvlmtCpbb",
    GruppforsakringLivforsakringmfkAvlmtCpbb = "GruppforsakringLivforsakringmfkAvlmtCpbb",
    GruppforsakringOlycksfallsforsakringAvlmtCpbb = "GruppforsakringOlycksfallsforsakringAvlmtCpbb",
    GruppforsakringBarnforsakringAvlmtCpbb = "GruppforsakringBarnforsakringAvlmtCpbb",
    GruppforsakringSjukforsakringAvlmtCkr = "GruppforsakringSjukforsakringAvlmtCkr",
    GruppforsakringLivforsakringBarillapbb = "GruppforsakringLivforsakringBarillapbb",
    GruppforsakringLivforsakringmdubbeltfkBarillapbb = "GruppforsakringLivforsakringmdubbeltfkBarillapbb",
    GruppforsakringBarnforsakringBarillapbb = "GruppforsakringBarnforsakringBarillapbb",
    GruppforsakringOlycksfallsforsakringBarillapbb = "GruppforsakringOlycksfallsforsakringBarillapbb",
    GruppforsakringSjukocholycksfallsforsakringBarillapbb = "GruppforsakringSjukocholycksfallsforsakringBarillapbb",
    GruppforsakringSjukforsakringBarillakr = "GruppforsakringSjukforsakringBarillakr",
    GruppforsakringOlycksfallsforsakringBelanoMaskinobligpbb = "GruppforsakringOlycksfallsforsakringBelanoMaskinobligpbb",
    GruppforsakringOlycksfallsforsakringCapitalCoolingobligpbb = "GruppforsakringOlycksfallsforsakringCapitalCoolingobligpbb",
    GruppforsakringLivforsakring4CGroupobligkr = "GruppforsakringLivforsakring4CGroupobligkr",
    GruppforsakringLivforsakringCivilekonomernaAnstalldapbb = "GruppforsakringLivforsakringCivilekonomernaAnstalldapbb",
    GruppforsakringLivforsakringmfkCivilekonomernaAnstalldapbb = "GruppforsakringLivforsakringmfkCivilekonomernaAnstalldapbb",
    GruppforsakringLivforsakringmdubbeltfkCivilekonomernaAnstalldaoblig = "GruppforsakringLivforsakringmdubbeltfkCivilekonomernaAnstalldaoblig",
    GruppforsakringOlycksfallsforsakringCivilekonomernaAnstalldaobligpb = "GruppforsakringOlycksfallsforsakringCivilekonomernaAnstalldaobligpb",
    GruppforsakringBarnforsakringCivilekonomernaAnstalldapbb = "GruppforsakringBarnforsakringCivilekonomernaAnstalldapbb",
    GruppforsakringOlycksfallsforsakringCivilekonomernaAnstalldapbb = "GruppforsakringOlycksfallsforsakringCivilekonomernaAnstalldapbb",
    GruppforsakringSjukforsakringCivilekonomernaAnstalldakr = "GruppforsakringSjukforsakringCivilekonomernaAnstalldakr",
    GruppforsakringOlycksfallsforsakringCopenhagenMalmopbb = "GruppforsakringOlycksfallsforsakringCopenhagenMalmopbb",
    GruppforsakringLivforsakringmfkDiagonalForlagspbb = "GruppforsakringLivforsakringmfkDiagonalForlagspbb",
    GruppforsakringBarnforsakringDiagonalForlagspbb = "GruppforsakringBarnforsakringDiagonalForlagspbb",
    GruppforsakringOlycksfallsforsakringDiagonalForlagspbb = "GruppforsakringOlycksfallsforsakringDiagonalForlagspbb",
    GruppforsakringLivforsakringEFkoncernenpbb = "GruppforsakringLivforsakringEFkoncernenpbb",
    GruppforsakringBarnforsakringEFkoncernenpbb = "GruppforsakringBarnforsakringEFkoncernenpbb",
    GruppforsakringOlycksfallsforsakringEFkoncernenpbb = "GruppforsakringOlycksfallsforsakringEFkoncernenpbb",
    GruppforsakringLivforsakringEngelholmsGlassobligpbb = "GruppforsakringLivforsakringEngelholmsGlassobligpbb",
    GruppforsakringOlycksfallsforsakringEngelholmsGlassobligpbb = "GruppforsakringOlycksfallsforsakringEngelholmsGlassobligpbb",
    GruppforsakringLivforsakringmdubbeltfkEtteplanIndustrypbb = "GruppforsakringLivforsakringmdubbeltfkEtteplanIndustrypbb",
    GruppforsakringSjukforsakringEtteplanIndustrykr = "GruppforsakringSjukforsakringEtteplanIndustrykr",
    GruppforsakringBarnforsakringEtteplanIndustrypbb = "GruppforsakringBarnforsakringEtteplanIndustrypbb",
    GruppforsakringOlycksfallsforsakringEtteplanIndustrypbb = "GruppforsakringOlycksfallsforsakringEtteplanIndustrypbb",
    GruppforsakringSjukocholycksfallsforsakringEtteplanIndustrypbb = "GruppforsakringSjukocholycksfallsforsakringEtteplanIndustrypbb",
    OlycksfallsforsakringKonceptpartneragdbyrapbb = "OlycksfallsforsakringKonceptpartneragdbyrapbb",
    ObligatoriskOlycksfallsforsakringForetagpbb = "ObligatoriskOlycksfallsforsakringForetagpbb",
    OlycksfallsforsakringMaxplanFamansforetagarplanpbb = "OlycksfallsforsakringMaxplanFamansforetagarplanpbb",
    GruppforsakringLivforsakringmdubbeltfkEuropeiskaForsakringspbb = "GruppforsakringLivforsakringmdubbeltfkEuropeiskaForsakringspbb",
    GruppforsakringSjukforsakringEuropeiskaForsakringskr = "GruppforsakringSjukforsakringEuropeiskaForsakringskr",
    GruppforsakringOlycksfallsforsakringEuropeiskaForsakringspbb = "GruppforsakringOlycksfallsforsakringEuropeiskaForsakringspbb",
    GruppforsakringBarnforsakringEuropeiskaForsakringspbb = "GruppforsakringBarnforsakringEuropeiskaForsakringspbb",
    GruppforsakringLivforsakringmfkEvryOneBoraspbb = "GruppforsakringLivforsakringmfkEvryOneBoraspbb",
    GruppforsakringLivforsakringmdubbeltfkEvryOneBoraspbb = "GruppforsakringLivforsakringmdubbeltfkEvryOneBoraspbb",
    GruppforsakringBarnforsakringEvryOneBoraspbb = "GruppforsakringBarnforsakringEvryOneBoraspbb",
    GruppforsakringOlycksfallsforsakringEvryOneBoraspbb = "GruppforsakringOlycksfallsforsakringEvryOneBoraspbb",
    GruppforsakringLivforsakringFricopbb = "GruppforsakringLivforsakringFricopbb",
    GruppforsakringSjukforsakringFricokr = "GruppforsakringSjukforsakringFricokr",
    GruppforsakringBarnforsakringFricopbb = "GruppforsakringBarnforsakringFricopbb",
    GruppforsakringSjukocholycksfallsforsakringFricopbb = "GruppforsakringSjukocholycksfallsforsakringFricopbb",
    GruppforsakringOlycksfallsforsakringFricopbb = "GruppforsakringOlycksfallsforsakringFricopbb",
    GruppforsakringOlycksfallsforsakringFsDynamicsobligpbb = "GruppforsakringOlycksfallsforsakringFsDynamicsobligpbb",
    GruppforsakringLivforsakringmdubbeltfkFsDynamicsobligpbb = "GruppforsakringLivforsakringmdubbeltfkFsDynamicsobligpbb",
    GruppforsakringLivforsakringHestraAdvokatbyrapbb = "GruppforsakringLivforsakringHestraAdvokatbyrapbb",
    GruppforsakringSjukocholycksfallsforsakringHestraAdvokatbyrapbb = "GruppforsakringSjukocholycksfallsforsakringHestraAdvokatbyrapbb",
    GruppforsakringBarnforsakringHestraAdvokatbyrapbb = "GruppforsakringBarnforsakringHestraAdvokatbyrapbb",
    GruppforsakringOlycksfallsforsakringHestraAdvokatbyrapbb = "GruppforsakringOlycksfallsforsakringHestraAdvokatbyrapbb",
    GruppforsakringLivforsakringHuaweiTechnologiespbb = "GruppforsakringLivforsakringHuaweiTechnologiespbb",
    GruppforsakringOlycksfallsforsakringHuaweiTechnologiespbb = "GruppforsakringOlycksfallsforsakringHuaweiTechnologiespbb",
    GruppforsakringLivforsakringHyresbostaderNorrkpbb = "GruppforsakringLivforsakringHyresbostaderNorrkpbb",
    GruppforsakringLivforsakringmfkHyresbostaderNorrkpbb = "GruppforsakringLivforsakringmfkHyresbostaderNorrkpbb",
    GruppforsakringOlycksfallsforsakringHyresbostaderNorrkpbb = "GruppforsakringOlycksfallsforsakringHyresbostaderNorrkpbb",
    GruppforsakringSjukforsakringHyresbostaderNorrkkr = "GruppforsakringSjukforsakringHyresbostaderNorrkkr",
    GruppforsakringBarnforsakringHyresbostaderNorrkpbb = "GruppforsakringBarnforsakringHyresbostaderNorrkpbb",
    TfoAnonympbb = "TfoAnonympbb",
    TglEjkollektivavtaladpersonnrpbb = "TglEjkollektivavtaladpersonnrpbb",
    TglCollectumanonympbb = "TglCollectumanonympbb",
    TglkfSanonympbb = "TglkfSanonympbb",
    TglkfsBegravningshjalpanonympbb = "TglkfsBegravningshjalpanonympbb",
    TfoPersonnrpbb = "TfoPersonnrpbb",
    TglAvgangspensionpnrpbb = "TglAvgangspensionpnrpbb",
    FortsattningsforsakringTgLpnrpbb = "FortsattningsforsakringTgLpnrpbb",
    GruppforsakringLivforsakringInsplanetpbb = "GruppforsakringLivforsakringInsplanetpbb",
    GruppforsakringSjukocholycksfallsforsakringInsplanetpbb = "GruppforsakringSjukocholycksfallsforsakringInsplanetpbb",
    GruppforsakringOlycksfallsforsakringInsplanetpbb = "GruppforsakringOlycksfallsforsakringInsplanetpbb",
    GruppforsakringBarnolycksfallsforsakringInsplanetpbb = "GruppforsakringBarnolycksfallsforsakringInsplanetpbb",
    GruppforsakringLivforsakringmdubbeltfkKeysightpbb = "GruppforsakringLivforsakringmdubbeltfkKeysightpbb",
    GruppforsakringOlycksfallsforsakringKeysightpbb = "GruppforsakringOlycksfallsforsakringKeysightpbb",
    GruppforsakringSjukforsakringKeysightkr = "GruppforsakringSjukforsakringKeysightkr",
    GruppforsakringLivforsakringKyocerapbb = "GruppforsakringLivforsakringKyocerapbb",
    GruppforsakringOlycksfallsforsakringKyocerapbb = "GruppforsakringOlycksfallsforsakringKyocerapbb",
    GruppforsakringLivforsakringLantmannenpbb = "GruppforsakringLivforsakringLantmannenpbb",
    GruppforsakringLivforsakringmfkLantmannenpbb = "GruppforsakringLivforsakringmfkLantmannenpbb",
    GruppforsakringLivforsakringmdubbeltfkLantmannenpbb = "GruppforsakringLivforsakringmdubbeltfkLantmannenpbb",
    GruppforsakringSjukforsakringLantmannenkr = "GruppforsakringSjukforsakringLantmannenkr",
    GruppforsakringOlycksfallsforsakringLantmannenpbb = "GruppforsakringOlycksfallsforsakringLantmannenpbb",
    GruppforsakringBarnforsakringLantmannenpbb = "GruppforsakringBarnforsakringLantmannenpbb",
    PersonforsakringLivforsakringkr = "PersonforsakringLivforsakringkr",
    GruppforsakringLivforsakringLiveNationobligkr = "GruppforsakringLivforsakringLiveNationobligkr",
    GruppforsakringSjukocholycksfallsforsakringRixnittipbb = "GruppforsakringSjukocholycksfallsforsakringRixnittipbb",
    GruppforsakringSjukforsakringMaxMatthiessenItp1Kr = "GruppforsakringSjukforsakringMaxMatthiessenItp1Kr",
    Livforsakringmedfortidskapital = "Livforsakringmedfortidskapital",
    GruppforsakringSjukforsakringMaxMatthiessenItp2Kr = "GruppforsakringSjukforsakringMaxMatthiessenItp2Kr",
    Livforsakringmeddubbeltfortidskapital = "Livforsakringmeddubbeltfortidskapital",
    PersonforsakringFortidskapitalkr = "PersonforsakringFortidskapitalkr",
    GruppforsakringLivforsakringMaxMatthiessenpbb = "GruppforsakringLivforsakringMaxMatthiessenpbb",
    PersonforsakringSjukforsakringkr = "PersonforsakringSjukforsakringkr",
    GruppforsakringLivforsakringMovesticPersonalpbb = "GruppforsakringLivforsakringMovesticPersonalpbb",
    GruppforsakringLivforsakringmfkMovesticPersonalpbb = "GruppforsakringLivforsakringmfkMovesticPersonalpbb",
    GruppforsakringSjukforsakringMovesticPersonalkr = "GruppforsakringSjukforsakringMovesticPersonalkr",
    GruppforsakringOlycksfallsforsakringMovesticPersonalpbb = "GruppforsakringOlycksfallsforsakringMovesticPersonalpbb",
    GruppforsakringBarnforsakringMovesticPersonalpbb = "GruppforsakringBarnforsakringMovesticPersonalpbb",
    GruppforsakringAllvarligsjukdomMovesticPersonalpbb = "GruppforsakringAllvarligsjukdomMovesticPersonalpbb",
    GruppforsakringSjukocholycksfallsforsakringMovesticPersonalpbb = "GruppforsakringSjukocholycksfallsforsakringMovesticPersonalpbb",
    GruppforsakringLivforsakringOriolapbb = "GruppforsakringLivforsakringOriolapbb",
    GruppforsakringLivforsakringmfkOriolapbb = "GruppforsakringLivforsakringmfkOriolapbb",
    GruppforsakringFortidskapitalOriolapbb = "GruppforsakringFortidskapitalOriolapbb",
    GruppforsakringOlycksfallsforsakringOriolapbb = "GruppforsakringOlycksfallsforsakringOriolapbb",
    GruppforsakringBarnforsakringOriolapbb = "GruppforsakringBarnforsakringOriolapbb",
    GruppforsakringSjukforsakringOriolakr = "GruppforsakringSjukforsakringOriolakr",
    GruppforsakringLivforsakringRidderheimpbb = "GruppforsakringLivforsakringRidderheimpbb",
    GruppforsakringOlycksfallsforsakringRidderheimpbb = "GruppforsakringOlycksfallsforsakringRidderheimpbb",
    GruppforsakringBarnforsakringRidderheimpbb = "GruppforsakringBarnforsakringRidderheimpbb",
    GruppforsakringLivforsakringmdubbeltfkSagaformpbb = "GruppforsakringLivforsakringmdubbeltfkSagaformpbb",
    GruppforsakringBarnforsakringSagaformpbb = "GruppforsakringBarnforsakringSagaformpbb",
    GruppforsakringOlycksfallsforsakringSagaformpbb = "GruppforsakringOlycksfallsforsakringSagaformpbb",
    GruppforsakringBarnforsakringFralsningsarménpbb = "GruppforsakringBarnforsakringFralsningsarménpbb",
    GruppforsakringOlycksfallsforsakringFralsningsarménpbb = "GruppforsakringOlycksfallsforsakringFralsningsarménpbb",
    GruppforsakringLivforsakringmdubbeltfkFralsningsarménpbb = "GruppforsakringLivforsakringmdubbeltfkFralsningsarménpbb",
    GruppforsakringSjukforsakringFralsningsarménkr = "GruppforsakringSjukforsakringFralsningsarménkr",
    SjukvardSmartObligatorisk = "SjukvardSmartObligatorisk",
    SjukvardOptimalObligatorisk = "SjukvardOptimalObligatorisk",
    SjukvardSmartFrivillig = "SjukvardSmartFrivillig",
    SjukvardOptimalFrivillig = "SjukvardOptimalFrivillig",
    DirektvardsforsakringBarnmedsjalvrisk = "DirektvardsforsakringBarnmedsjalvrisk",
    PersonforsakringOlycksfallsforsakringkr = "PersonforsakringOlycksfallsforsakringkr",
    PersonforsakringSjukocholycksfallsforsakringkr = "PersonforsakringSjukocholycksfallsforsakringkr",
    PersonforsakringBarnforsakringkr = "PersonforsakringBarnforsakringkr",
    PersonforsakringAllvarligsjukdomkr = "PersonforsakringAllvarligsjukdomkr",
    DirektvardsforsakringBarnutansjalvrisk = "DirektvardsforsakringBarnutansjalvrisk",
    SjukvardSmartSig = "SjukvardSmartSig",
    SjukvardOptimalSig = "SjukvardOptimalSig",
    SjukvardOptimalSiGchefsgrupp = "SjukvardOptimalSiGchefsgrupp",
    SjukvardSmartUddevallaFrivillig = "SjukvardSmartUddevallaFrivillig",
    SjukvardOptimalUddevallaFrivillig = "SjukvardOptimalUddevallaFrivillig",
    SjukvardOptimalUddevallaUtankarens = "SjukvardOptimalUddevallaUtankarens",
    GruppforsakringLivforsakringSekabpbb = "GruppforsakringLivforsakringSekabpbb",
    GruppforsakringLivforsakringmedfkSekabpbb = "GruppforsakringLivforsakringmedfkSekabpbb",
    GruppforsakringLivforsakringmdubbeltfkSekabpbb = "GruppforsakringLivforsakringmdubbeltfkSekabpbb",
    GruppforsakringOlycksfallsforsakringSekabMedEkpbb = "GruppforsakringOlycksfallsforsakringSekabMedEkpbb",
    GruppforsakringOlycksfallsforsakringSekabEkMed2Pbb = "GruppforsakringOlycksfallsforsakringSekabEkMed2Pbb",
    GruppforsakringSjukocholycksfallsforsakringSekabpbb = "GruppforsakringSjukocholycksfallsforsakringSekabpbb",
    GruppforsakringBarnforsakringSekabpbb = "GruppforsakringBarnforsakringSekabpbb",
    GruppforsakringSjukforsakringSekabkr = "GruppforsakringSjukforsakringSekabkr",
    GruppforsakringLivforsakringSiKpbb = "GruppforsakringLivforsakringSiKpbb",
    GruppforsakringOlycksfallsforsakringSiKpbb = "GruppforsakringOlycksfallsforsakringSiKpbb",
    GruppforsakringSjukocholycksfallsforsakringSiKpbb = "GruppforsakringSjukocholycksfallsforsakringSiKpbb",
    GruppforsakringBarnforsakringSiKpbb = "GruppforsakringBarnforsakringSiKpbb",
    GruppforsakringSjukforsakringSiKkr = "GruppforsakringSjukforsakringSiKkr",
    GruppforsakringLivforsakringStrusoftpbb = "GruppforsakringLivforsakringStrusoftpbb",
    GruppforsakringLivforsakringmfkStrusoftpbb = "GruppforsakringLivforsakringmfkStrusoftpbb",
    GruppforsakringLivforsakringmdubbeltfkStrusoftpbbb = "GruppforsakringLivforsakringmdubbeltfkStrusoftpbbb",
    GruppforsakringOlycksfallsforsakringStrusoftpbb = "GruppforsakringOlycksfallsforsakringStrusoftpbb",
    GruppforsakringSjukocholycksfallsforsakringStrusoftpbb = "GruppforsakringSjukocholycksfallsforsakringStrusoftpbb",
    GruppforsakringBarnforsakringStrusoftpbb = "GruppforsakringBarnforsakringStrusoftpbb",
    GruppforsakringSjukforsakringStrusoftFormBelMkr = "GruppforsakringSjukforsakringStrusoftFormBelMkr",
    GruppforsakringSjukforsakringStrusoftFormBelRkr = "GruppforsakringSjukforsakringStrusoftFormBelRkr",
    GruppforsakringLivforsakringmdubbeltfkStyrudpbb = "GruppforsakringLivforsakringmdubbeltfkStyrudpbb",
    GruppforsakringOlycksfallsforsakringStyrudpbb = "GruppforsakringOlycksfallsforsakringStyrudpbb",
    GruppforsakringBarnforsakringStyrudpbb = "GruppforsakringBarnforsakringStyrudpbb",
    GruppforsakringSjukforsakringStyrudFormBelMkr = "GruppforsakringSjukforsakringStyrudFormBelMkr",
    GruppforsakringSjukforsakringStyrudFormBelRkr = "GruppforsakringSjukforsakringStyrudFormBelRkr",
    GruppforsakringLivforsakringmdubbeltfkStampelkompanietpbb = "GruppforsakringLivforsakringmdubbeltfkStampelkompanietpbb",
    GruppforsakringOlycksfallsforsakringStampelkompanietpbb = "GruppforsakringOlycksfallsforsakringStampelkompanietpbb",
    GruppforsakringBarnforsakringStampelkompanietpbb = "GruppforsakringBarnforsakringStampelkompanietpbb",
    GruppforsakringSjukforsakringStampelkompanietkr = "GruppforsakringSjukforsakringStampelkompanietkr",
    GruppforsakringLivforsakringSweetpointobligpbb = "GruppforsakringLivforsakringSweetpointobligpbb",
    GruppforsakringLivforsakringmdubbeltfkSvNaringslivpbb = "GruppforsakringLivforsakringmdubbeltfkSvNaringslivpbb",
    GruppforsakringOlycksfallsforsakringSvNaringslivpbb = "GruppforsakringOlycksfallsforsakringSvNaringslivpbb",
    GruppforsakringBarnforsakringSvNaringslivpbb = "GruppforsakringBarnforsakringSvNaringslivpbb",
    GruppforsakringSjukforsakringSvNaringslivFormBelMkr = "GruppforsakringSjukforsakringSvNaringslivFormBelMkr",
    GruppforsakringSjukforsakringSvNaringslivFormBelRkr = "GruppforsakringSjukforsakringSvNaringslivFormBelRkr",
    GruppforsakringLivforsakringSyncronpbb = "GruppforsakringLivforsakringSyncronpbb",
    GruppforsakringLivforsakringmdubbeltfkSyncronpbb = "GruppforsakringLivforsakringmdubbeltfkSyncronpbb",
    GruppforsakringOlycksfallsforsakringSyncronpbb = "GruppforsakringOlycksfallsforsakringSyncronpbb",
    GruppforsakringSjukocholycksfallsforsakringSyncronpbb411670 = "GruppforsakringSjukocholycksfallsforsakringSyncronpbb411670",
    GruppforsakringSjukocholycksfallsforsakringSyncronpbb411675 = "GruppforsakringSjukocholycksfallsforsakringSyncronpbb411675",
    GruppforsakringLivforsakringUnitedConspbb = "GruppforsakringLivforsakringUnitedConspbb",
    GruppforsakringBarnforsakringSyncronpbb = "GruppforsakringBarnforsakringSyncronpbb",
    GruppforsakringBarnforsakringUnitedConspbb = "GruppforsakringBarnforsakringUnitedConspbb",
    GruppforsakringSjukocholycksfallsforsakringUnitedConspbb = "GruppforsakringSjukocholycksfallsforsakringUnitedConspbb",
    GruppforsakringLivforsakringVadstenapbb = "GruppforsakringLivforsakringVadstenapbb",
    GruppforsakringLivforsakringmdubbeltfkVadstenapbb = "GruppforsakringLivforsakringmdubbeltfkVadstenapbb",
    GruppforsakringBarnforsakringVadstenapbb = "GruppforsakringBarnforsakringVadstenapbb",
    GruppforsakringOlycksfallsforsakringVadstenapbb = "GruppforsakringOlycksfallsforsakringVadstenapbb",
    GruppforsakringSjukforsakringVadstenakr = "GruppforsakringSjukforsakringVadstenakr",
    GruppforsakringOlycksfallsforsakringVerizonSwedenpbb = "GruppforsakringOlycksfallsforsakringVerizonSwedenpbb",
    IbmSjukforsakring90dgr = "IbmSjukforsakring90dgr",
    SjukforsakringVillaagarna90dgr = "SjukforsakringVillaagarna90dgr",
    Antalsbaseradgrupppris = "Antalsbaseradgrupppris",
    SeniorforsakringOlycksfallsforsakringpbb = "SeniorforsakringOlycksfallsforsakringpbb",
    SeniorforsakringLivforsakringpbb = "SeniorforsakringLivforsakringpbb",
    SjukvardSmartUtankarens = "SjukvardSmartUtankarens",
    SjukvardOptimalUtankarens = "SjukvardOptimalUtankarens",
    GrupplivforsakringSmftgkrfel = "GrupplivforsakringSmftgkrfel",
    GrupplivforsakringKonceptpartneragdbyrapbb = "GrupplivforsakringKonceptpartneragdbyrapbb",
    GrupplivforsakringMaqsAdvokatbyraobligpbb = "GrupplivforsakringMaqsAdvokatbyraobligpbb",
    IndividuellLivforsakringKonsneutral20200101 = "IndividuellLivforsakringKonsneutral20200101",
    GrupplivforsakringComfortSystemobligkr = "GrupplivforsakringComfortSystemobligkr",
    GrupplivforsakringGivAktInformationobligkr = "GrupplivforsakringGivAktInformationobligkr",
    FortsattningsforsakringSjukvardsforsakringSmart = "FortsattningsforsakringSjukvardsforsakringSmart",
    FortsattningsforsakringSjukvardsforsakringOptimal = "FortsattningsforsakringSjukvardsforsakringOptimal",
    GruppforsakringLivforsakringArcticGroupABobligpbb = "GruppforsakringLivforsakringArcticGroupABobligpbb",
    GruppforsakringLivforsakringManpowerobligkr = "GruppforsakringLivforsakringManpowerobligkr",
    OppenGruppforsakringLivforsakringpbb = "OppenGruppforsakringLivforsakringpbb",
    OppenGruppforsakringLivforsakringmedfortidskapitalpbb = "OppenGruppforsakringLivforsakringmedfortidskapitalpbb",
    OppenGruppforsakringFortidskapitalpbb = "OppenGruppforsakringFortidskapitalpbb",
    OppenGruppforsakringSjukforsakringkr = "OppenGruppforsakringSjukforsakringkr",
    OppenGruppforsakringOlycksfallsforsakringpbb = "OppenGruppforsakringOlycksfallsforsakringpbb",
    OppenGruppforsakringSjukocholycksfallsforsakringpbb = "OppenGruppforsakringSjukocholycksfallsforsakringpbb",
    OppenGruppforsakringBarnforsakringpbb = "OppenGruppforsakringBarnforsakringpbb",
    OppenGruppforsakringAllvarligsjukdompbb = "OppenGruppforsakringAllvarligsjukdompbb",
    OppenGruppforsakringLivforsakringAlpcotochPartnerskr = "OppenGruppforsakringLivforsakringAlpcotochPartnerskr",
    OppenGruppforsakringAllvarligsjukdomAlpcotochPartnerskr = "OppenGruppforsakringAllvarligsjukdomAlpcotochPartnerskr",
    FortsattningsforsakringSjukforsakringTillaggsformanFortidsochdodsfalls = "FortsattningsforsakringSjukforsakringTillaggsformanFortidsochdodsfalls",
    FortsattningsforsakringSjukforsakringR = "FortsattningsforsakringSjukforsakringR",
    FortsattningsforsakringSjukforsakring360 = "FortsattningsforsakringSjukforsakring360",
    FortsattningsforsakringSjukforsakring180 = "FortsattningsforsakringSjukforsakring180",
    FortsattningsforsakringSjukforsakring90 = "FortsattningsforsakringSjukforsakring90",
    FortsattningsforsakringSjukforsakring30 = "FortsattningsforsakringSjukforsakring30",
    OppenGruppforsakringFortidskapitalAlpcotochPartnerskr = "OppenGruppforsakringFortidskapitalAlpcotochPartnerskr",
    OppenGruppforsakringSjukforsakringAlpcotochPartnerskr = "OppenGruppforsakringSjukforsakringAlpcotochPartnerskr",
    OppenGruppforsakringSjukocholycksfallsforsakringAlpcotochPartnerskr = "OppenGruppforsakringSjukocholycksfallsforsakringAlpcotochPartnerskr",
    PersonforsakringLivforsakringmeddubbeltfortidskapitalkr = "PersonforsakringLivforsakringmeddubbeltfortidskapitalkr",
    PersonforsakringLivforsakringmedenkeltfortidskapitalkr = "PersonforsakringLivforsakringmedenkeltfortidskapitalkr",
    OppenGruppforsakringAllvarligsjukdomAlpcotochPartnerspbb = "OppenGruppforsakringAllvarligsjukdomAlpcotochPartnerspbb",
    OppenGruppforsakringOlycksfallsforsakringAlpcotochPartnerskr = "OppenGruppforsakringOlycksfallsforsakringAlpcotochPartnerskr",
    OppenGruppforsakringBarnforsakringAlpcotochPartnerskr = "OppenGruppforsakringBarnforsakringAlpcotochPartnerskr",
    OppenGruppforsakringLivforsakringSiGpbb = "OppenGruppforsakringLivforsakringSiGpbb",
    NetviqLivforsakringickerokare = "NetviqLivforsakringickerokare",
    NetviqLivforsakringrokare = "NetviqLivforsakringrokare",
    NetviqLivforsakringtillaggolycksfallickerokare = "NetviqLivforsakringtillaggolycksfallickerokare",
    GruppforsakringLivforsakringCapitalCoolingobligkr = "GruppforsakringLivforsakringCapitalCoolingobligkr",
    GruppforsakringLivforsakringCityJetobligkr = "GruppforsakringLivforsakringCityJetobligkr",
    FortsattningsforsakringGruppforsakringLivforsakringTariffkr = "FortsattningsforsakringGruppforsakringLivforsakringTariffkr",
    FortsattningsforsakringGrpLivforsakringmedfortidskapitalTariffkr = "FortsattningsforsakringGrpLivforsakringmedfortidskapitalTariffkr",
    FortsattningsforsakringGrpLivforsakringmeddubbeltfortidskapTariffkr = "FortsattningsforsakringGrpLivforsakringmeddubbeltfortidskapTariffkr",
    FortsattningsforsakringGruppforsakringFortidskapitalTariffkr = "FortsattningsforsakringGruppforsakringFortidskapitalTariffkr",
    NetviqLivforsakringtillaggolycksfallrokare = "NetviqLivforsakringtillaggolycksfallrokare",
    OppenGruppforsakringFortidskapitalSiGpbb = "OppenGruppforsakringFortidskapitalSiGpbb",
    OppenGruppforsakringSjukforsakringSiGkr = "OppenGruppforsakringSjukforsakringSiGkr",
    OlycksfallsforsakringForetagSmftgkr = "OlycksfallsforsakringForetagSmftgkr",
    OppenGruppforsakringSjukocholycksfallsforsakringSiGpbb = "OppenGruppforsakringSjukocholycksfallsforsakringSiGpbb",
    OppenGruppforsakringAllvarligsjukdomSiGpbb = "OppenGruppforsakringAllvarligsjukdomSiGpbb",
    OppenGruppforsakringBarnforsakringSiGpbb = "OppenGruppforsakringBarnforsakringSiGpbb",
    OppenGruppforsakringOlycksfallsforsakringSiGpbb = "OppenGruppforsakringOlycksfallsforsakringSiGpbb",
    Fortsforsakringmall = "Fortsforsakringmall",
    FortsattningsforsakringGruppforsakringLivforsakringpbb = "FortsattningsforsakringGruppforsakringLivforsakringpbb",
    FortsattningsforsakringGrupplivforsakring = "FortsattningsforsakringGrupplivforsakring",
    FortsattningsforsakringGruppforsakringSjukforsakring30Tariffkr = "FortsattningsforsakringGruppforsakringSjukforsakring30Tariffkr",
    FortsattningsforsakringGruppforsakringSjukforsakring90Tariffkr = "FortsattningsforsakringGruppforsakringSjukforsakring90Tariffkr",
    FortsattningsforsakringGruppforsakringSjukforsakring180Tariffkr = "FortsattningsforsakringGruppforsakringSjukforsakring180Tariffkr",
    FortsattningsforsakringGruppforsakringSjukforsakring360Tariffkr = "FortsattningsforsakringGruppforsakringSjukforsakring360Tariffkr",
    FortsattningsforsakringGruppforsakringSjukforsakringRTariffkr = "FortsattningsforsakringGruppforsakringSjukforsakringRTariffkr",
    FortsattningsforsakringGruppforsakringLivforsakringmedfortidskapitalpbb = "FortsattningsforsakringGruppforsakringLivforsakringmedfortidskapitalpbb",
    FortsattningsforsakringGruppforsakringLivforsakringmeddubbeltFkpbb = "FortsattningsforsakringGruppforsakringLivforsakringmeddubbeltFkpbb",
    FortsattningsforsakringGruppforsakringFortidskapitalpbb = "FortsattningsforsakringGruppforsakringFortidskapitalpbb",
    Mall2Fortsfors = "Mall2Fortsfors",
    FortsattningsforsakringGruppforsakringSjukocholycksfallekinvPbb = "FortsattningsforsakringGruppforsakringSjukocholycksfallekinvPbb",
    FortsattningsforsakringGruppforsakringSjukocholycksfallmedinvPbb = "FortsattningsforsakringGruppforsakringSjukocholycksfallmedinvPbb",
    FortsattningsforsakringGruppforsakringolycksfallekonomiskinvPbb = "FortsattningsforsakringGruppforsakringolycksfallekonomiskinvPbb",
    FortsattningsforsakringGruppforsakringolycksfallmedicinskinvPbb = "FortsattningsforsakringGruppforsakringolycksfallmedicinskinvPbb",
    FortsattningsforsakringGruppforsakringBarnforsakringettbarnpbb = "FortsattningsforsakringGruppforsakringBarnforsakringettbarnpbb",
    FortsattningsforsakringGruppforsakringBarnforsakringflerabarnpbb = "FortsattningsforsakringGruppforsakringBarnforsakringflerabarnpbb",
    FortsattningsforsakringGruppforsakringAllvarligsjukdompbb = "FortsattningsforsakringGruppforsakringAllvarligsjukdompbb",
    FortsattningsforsakringGruppforsakringAllvarligsjukdomkr = "FortsattningsforsakringGruppforsakringAllvarligsjukdomkr",
    GrupplivforsakringSmftgkr = "GrupplivforsakringSmftgkr",
    Barnforsakringsumerkr = "Barnforsakringsumerkr",
    GruppforsakringLivforsakringsjukvardkr = "GruppforsakringLivforsakringsjukvardkr",
    MovesticS180Mfsjuk = "MovesticS180Mfsjuk",
    GruppforsakringLivforsakringSalusAnsvarpbb = "GruppforsakringLivforsakringSalusAnsvarpbb",
    GruppforsakringSjukforsakringSalusAnsvarkr = "GruppforsakringSjukforsakringSalusAnsvarkr",
    GruppforsakringOlycksfallsforsakringApoteksgruppenpbb = "GruppforsakringOlycksfallsforsakringApoteksgruppenpbb",
    GruppforsakringOlycksfallsforsakringSalusAnsvarpbb = "GruppforsakringOlycksfallsforsakringSalusAnsvarpbb",
    GruppforsakringSjukocholycksfallsEmSalusAnsvarpbb = "GruppforsakringSjukocholycksfallsEmSalusAnsvarpbb",
    GruppforsakringSjukocholycksfallsMe2SalusAnsvarpbb = "GruppforsakringSjukocholycksfallsMe2SalusAnsvarpbb",
    GruppforsakringBarnforsakringSalusAnsvarpbb = "GruppforsakringBarnforsakringSalusAnsvarpbb",
    IbmSjukforsakringR = "IbmSjukforsakringR",
    SjukforsakringVillaagarnaSjukR = "SjukforsakringVillaagarnaSjukR",
    Sjuk202030 = "Sjuk202030",
    Sjuk202090 = "Sjuk202090",
    Sjuk2020180 = "Sjuk2020180",
    Sjuk2020360 = "Sjuk2020360",
    Sjuk2020R = "Sjuk2020R",
    IntervallSjuk2020 = "IntervallSjuk2020",
    UWarSjuk2020 = "UWarSjuk2020",
    PtlGruppsjukforsakring200430 = "PtlGruppsjukforsakring200430",
    PtlGruppsjukforsakring200490 = "PtlGruppsjukforsakring200490",
    PtlGruppsjukforsakring2004360 = "PtlGruppsjukforsakring2004360",
    PtlGruppsjukforsakring2004R = "PtlGruppsjukforsakring2004R",
    TglpcEjkollektivavtaladpersonnrpbb = "TglpcEjkollektivavtaladpersonnrpbb",
    GruppforsakringLivforsakringStandardpbb = "GruppforsakringLivforsakringStandardpbb",
    GruppforsakringOlycksfallsforsakringStandardpbb = "GruppforsakringOlycksfallsforsakringStandardpbb",
    GruppforsakringSjukforsakringStandardkr = "GruppforsakringSjukforsakringStandardkr",
    MovesticSafloUtbetalningsdodlighet = "MovesticSafloUtbetalningsdodlighet",
    MovesticSafloArvsvinst = "MovesticSafloArvsvinst",
}

export interface BusinessBenefitPremiumCalculationMethodResponse {
    isDefault?: boolean;
    premiumCalculationMethodInInsuranceProductType?: PremiumCalculationMethodInInsuranceProductType;
    defaultSalaryToPremiunTable?: SalaryToPremiumTableResponse | undefined;
}

export enum PremiumCalculationMethodInInsuranceProductType {
    SalaryToPremiumTable = "SalaryToPremiumTable",
    SalaryToPremiumTableBasedOnExisting = "SalaryToPremiumTableBasedOnExisting",
    SimpleCalculationMethod = "SimpleCalculationMethod",
    StandardCalculationMethod = "StandardCalculationMethod",
}

export interface SalaryToPremiumTableResponse {
    salaryToPremiumTableId?: number | undefined;
    salaryToPremiumTableColumn?: SalaryToPremiumTableColumnResponse[] | undefined;
    salaryToPremiumTableRow?: SalaryToPremiumTableRowResponse[] | undefined;
}

export interface SalaryToPremiumTableColumnResponse {
    salaryToPremiumFromSalaryQuantity?: number | undefined;
    salaryToPremiumToSalaryQuantity?: number | undefined;
    quantityUnitTypeTmp?: QuantityUnitType | undefined;
    quantityUnitType?: QuantityUnitType | undefined;
}

export interface SalaryToPremiumTableRowResponse {
    salaryToPremiumTableEntry?: SalaryToPremiumTableEntryResponse[] | undefined;
}

export interface SalaryToPremiumTableEntryResponse {
    salaryToPremiumQuantity?: number | undefined;
    salaryToPremiumQuantityUnit?: QuantityUnitTypeResponse | undefined;
}

export interface QuantityUnitTypeResponse {
    type?: QuantityUnitTypeType | undefined;
}

export enum RiskAssessmentRuleSetType {
    MlStandard = "MlStandard",
    MlIngenriskbedömning = "MlIngenriskbedömning",
    MlLiten = "MlLiten",
    MlStor = "MlStor",
    Ml10Bb = "Ml10Bb",
    MlEkonomiskt1 = "MlEkonomiskt1",
    MlEkonomiskt10Bb = "MlEkonomiskt10Bb",
    Grundanslutning = "Grundanslutning",
    Företagsanslutning = "Företagsanslutning",
    Femellerfler = "Femellerfler",
    Försäkringsbara = "Försäkringsbara",
    Tiotaggare = "Tiotaggare",
    Tiotaggaredirektavstämda = "Tiotaggaredirektavstämda",
    IndividuellLivförsäkring = "IndividuellLivförsäkring",
    Pensionsplan1Till4 = "Pensionsplan1Till4",
    Pensionsplan5Till30 = "Pensionsplan5Till30",
    Pensionsplanfleran30 = "Pensionsplanfleran30",
    GruppforsakringBas = "GruppforsakringBas",
    GruppforsakringBasTillLivFa = "GruppforsakringBasTillLivFa",
    GruppforsakringTillOrdinarieFa = "GruppforsakringTillOrdinarieFa",
    GruppforsakringTillFa = "GruppforsakringTillFa",
    PensionsplanM30 = "PensionsplanM30",
    Pensionsplan1T4 = "Pensionsplan1T4",
    Pensionsplan5T30 = "Pensionsplan5T30",
    Pensionsplan1T4Riskbedomning = "Pensionsplan1T4Riskbedomning",
    Tgl = "Tgl",
    GruppforsakringTillFleraggrarslonupptill30ibb = "GruppforsakringTillFleraggrarslonupptill30ibb",
    GruppforsakringTillStandardObligatorisk = "GruppforsakringTillStandardObligatorisk",
    GruppforsakringTillStandardFrivillig = "GruppforsakringTillStandardFrivillig",
}

export interface BusinessProductSubTypeResponse {
    externalId?: number | undefined;
}

export enum RiskClassType {
    Risk1 = "Risk1",
    Risk2 = "Risk2",
    Risk3 = "Risk3",
}

export interface CreatePensionPlanStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    arcaAgreementId?: number;
    envelopeId?: number | undefined;
    externalId?: string | undefined;
    documentId?: number;
}

export interface CreatePensionPlanStory {
    pensionPlanName?: string | undefined;
    owner?: PersonModel | undefined;
    inpaymentServiceType?: InpaymentServiceType;
    inPaymentFrequency?: InPaymentFrequency;
    retailAgreementId?: number;
    startDate?: string;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    pensionPlanGroups?: CreatePensionPlanGroupStory[] | undefined;
    brokerCode?: string | undefined;
    alternateBillingAddress?: PostalAddressModel | undefined;
    signatureType?: SignatureType;
    accessControlOfRepresentatives?: string | undefined;
    identificationControl?: string | undefined;
    identificationControlActing?: string | undefined;
    representativePersonOfficialId?: string | undefined;
    externalId?: string | undefined;
    signaturePersons?: SignaturePerson[] | undefined;
}

export interface CreatePensionPlanGroupStory {
    name?: string | undefined;
    allocationPrinciples?: AllocationPrinciple[] | undefined;
    riskClass?: RiskClassType;
    insuranceProductName?: string | undefined;
    pensionPlanInsuranceProductId?: number;
    selectOption?: SelectOptionType;
    pensionAge?: number;
    premiumCalculation?: PremiumCalculation | undefined;
    riskAssessmentRuleSet?: RiskAssessmentRuleSetType;
    from?: string | undefined;
    pensionPlanProducts?: PensionPlanProduct[] | undefined;
    employments?: NewEmploymentPlanStory[] | undefined;
    incaAgreementId?: number | undefined;
    toRiskAssessment?: boolean | undefined;
    allEmployeesApplies?: boolean | undefined;
}

export interface AllocationPrinciple {
    valueHolderId?: number;
    percentage?: number;
}

export interface PremiumCalculation {
    quantityCalculationMethodType?: QuantityCalculationMethodType;
    premiumCalculationMethod?: PremiumCalculationMethodInInsuranceProductType;
    name?: string | undefined;
    quantityUnitType?: QuantityUnitTypeType | undefined;
    premiumCalculationMethodAmount?: number | undefined;
    salaryToPremiumTable?: SalaryToPremiumTable | undefined;
}

export interface SalaryToPremiumTable {
    salaryToPremiumTableId?: number | undefined;
    salaryToPremiumTableColumn?: SalaryToPremiumTableColumn[] | undefined;
    salaryToPremiumTableRow?: SalaryToPremiumTableRow[] | undefined;
}

export interface SalaryToPremiumTableColumn {
    salaryToPremiumFromSalaryQuantity?: number | undefined;
    salaryToPremiumTableColumnId?: number | undefined;
    salaryToPremiumToSalaryQuantity?: number | undefined;
    quantityUnitType?: QuantityUnitType | undefined;
    salaryToPremiumTable?: SalaryToPremiumTable | undefined;
    quantityUnitTypeTmp?: QuantityUnitType | undefined;
}

export interface SalaryToPremiumTableRow {
    salaryToPremiumTableRowId?: number | undefined;
    salaryToPremiumFromAge?: number | undefined;
    salaryToPremiumTable?: SalaryToPremiumTable | undefined;
    salaryToPremiumTableEntry?: SalaryToPremiumTableEntry[] | undefined;
    salaryToPremiumToAge?: number | undefined;
}

export interface SalaryToPremiumTableEntry {
    salaryToPremiumQuantity?: number | undefined;
    salaryToPremiumTableEntryId?: number | undefined;
    salaryToPremiumQuantityUnit?: QuantityUnitType | undefined;
    salaryToPremiumTableColumn?: SalaryToPremiumTableColumn | undefined;
    salaryToPremiumTableRow?: SalaryToPremiumTableRow | undefined;
}

export interface PensionPlanProduct {
    insuranceProductInPpgTermsBaseId?: number | undefined;
    variantId?: number;
    paymentTime?: number | undefined;
    benefitPaymentType?: BenefitPaymentType;
    usingSalaryPaymentContract?: boolean | undefined;
    contractPriceWithinParentPrice?: boolean | undefined;
    selectOption?: SelectOptionType;
    benefitAmountCalculations?: BusinessBenefitAmountCalculationMethod[] | undefined;
    basesOfCalculations?: BaseCalculationType[] | undefined;
    priceAdjustment?: number | undefined;
}

export enum BenefitPaymentType {
    None = "None",
    Life = "Life",
    Once = "Once",
    SameAsLife = "SameAsLife",
    Year = "Year",
}

export interface BusinessBenefitAmountCalculationMethod {
    quantityCalculationMethodType?: QuantityCalculationMethodType;
    bnfAmtCmthdType?: BnfAmtCmthdType;
    isDefault?: boolean;
    benefitSimpleAmount?: number | undefined;
    editable?: boolean;
}

export interface NewEmploymentPlanStory {
    personId?: number | undefined;
    incaPersonId?: number;
    from?: string | undefined;
    salary?: number | undefined;
    premium?: number | undefined;
    reportedDate?: string | undefined;
    isFullyWorking?: boolean | undefined;
    isBusinessMan?: boolean | undefined;
    isOneTimePayment?: boolean;
    oneTimePaymentPremium?: number | undefined;
    age?: number;
    uniqueId?: string | undefined;
    personOfficialId?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export enum SignatureType {
    BankId = "BankId",
    Subscribe = "Subscribe",
    Print = "Print",
    SignaturePersons = "SignaturePersons",
}

export interface SignaturePerson {
    personOfficialId?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    role?: string | undefined;
    disabled?: boolean;
    identityDocument?: PhysicalIdentityDocument | undefined;
    identityNumber?: string | undefined;
}

export enum PhysicalIdentityDocument {
    SwedishDrivingLicense = "SwedishDrivingLicense",
    SwedishPassport = "SwedishPassport",
    SwedishNationalIdCard = "SwedishNationalIdCard",
    ForeignIdCard = "ForeignIdCard",
    ExternalBankId = "ExternalBankId",
    Simplified = "Simplified",
}

export interface CreateIndividualInsuranceStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    envelopeId?: number | undefined;
}

export interface CreateFreestandingWithAmlRequest {
    freestandingRequest?: CreateFreestandingRequest | undefined;
    amlPrivatePersonStory?: AmlPrivatePersonStory[] | undefined;
    amlLegalPersonStory?: AmlLegalPersonStory[] | undefined;
    amlContractStory?: AmlContractStory[] | undefined;
    amlControllingPersonStory?: AmlControllingPersonStory[] | undefined;
    withSignatures?: boolean;
}

export interface CreateFreestandingRequest extends Story {
    variantId?: number;
    startDate?: string | undefined;
    amount?: number | undefined;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    premiumType?: ContractPremiumType | undefined;
    inPaymentFrequency?: InPaymentFrequency | undefined;
    outpaymentDate?: string | undefined;
    outPaymentFrequency?: PeriodType | undefined;
    contractPriceEnd?: string | undefined;
    allocationPrincipleDetails?: AllocationPrinciple[] | undefined;
    premiumFree?: boolean | undefined;
    premiumFreePercent?: number | undefined;
    retailAgreementId?: number | undefined;
    fullyWorking?: boolean | undefined;
    accessControlOfRepresentatives?: string | undefined;
    mortgageHolder?: string | undefined;
    owner?: string | undefined;
    insured?: string | undefined;
    insuredEmail?: string | undefined;
    payer?: string | undefined;
    pricePeriod?: PeriodType | undefined;
    benefitAmountPaymentYears?: number | undefined;
    controllingPersons?: ControllingPerson[] | undefined;
    manualControllingPerson?: boolean;
    controllingPersonIsPep?: boolean;
    taxCountryOtherThanSweden?: boolean;
    individualInsuranceCompany?: IndividualInsuranceCompany | undefined;
    insuranceInformation?: InsuranceInformation | undefined;
    companyDetails?: CompanyDetails | undefined;
    adminFeeDiscounts?: AdminFeeDiscount[] | undefined;
    peps?: IndividualInsurancePep[] | undefined;
    signaturePersons?: SignaturePerson[] | undefined;
    brokerCode?: string | undefined;
    ownerCitizenship?: string[] | undefined;
    sumOfInvestmentAboveLimitFreeText?: string | undefined;
    oneTimeDepositOriginOfAsset?: string[] | undefined;
    oneTimeDepositOriginOfAssetFreeText?: string | undefined;
}

export interface ControllingPerson {
    swedishPersonOfficialId?: boolean;
    personOfficialId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthdate?: string | undefined;
    controls?: ControlsCompanyThrough[] | undefined;
    howIsControlExercised?: string[] | undefined;
    citizenship?: string[] | undefined;
    pep?: IndividualInsurancePep | undefined;
    ownerExtent?: OwnerExtent | undefined;
    taxCountries?: AmlTaxCountry[] | undefined;
}

export interface ControlsCompanyThrough {
    controlCode?: Control | undefined;
    legalPersonName?: string | undefined;
    legalPersonOfficialId?: string | undefined;
}

export enum Control {
    Art10 = "Art10",
    Art14 = "Art14",
    Art17 = "Art17",
    Art20 = "Art20",
    Art25 = "Art25",
    Art30 = "Art30",
    Art40 = "Art40",
    Art70 = "Art70",
    Art71 = "Art71",
    Art72 = "Art72",
    Art73 = "Art73",
    Art74 = "Art74",
}

export interface IndividualInsurancePep {
    isPep?: boolean;
    positions?: string[] | undefined;
    residence?: string | undefined;
    isFamily?: boolean | undefined;
    familyName?: string | undefined;
    familyFirstName?: string | undefined;
    familyLastName?: string | undefined;
    relation?: string | undefined;
    familyPositions?: string[] | undefined;
    familyResidence?: string | undefined;
    type?: IndividualInsurancePepType;
}

export enum IndividualInsurancePepType {
    Insured = "Insured",
    MortageHolder = "MortageHolder",
    Owner = "Owner",
}

export enum OwnerExtent {
    ZeroToTwentyFivePercent = "ZeroToTwentyFivePercent",
    TwentyFiveToFiftyPercent = "TwentyFiveToFiftyPercent",
    FiftyToSeventyFivePercent = "FiftyToSeventyFivePercent",
    SeventyFiveToHundredPercent = "SeventyFiveToHundredPercent",
    HundredPercent = "HundredPercent",
}

export interface IndividualInsuranceCompany {
    isActiveNonFinancialInstitution?: boolean | undefined;
    isFinancialInstitution?: boolean | undefined;
    isPassiveNonFinancialInstitution?: boolean | undefined;
    isCompanyListed?: boolean | undefined;
    companyIsFinancialInstitutionCrs?: boolean | undefined;
    companyIsFinancialInstitutionOther?: boolean | undefined;
    companyGiin?: string | undefined;
    taxCountries?: AmlTaxCountry[] | undefined;
}

export interface InsuranceInformation {
    insurancePurpose?: string[] | undefined;
    paymentOrigin?: string[] | undefined;
}

export interface CompanyDetails {
    officialId?: string | undefined;
    name?: string | undefined;
    mainAddress?: MainAddress | undefined;
    companyType?: string | undefined;
    phone?: string | undefined;
    region?: string | undefined;
    url?: string | undefined;
    companySign?: string | undefined;
    companyStatus?: string | undefined;
    companyActive?: string | undefined;
    companyStatusCode?: string | undefined;
    sni?: string | undefined;
    individualCompanyHasMultipleActiveOperations?: boolean;
}

export interface MainAddress {
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    addressWithoutCO?: string | undefined;
    coAddress?: string | undefined;
    country?: string | undefined;
}

export interface AdminFeeDiscount {
    discountTypeId?: number | undefined;
    discountPercent?: number | undefined;
}

export interface AmlPrivatePersonStory {
    personOfficialId?: string | undefined;
    firstName?: string | undefined;
    pep?: boolean;
    rca?: boolean;
    pepInCountry?: string | undefined;
    pepPosition?: string[] | undefined;
    lastName?: string | undefined;
    monthlyIncome?: AmlRange | undefined;
    occupation?: string[] | undefined;
    occupationFreeText?: string | undefined;
    questionId?: number | undefined;
    rcaFirstNameOfPep?: string | undefined;
    rcaInCountry?: string | undefined;
    rcaLastNameOfPep?: string | undefined;
    rcaPepPosition?: string[] | undefined;
    rcaRelationToPep?: string | undefined;
    reason?: string | undefined;
    taxCountries?: AmlTaxCountry[] | undefined;
    manual?: boolean;
    manualReason?: string | undefined;
}

export interface AmlLegalPersonStory {
    officialId?: string | undefined;
    reason?: string | undefined;
    name?: string | undefined;
    controllingPersonsModified?: boolean;
    listedOnStockExchange?: boolean | undefined;
    manual?: boolean;
    manualReason?: string | undefined;
    questionId?: number | undefined;
    taxCountries?: AmlTaxCountry[] | undefined;
    isPassiveNonFinancialInstitution?: boolean;
}

export interface AmlContractStory {
    officialId?: string | undefined;
    reason?: string | undefined;
    questionId?: number | undefined;
    originOfAsset?: string[] | undefined;
    originOfAssetFreeText?: string | undefined;
    plannedDepositVolume?: AmlRange | undefined;
    plannedDepositsPerYear?: AmlRange | undefined;
    purposeOfInvestment?: string[] | undefined;
    purposeOfInvestmentFreeText?: string | undefined;
    manual?: boolean;
    manualReason?: string | undefined;
    sumOfInvestmentAboveLimitFreeText?: string | undefined;
    oneTimeDepositVolume?: AmlRange | undefined;
    oneTimeDepositOriginOfAsset?: string[] | undefined;
    oneTimeDepositOriginOfAssetFreeText?: string | undefined;
}

export interface AmlControllingPersonStory {
    legalPersonOfficialId?: string | undefined;
    citizenship?: string[] | undefined;
    dateOfBirth?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    personOfficialId?: string | undefined;
    position?: string[] | undefined;
    controls?: ControlsCompanyThrough[] | undefined;
    ownerExtent?: OwnerExtent | undefined;
    reason?: string | undefined;
    questionId?: number | undefined;
    manual?: boolean;
    manuallyCreated?: boolean;
    manualReason?: string | undefined;
    taxCountries?: AmlTaxCountry[] | undefined;
    pep?: boolean;
    pepInCountry?: string | undefined;
    pepPosition?: string[] | undefined;
    rca?: boolean;
    rcaFirstNameOfPep?: string | undefined;
    rcaLastNameOfPep?: string | undefined;
    rcaInCountry?: string | undefined;
    rcaPepPosition?: string[] | undefined;
    rcaRelationToPep?: string | undefined;
}

export interface Company {
    id?: number;
    officialId?: string | undefined;
    companyDetails?: CompanyDetails | undefined;
    errorMessage?: string | undefined;
}

export interface CreateOutPaymentStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: CreateOutPaymentStoryValidationResult[] | undefined;
    envelopeId?: number;
    documentId?: number;
}

export interface CreateOutPaymentStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    incaEmploymentId?: number;
}

export interface CreateOutPaymentProposalStoryCommand {
    customerOfficialId?: string | undefined;
    userName?: string | undefined;
    personOfficialId?: string | undefined;
    insuranceOfficialId?: string | undefined;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    pensionDate?: string | undefined;
    paymentTimeInYears?: number | undefined;
    fixedAmount?: number | undefined;
    outPaymentType?: OutPaymentType;
    taxBasisPercent?: number | undefined;
    customerEmailAddress?: string | undefined;
}

export interface OutpaymentAccountAndClearing {
    accountNumber?: string | undefined;
    clearingNumber?: string | undefined;
    hasMultipleOutpaymentContracts?: boolean;
}

export interface OutpaymentInsuranceResponse {
    arcaInsuranceId?: number;
    officialId?: string | undefined;
    friendlyName?: string | undefined;
    marketValue?: number | undefined;
    outpaymentDate?: string | undefined;
    outpaymentStatus?: OutPaymentStatus;
    personBirthDate?: string | undefined;
    personEmailAddress?: string | undefined;
    personOfficialId?: string | undefined;
    productName?: string | undefined;
    arcaProductId?: number | undefined;
    productSubTypeName?: string | undefined;
    benefitsType?: BenefitType | undefined;
    benefitsInsurancePaymentTime?: number | undefined;
    benefitsOutpaymentAmount?: number | undefined;
    benefitsPaymentToDate?: string | undefined;
    benefitsPaymentFromDate?: string | undefined;
    benefitsStartDate?: string | undefined;
    benefitsStatus?: ContractStatus | undefined;
    currentPremiumPriceEnd?: string | undefined;
    currentPremiumAmount?: number | undefined;
}

export interface PensionPlanGroupResponse {
    id?: number | undefined;
    externalId?: number;
    groupName?: string | undefined;
    pensionPlanGroupTerm?: PensionPlanGroupTermResponse | undefined;
}

export interface PensionPlanGroupTermResponse {
    versionFrom?: string | undefined;
    versionTo?: string | undefined;
    riskClassId?: number | undefined;
    products?: PensionPlanProductTermResponse[] | undefined;
}

export interface PensionPlanProductTermResponse {
    id?: number | undefined;
    officialId?: string | undefined;
    name?: string | undefined;
    premiumCalculationMethodName?: string | undefined;
    premiumCalculationMethodAmount?: number | undefined;
    pensionAge?: number | undefined;
    premiumExemption?: number | undefined;
    premiumExemptionWithinParentPrice?: boolean;
    disabledCalculationMethod?: string | undefined;
    disabledWithinParentPrice?: boolean;
    healthCover?: string | undefined;
    survivorsProtection?: string | undefined;
    isOnetimePremiumPaymentIncaProduct?: boolean;
    canChangeSalary?: boolean;
    isDirectlyTunedMooseWithHugeHorns?: boolean;
    defaultProductAllocation?: PensionPlanDefaultAllocationResponse | undefined;
    salaryToPremiumTable?: SalaryToPremiumTableResponse | undefined;
    premiumCalculationMethod?: PremiumCalculationMethodType | undefined;
    benefits?: BenefitInPensionPlanProductTermResponse[] | undefined;
    subProducts?: SubPensionPlanProductTermResponse[] | undefined;
}

export interface PensionPlanDefaultAllocationResponse {
    name?: string | undefined;
    valueHolders?: ValueHolderAllocationResponse[] | undefined;
}

export interface ValueHolderAllocationResponse {
    valueHolderId?: number | undefined;
    name?: string | undefined;
    percentage?: number | undefined;
}

export interface BenefitInPensionPlanProductTermResponse {
    variantName?: string | undefined;
    benefitAmountCalculationMethods?: BenefitAmountCalculationMethodResponse[] | undefined;
    selectOptionType?: BenefitProdSelectOptionType | undefined;
}

export interface BenefitAmountCalculationMethodResponse {
    isDefault?: boolean;
    standardValue?: string | undefined;
}

export enum BenefitProdSelectOptionType {
    Optional = "Optional",
    Required = "Required",
    Standard = "Standard",
    Unavailable = "Unavailable",
}

export interface SubPensionPlanProductTermResponse {
    name?: string | undefined;
    selectOption?: BenefitProdSelectOptionType;
}

export interface PersonLightResponse {
    externalId?: number;
    arcaPersonId?: number;
    officialId?: string | undefined;
    firstName?: string | undefined;
    name?: string | undefined;
}

export interface PrivatePersonSparStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: PrivatePersonStoryValidationResult[] | undefined;
}

export interface PrivatePersonStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
}

export interface SearchResultResponse {
    privatePersons?: PersonSearchResponse[] | undefined;
    isAllPrivatePersons?: boolean | undefined;
    legalPersons?: PersonSearchResponse[] | undefined;
    isAllLegalPersons?: boolean | undefined;
    agreements?: AgreementSearchResponse[] | undefined;
    isAllAgreements?: boolean | undefined;
    insurances?: InsuranceSearchResponse[] | undefined;
    isAllInsurances?: boolean | undefined;
}

export interface PersonSearchResponse {
    officialId?: string | undefined;
    arcaPersonId?: number;
    firstName?: string | undefined;
    name?: string | undefined;
}

export interface AgreementSearchResponse {
    arcaAgreementId?: number;
    agreementOfficialId?: string | undefined;
    ownerFirstName?: string | undefined;
    ownerName?: string | undefined;
    name?: string | undefined;
}

export interface InsuranceSearchResponse {
    arcaInsuranceId?: number;
    officialId?: string | undefined;
    sourceSystem?: SourceSystem;
    insuredName?: string | undefined;
    insuredFirstName?: string | undefined;
    insuredOfficialId?: string | undefined;
    productName?: string | undefined;
    arcaAgreementId?: number | undefined;
}

export enum AdminSearchType {
    PrivatePerson = "PrivatePerson",
    LegalPerson = "LegalPerson",
    Agreement = "Agreement",
    Insurance = "Insurance",
}

export interface AdminPersonSearchRequest {
    search?: string | undefined;
    startsWith?: string | undefined;
    isPrivatePerson?: boolean;
    skip?: number | undefined;
    take?: number | undefined;
}

export interface CustomerKnowlegeResponse {
    insurances?: CustomerKnowledgeInsuranceResponse[] | undefined;
    items?: AmlItemResponse[] | undefined;
    personOfficialId?: string | undefined;
    legalName?: string | undefined;
}

export interface CustomerKnowledgeInsuranceResponse {
    officialId?: string | undefined;
    marketValue?: number;
    friendlyName?: string | undefined;
}

export interface AmlItemResponse {
    type?: AmlType;
}

export enum AmlType {
    Agreement = "Agreement",
    Insurance = "Insurance",
    LegalPerson = "LegalPerson",
    PrivatePerson = "PrivatePerson",
    ControllingPerson = "ControllingPerson",
}

export interface AmlPrivatePersonLoginStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    envelopeId?: number | undefined;
}

export interface CreateAmlPrivatePersonLoginStoryCommand {
    amlPrivatePersonStory?: AmlPrivatePersonStory | undefined;
    amlContractStories?: AmlContractStory[] | undefined;
}

export interface CustomBannerResponse {
    position?: string | undefined;
    page?: string | undefined;
    bannerId?: number;
}

export interface WizardItem {
    title?: string | undefined;
    stepKey?: string | undefined;
    rows?: WizardRow[] | undefined;
}

export interface WizardRow {
    label?: string | undefined;
    value?: string | undefined;
    name?: string | undefined;
}

export interface CreateLifeInsuranceStoryCommand {
    privatePersonOfficialId?: string | undefined;
    emailAddress?: string | undefined;
    mobilePhoneNumber?: string | undefined;
    salaryDemandIsSatisfied?: boolean | undefined;
    insuranceAmount?: number;
    clearingNumber?: string | undefined;
    accountNr?: string | undefined;
    healthQuestions?: HealthQuestions | undefined;
    decodedVisibleData?: string | undefined;
    mailAddressRisk?: string | undefined;
    isInvoice?: boolean;
    brokerCode?: string | undefined;
    affiliate?: string | undefined;
    initiatingEnvelopeId?: number | undefined;
    reasonForHigherDemandIfNotSatisfied?: string | undefined;
    monthlySalary?: number | undefined;
}

export interface HealthQuestions {
    isSmoker?: boolean;
    swedishCitizen2Years?: boolean;
    bmi?: BMI | undefined;
    contactWithHealthcare?: ContactWithHealthcare | undefined;
    prescribedMedication?: PrescribedMedication | undefined;
    symptomsWithoutHealthcareContact?: SymptomsWithoutHealthcareContact | undefined;
    previousRejection?: PreviousRejection | undefined;
}

export interface BMI {
    length?: number;
    weight?: number;
    bmi?: number;
}

export interface ContactWithHealthcare {
    contactHealthcareLastFiveYears?: YesNoQuestion | undefined;
    reasonForHealthcareContact?: ReasonForHealthcareContact | undefined;
}

export interface YesNoQuestion {
    question?: string | undefined;
    answer?: boolean | undefined;
}

export interface ReasonForHealthcareContact {
    question?: string | undefined;
    cancer?: ReasonForHealthCareContactQuestion | undefined;
    heart?: ReasonForHealthCareContactQuestion | undefined;
    diabetes?: ReasonForHealthCareContactQuestion | undefined;
    respiratoryDisease?: ReasonForHealthCareContactQuestion | undefined;
    drugAbuse?: ReasonForHealthCareContactQuestion | undefined;
    kidneyLiverIntestine?: ReasonForHealthCareContactQuestion | undefined;
    rheumatical?: ReasonForHealthCareContactQuestion | undefined;
    neurological?: ReasonForHealthCareContactQuestion | undefined;
    psychological?: ReasonForHealthCareContactQuestion | undefined;
}

export interface ReasonForHealthCareContactQuestion {
    question?: YesNoQuestion | undefined;
    followUpQuestions?: FollowUpQuestions | undefined;
}

export interface FollowUpQuestions {
    formerDisease?: TextQuestion | undefined;
    startOfSickness?: DateQuestion | undefined;
    healthcareFacility?: TextQuestion | undefined;
    treatment?: TextQuestion | undefined;
    lastHealthcareContact?: DateQuestion | undefined;
    isFreeOfSymptom?: YesNoQuestion | undefined;
    freeOfSymptomSince?: DateQuestion | undefined;
    notFreeOfSymptoms?: TextQuestion | undefined;
}

export interface TextQuestion {
    question?: string | undefined;
    answer?: string | undefined;
}

export interface DateQuestion {
    question?: string | undefined;
    answer?: YearMonth | undefined;
}

export interface YearMonth {
    year?: number;
    month?: number;
}

export interface PrescribedMedication {
    question?: YesNoQuestion | undefined;
    currentPrescriptions?: TextQuestion | undefined;
}

export interface SymptomsWithoutHealthcareContact {
    question?: YesNoQuestion | undefined;
    currentSymptoms?: TextQuestion | undefined;
}

export interface PreviousRejection {
    question?: YesNoQuestion | undefined;
}

export interface DigitalLifeRequest {
    personOfficialId?: string | undefined;
    envelopeId?: number;
}

export interface DiscussionResponse {
    title?: string | undefined;
    description?: string | undefined;
    read?: string | undefined;
    type?: DiscussionType;
    category?: DiscussionCategory;
    latestMessageDirection?: Direction;
    modified?: string | undefined;
    created?: string;
    externalId?: string | undefined;
    notifyCustomer?: boolean | undefined;
}

export enum DiscussionType {
    Message = "Message",
    Document = "Document",
    Mail = "Mail",
    Story = "Story",
}

export enum DiscussionCategory {
    None = "None",
    Injury = "Injury",
    Risk = "Risk",
}

export enum Direction {
    FromCustomer = "FromCustomer",
    ToCustomer = "ToCustomer",
}

export interface DiscussionMessageResponse {
    externalId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    read?: string | undefined;
    type?: DiscussionType;
    messageInformation?: MessageInformationResponse | undefined;
    messages?: Message[] | undefined;
    modified?: string;
    created?: string;
    envelopeId?: string | undefined;
}

export interface MessageInformationResponse {
    upperSection?: string | undefined;
    lowerSection?: string | undefined;
    upperSectionFormat?: string | undefined;
    lowerSectionFormat?: string | undefined;
    attachments?: Attachment[] | undefined;
    direction?: Direction;
    created?: string;
}

export interface Attachment {
    attachmentName?: string | undefined;
    documentExternalId?: string | undefined;
    created?: string;
    createdBy?: string | undefined;
    envelopeId?: string | undefined;
    direction?: Direction;
}

export interface Message {
    discussionId?: number;
    body?: string | undefined;
    direction?: Direction;
    deleted?: string;
    created?: string;
    createdBy?: string | undefined;
    attachments?: Attachment[] | undefined;
    format?: string | undefined;
}

export interface CustomerDocumentResponse {
    fileName?: string | undefined;
    externalId?: string;
    typeCode?: string | undefined;
    name?: string[] | undefined;
    title?: string | undefined;
    created?: string;
    insuranceOfficialId?: string | undefined;
    isReadByActor?: boolean | undefined;
    description?: string | undefined;
}

export interface CustomerDocumentSearchRequest {
    search?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export interface InsuranceFundResponse {
    id?: number;
    name?: string | undefined;
    closeType?: ValueHolderCloseType;
}

export interface CreateGroupAccidentStoryResult {
    envelopeId?: number | undefined;
}

export interface CreateDisabledAccidentResult {
    envelopeId?: number | undefined;
}

export interface CustomerInsuranceResponse {
    arcaInsuranceId?: number;
    arcaProductId?: number | undefined;
    officialId?: string | undefined;
    marketValue?: number | undefined;
    totalSavingsInPaymentAmount?: number | undefined;
    totalOutPaymentAmount?: number | undefined;
    friendlyName?: string | undefined;
    ownerHasDeceased?: boolean;
    status?: InsuranceStatus;
    ongoingTradeCount?: number;
    isRiskInsurance?: boolean;
    benefits?: string[] | undefined;
    contractStartDate?: string | undefined;
    taxCategory?: TaxCategory | undefined;
    roles?: CustomerInsuranceRoleResponse[] | undefined;
    productName?: string | undefined;
    isPcRisk?: boolean;
    contractSubtype?: ContractSubtype | undefined;
    productFormName?: string | undefined;
    savingsProductGroup?: SavingsProductGroup | undefined;
}

export interface CustomerInsuranceRoleResponse {
    type?: RoleType;
    name?: string | undefined;
}

export enum RoleType {
    Insured = "Insured",
    Broker = "Broker",
    Owner = "Owner",
    Payee = "Payee",
    Pledgee = "Pledgee",
    Commission = "Commission",
}

export enum SavingsProductGroup {
    PensionInsuranceGroup = "PensionInsuranceGroup",
    CapitalInsuranceGroup = "CapitalInsuranceGroup",
}

export interface CustomerInsuranceDistrubutionResponse {
    distributionType?: DistributionType;
    distributions?: CustomerInsuranceDistrubutionPairResponse[] | undefined;
}

export enum DistributionType {
    FundType = "FundType",
    Region = "Region",
    Sector = "Sector",
}

export interface CustomerInsuranceDistrubutionPairResponse {
    key?: string | undefined;
    value?: number | undefined;
}

export interface InsuranceContactResponse {
    name?: string | undefined;
    officeEmail?: string | undefined;
    officePhone?: string | undefined;
    officeName?: string | undefined;
    isAffiliateBroker?: boolean;
    isMovesticBroker?: boolean;
}

export interface CustomerInsuranceHoldingResponse {
    ongoingTradeCount?: number;
    holdings?: InsuranceHoldingLightResponse[] | undefined;
}

export interface InsuranceOutpaymentResponse {
    insuranceOfficialId?: string | undefined;
    arcaInsuranceId?: number;
    taxBasisPercent?: number | undefined;
    friendlyName?: string | undefined;
    totalAmount?: number | undefined;
    taxCategory?: string | undefined;
    productGroupName?: string | undefined;
    priceUpdatedDate?: string | undefined;
    outpayment?: OutpaymentResponse | undefined;
}

export interface OutpaymentResponse {
    outpaymentDate?: string | undefined;
    outpaymentAmount?: number | undefined;
    taxAmount?: number | undefined;
    paymentToDate?: string | undefined;
    remainingOutpayments?: number | undefined;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    outpaymentStartDate?: string | undefined;
    remainingOutpaymentYears?: number | undefined;
    outpaymentType?: string | undefined;
    hasMultipleOutpaymentContracts?: boolean;
}

export interface InsuranceInpaymentResponse {
    arcaInsuranceId?: number;
    insuranceOfficialId?: string | undefined;
    friendlyName?: string | undefined;
    totalInpaymentAmount?: number | undefined;
    productGroupName?: string | undefined;
    totalInpaymentValueAmount?: number | undefined;
    inpaymentAmount?: number | undefined;
    inpaymentAmountDate?: string | undefined;
    totalInpaymentValueAmountDate?: string | undefined;
    canPlan?: boolean;
}

export interface InsuranceTransactionResponse {
    completedAmount?: number | undefined;
    taxAmount?: number | undefined;
    completedDatetime?: string | undefined;
    categoryName?: string | undefined;
    officialId?: string | undefined;
    contractTransactionId?: number | undefined;
    categoryType?: YearlyReportTransactionCategoryType | undefined;
    expandable?: boolean;
    subTransactions?: InsuranceSubTransactionResponse[] | undefined;
    isOutpayment?: boolean;
}

export enum YearlyReportTransactionCategoryType {
    Fee = "Fee",
    FeeRiskPremiumWaiver = "FeeRiskPremiumWaiver",
    FeeValueHolderDepot = "FeeValueHolderDepot",
    Outpayment = "Outpayment",
    Inpayment = "Inpayment",
    DpdValueInvoicedExternalPremium = "DpdValueInvoicedExternalPremium",
    RelocationBonus = "RelocationBonus",
    FundFeeDiscount = "FundFeeDiscount",
    Compensation = "Compensation",
    CustomerBonus = "CustomerBonus",
    PensionBoost = "PensionBoost",
    RiskCompensation = "RiskCompensation",
    FeeInheritanceGain = "FeeInheritanceGain",
    CorrValue = "CorrValue",
    Tax = "Tax",
    FeeYieldTax = "FeeYieldTax",
    Transaction = "Transaction",
    ValueTransferTo = "ValueTransferTo",
    DebitedPriceDetailValueContractualReimbursement = "DebitedPriceDetailValueContractualReimbursement",
    DebitedPriceDetailValueOptionalReimbursement = "DebitedPriceDetailValueOptionalReimbursement",
    DpdValueContractualTargetPrice = "DpdValueContractualTargetPrice",
    DebitedPriceDetailValueOptional = "DebitedPriceDetailValueOptional",
    RedemptionSurrender = "RedemptionSurrender",
    ImportedValueExternalCompensation = "ImportedValueExternalCompensation",
    ImportedValueExternalFee = "ImportedValueExternalFee",
    ImportedValueExternal = "ImportedValueExternal",
    PremiumReimbursementCorrection = "PremiumReimbursementCorrection",
    ImportedValueInternal = "ImportedValueInternal",
    FeeAdministrative = "FeeAdministrative",
    FeeAdministrativeFixedFee = "FeeAdministrativeFixedFee",
    FeeAdministrativeCapitalFee = "FeeAdministrativeCapitalFee",
    FeeRiskDeath = "FeeRiskDeath",
    PurchaseDebitedPriceDetailTransaction = "PurchaseDebitedPriceDetailTransaction",
    AccruedFeeImportedValue = "AccruedFeeImportedValue",
    FeeImport = "FeeImport",
    FeePremium = "FeePremium",
    FeePremiumCompensation = "FeePremiumCompensation",
    SavingsPremiumCompensation = "SavingsPremiumCompensation",
    SavingsPremiumFee = "SavingsPremiumFee",
    ImportedValueExternalGroupPurchase = "ImportedValueExternalGroupPurchase",
}

export interface InsuranceSubTransactionResponse {
    completedAmount?: number | undefined;
    contractTransactionId?: number | undefined;
    completedDatetime?: string | undefined;
    contractId?: number;
    categoryType?: YearlyReportTransactionCategoryType | undefined;
    categoryName?: string | undefined;
}

export interface FundChangeTransactionResponse {
    contractTransactionId?: number;
    type?: FundChangeTransactionType;
    typeName?: string | undefined;
    ordered?: string | undefined;
}

export enum FundChangeTransactionType {
    FundChange = "FundChange",
    FutureAllocation = "FutureAllocation",
}

export interface FundChangeTransactionValueHolderResponse {
    contractTransactionId?: number | undefined;
    transactionValues?: FundChangeTransactionValueTransactionResponse[] | undefined;
}

export interface FundChangeTransactionValueTransactionResponse {
    valueHolderId?: number;
    valueHolderName?: string | undefined;
    completedAmount?: number | undefined;
    completedUnits?: number | undefined;
    unitPrice?: number | undefined;
    valueHolderPriceDatetime?: string | undefined;
    isClosed?: boolean;
}

export interface FundChangeTransactionFutureAllocationResponse {
    valueHolderId?: number | undefined;
    valueHolderName?: string | undefined;
    purchasePercent?: number | undefined;
    isClosed?: boolean;
}

export interface InsuranceHoldingRequest {
    currentHoldings?: HoldingRequest[] | undefined;
    futureHoldings?: HoldingRequest[] | undefined;
    insuranceIsTrading?: boolean;
    insuranceOfficialId?: string | undefined;
}

export interface HoldingRequest {
    holderId?: number;
    allocation?: number;
    allocationPrinciple?: number;
    allocationRoundedPercentage?: number;
    excludeFromReallocation?: boolean;
}

export interface InsuranceHoldingResponse {
    arcaInsuranceId?: number;
    officialId?: string | undefined;
    ongoingTradeCount?: number;
    friendlyName?: string | undefined;
    isRiskInsurance?: boolean;
    incaInsuranceId?: number;
    isReplacementInsurance?: boolean;
    productName?: string | undefined;
    productSourceSystem?: SourceSystem;
    productSubTypeName?: string | undefined;
    marketValue?: number;
    personStatus?: PersonStatus;
    insuranceStatus?: InsuranceStatus;
    productGroup?: InsuranceProductGroup;
    isTrading?: boolean;
    holdings?: HoldingResponse[] | undefined;
    hasCustomerRoles?: boolean;
    ownerHasDeceased?: boolean;
    status?: InsuranceStatus;
    isOwnerPostalCountryBlocked?: boolean;
}

export interface HoldingResponse {
    holderId?: number;
    holderName?: string | undefined;
    allocationRoundedPercentage?: number;
    allocation?: number;
    holdingAmount?: number;
    allocationPrinciple?: number;
    excludeFromReallocation?: boolean;
    isInOffer?: boolean;
    fundQuantity?: number;
    closeType?: ValueHolderCloseType;
    fundType?: FundType;
    holdingTotalAmountValue?: number;
}

export interface InsuranceTransactionPlanEarlyResponse {
    completedAmount?: number | undefined;
    completedDatetime?: string | undefined;
    arcaInsuranceId?: number;
}

export interface CreateOutPaymentStoryCommand {
    userName?: string | undefined;
    personOfficialId?: string | undefined;
    insuranceOfficialId?: string | undefined;
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
    pensionDate?: string | undefined;
    paymentTimeInYears?: number | undefined;
    fixedAmount?: number | undefined;
    outPaymentType?: OutPaymentType;
    taxBasisPercent?: number | undefined;
    customerEmailAddress?: string | undefined;
}

export interface ChangeOutPaymentStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    validationResult?: ChangeOutPaymentStoryValidationResult[] | undefined;
    envelopeId?: number;
    documentId?: number;
}

export interface ChangeOutPaymentStoryValidationResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    incaEmploymentId?: number;
}

export interface ChangeOutPaymentStoryCommand {
    userName?: string | undefined;
    personOfficialId?: string | undefined;
    insuranceOfficialId?: string | undefined;
    paymentTimeInYears?: number | undefined;
    fixedAmount?: number | undefined;
    outPaymentType?: OutPaymentType;
}

export interface ChangePensionDateStoryCommand {
    personOfficialId?: string | undefined;
    insuranceOfficialId?: string | undefined;
    pensionDate?: string | undefined;
}

export interface UpdateOutpaymentDetailsStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    envelopeId?: number | undefined;
}

export interface UpdateOutpaymentDetailsRequest {
    clearingNumber?: string | undefined;
    accountNumber?: string | undefined;
}

export interface UpdateElectronicAddressesResult {
    envelopeId?: number;
    isSuccessful?: boolean;
}

export interface UpdateElectronicAddressesRequest {
    email?: string | undefined;
    phone?: string | undefined;
}

export interface User {
    id?: number;
    userName?: string | undefined;
    newsLetter?: boolean;
    passwordRecoveryTypeIsEmail?: boolean;
    active?: boolean;
    lastLogin?: string | undefined;
    personId?: number | undefined;
    refType?: UserType;
    termsAccepted?: boolean;
    failedLogins?: number;
    customerNeedsOnBoarding?: boolean;
    customerMustAnswerAml?: boolean;
    hasExpiredContactDetails?: boolean;
    hasInvalidContactDetails?: boolean;
    notificationDisabled?: boolean;
    isSuperUser?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export enum UserType {
    Broker = "Broker",
    Customer = "Customer",
    SuperUser = "SuperUser",
}

export interface ChangePasswordCommand {
    password?: string | undefined;
    oldPassword?: string | undefined;
}

export interface AgreementCompanyStatisticsResponse {
    arcaAgreementId?: number;
    agreementOfficialId?: string | undefined;
    totalInforce?: number | undefined;
    totalPaidUp?: number | undefined;
}

export interface AdministrationAgreementIdResponse {
    pensionPlanId?: number;
    arcaAgreementId?: number;
    agreementOfficialId?: string | undefined;
}

export interface AdministrationAgreementResponse {
    pensionPlanId?: number;
    arcaAgreementId?: number;
    agreementExternalId?: number;
    agreementOfficialId?: string | undefined;
    isManagable?: boolean;
    arcaPersonId?: number;
    agreementDetailsPensionPlanGroups?: AdministrationPensionPlanGroupResponse[] | undefined;
}

export interface AdministrationPensionPlanGroupResponse {
    id?: number | undefined;
    externalId?: number;
    groupName?: string | undefined;
    pensionPlanGroupTerm?: AdministrationPensionPlanGroupTerm | undefined;
}

export interface AdministrationPensionPlanGroupTerm {
    products?: AdministrationPensionPlanProductTerm[] | undefined;
}

export interface AdministrationPensionPlanProductTerm {
    id?: number | undefined;
    canChangeSalary?: boolean;
    isDirectlyTunedMooseWithHugeHorns?: boolean;
    premiumCalculationMethod?: PremiumCalculationMethodType | undefined;
}

export interface CompanyAgreementResponse {
    arcaAgreementId?: number;
    agreementOfficialId?: string | undefined;
    owner?: CompanyAgreementOwner | undefined;
    agreementDetails?: CompanyAgreementDetails | undefined;
    retailAgreement?: CompanyRetailAgreement | undefined;
}

export interface CompanyAgreementOwner {
    fullName?: string | undefined;
    postalAddresses?: CompanyAgreementPostalAddress[] | undefined;
    officialId?: string | undefined;
    arcaPersonId?: number;
}

export interface CompanyAgreementPostalAddress {
    primary?: boolean;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
}

export interface CompanyAgreementDetails {
    holdingAmount?: number | undefined;
    inPaymentMethod?: string | undefined;
    inPaymentFrequency?: InPaymentFrequency | undefined;
    totalPremium?: number | undefined;
    insurances?: CompanyAgreementInsurance[] | undefined;
    pensionPlan?: CompanyPensionPlan | undefined;
}

export interface CompanyAgreementInsurance {
    arcaInsuranceId?: number;
    officialId?: string | undefined;
    roles?: CompanyInsuranceRoles | undefined;
    agreement?: CompanyAgreementResponse | undefined;
    product?: CompanyProductResponse | undefined;
    startDate?: string | undefined;
    riskAssessment?: HasActiveRiskAssessment | undefined;
    amountsPremiumPriceAmount?: number | undefined;
    status?: InsuranceStatus;
    currentPremium?: CompanyAgreementInsurancePremium | undefined;
}

export interface CompanyInsuranceRoles {
    insured?: CompanyAgreementOwner | undefined;
}

export interface CompanyProductResponse {
    productGroup?: InsuranceProductGroup;
    productSubTypeName?: string | undefined;
    productFriendlyName?: string | undefined;
}

export interface CompanyAgreementInsurancePremium {
    priceAmount?: number;
    premiumFreeAmount?: number | undefined;
}

export interface CompanyPensionPlan {
    pensionPlanGroups?: CompanyPensionPlanGroup[] | undefined;
}

export interface CompanyPensionPlanGroup {
    id?: number;
    groupName?: string | undefined;
    externalId?: number;
    pensionPlanGroupTerm?: CompanyPensionPlanGroupTerm | undefined;
}

export interface CompanyPensionPlanGroupTerm {
    products?: CompanyPensionPlanProductTerm[] | undefined;
    versionFrom?: string | undefined;
}

export interface CompanyPensionPlanProductTerm {
    id?: number | undefined;
    name?: string | undefined;
    premiumCalculationMethodId?: number | undefined;
    premiumCalculationMethod?: PremiumCalculationMethodType | undefined;
    premiumCalculationMethodAmount?: number | undefined;
    premiumCalculationMethodName?: string | undefined;
    pensionAge?: number | undefined;
    premiumExemption?: number | undefined;
    premiumExemptionWithinParentPrice?: boolean;
    disabledCalculationMethod?: string | undefined;
    disabledWithinParentPrice?: boolean;
    survivorsProtection?: string | undefined;
    familyPensionMethod?: string | undefined;
    familyPensionWithinParentPrice?: boolean;
    defaultProductAllocation?: PensionPlanDefaultAllocation | undefined;
}

export interface PensionPlanDefaultAllocation {
    name?: string | undefined;
    valueHolders?: ValueHolderAllocation[] | undefined;
}

export interface CompanyRetailAgreement {
    businessAgreementName?: string | undefined;
}

export interface CreateAmlUserForCompanyStoryResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    envelopeId?: number | undefined;
}

export interface CreateAmlContractStoryCommand {
    legalPersonOfficialId?: string | undefined;
    personOfficialId?: string | undefined;
    officialId?: string | undefined;
    reason?: string | undefined;
    questionId?: number | undefined;
    originOfAsset?: string[] | undefined;
    originOfAssetFreeText?: string | undefined;
    plannedDepositVolume?: AmlRange | undefined;
    plannedDepositsPerYear?: AmlRange | undefined;
    purposeOfInvestment?: string[] | undefined;
    purposeOfInvestmentFreeText?: string | undefined;
    manual?: boolean;
    manualReason?: string | undefined;
    sumOfInvestmentAboveLimitFreeText?: string | undefined;
    oneTimeDepositVolume?: AmlRange | undefined;
    oneTimeDepositOriginOfAsset?: string[] | undefined;
    oneTimeDepositOriginOfAssetFreeText?: string | undefined;
}

export interface AmlLegalPersonResult {
    status?: StoryStatus;
    messages?: StoryMessage[] | undefined;
    envelopeId?: number | undefined;
}

export interface CreateAmlLegalPersonStoryCommand {
    personOfficialId?: string | undefined;
    legalPerson?: AmlLegalPersonStory | undefined;
    controllingPersons?: AmlControllingPersonStory[] | undefined;
}

export interface CreateAmlUserForCompanyStoryCommand {
    legalPersonOfficialId?: string | undefined;
    personOfficialId?: string | undefined;
    identifier?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAdress?: string | undefined;
    role?: string | undefined;
    signingAuthority?: boolean | undefined;
}

export interface CompanyRepresentativeResponse {
    id?: number;
    legalPersonId?: number;
    legalPersonName?: string | undefined;
    legalPersonOfficialId?: string | undefined;
}

export interface CompanyAuthenticationResponse {
    id?: number;
    email?: string | undefined;
    legalPersonId?: number;
    legalPersonName?: string | undefined;
    isExpired?: boolean;
}

export interface VerifyVerificationCodeRequest {
    id?: number;
    code?: string | undefined;
}

export interface CompanyResponse {
    officialId?: string | undefined;
    name?: string | undefined;
    companyType?: string | undefined;
    addresses?: string[] | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    externalId?: number;
}

export interface CompanyUserResponse {
    id?: number;
    legalPersonName?: string | undefined;
    privatePersonOfficialId?: string | undefined;
    privatePersonName?: string | undefined;
    email?: string | undefined;
    validFrom?: string;
    validTo?: string | undefined;
    role?: string | undefined;
    roles?: AuthRole[] | undefined;
    isExpired?: boolean;
    createdDate?: string;
    updatedDate?: string | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export enum AuthRole {
    BankIdAuth = "BankIdAuth",
    Broker_Assistant = "Broker_Assistant",
    Broker = "Broker",
    Customer = "Customer",
    SuperUser = "SuperUser",
    SigningUser = "SigningUser",
    Maia_User = "Maia_User",
    CompanyMasterAdmin = "CompanyMasterAdmin",
    CompanyAdmin = "CompanyAdmin",
    CompanyAML = "CompanyAML",
    CompanyRead = "CompanyRead",
    CompanySigningAuthority = "CompanySigningAuthority",
}

export interface CompanyUserRequest {
    id?: number;
    legalPersonId?: number;
    email?: string | undefined;
    role?: string | undefined;
    privatePersonOfficialId?: string | undefined;
    roles?: AuthRole[] | undefined;
    validFrom?: string;
    validTo?: string;
    legalPersonOfficialId?: string | undefined;
}

export interface GroupedCompanyDocumentResponse {
    documentTypeCode?: string | undefined;
    groupedByYearDocuments?: GroupedByYearInvoicesResponse[] | undefined;
}

export interface CompanyAdministrationEmploymentResponse {
    employmentId?: number | undefined;
    arcaAgreementId?: number;
    pensionPlanGroupId?: number;
    pensionPlanId?: number;
    status?: EmploymentStatus | undefined;
    latestChangedDate?: string | undefined;
    companyOwnerType?: CompanyOwnerType | undefined;
    insurances?: CompanyAdministrationInsuranceResponse[] | undefined;
    owner?: CompanyAdministrationPersonResponse | undefined;
    latestEmploymentAdjustment?: EmploymentAdjustment | undefined;
    latestEmploymentAdjustmentPremium?: number | undefined;
    latestEmploymentTerms?: EmploymentTerm | undefined;
    latestEmploymentTermsRiskAssesment?: RiskAssesment | undefined;
}

export enum CompanyOwnerType {
    Employee = "Employee",
    MainPartOwner = "MainPartOwner",
}

export interface CompanyAdministrationInsuranceResponse {
    incaInsuranceId?: number;
    productName?: string | undefined;
    productSubTypeName?: string | undefined;
    productSubTypeId?: any | undefined;
    productArcaProductId?: number | undefined;
    productGroup?: InsuranceProductGroup | undefined;
    arcaAgreementId?: number | undefined;
    arcaInsuranceId?: number;
    officialId?: string | undefined;
    status?: InsuranceStatus;
    hasActiveRiskAssessment?: boolean | undefined;
    startDate?: string | undefined;
    pensionPlanGroupName?: string | undefined;
    taxCategory?: TaxCategory | undefined;
    benefits?: CompanyAdministrationBenefitsResponse[] | undefined;
}

export interface CompanyAdministrationBenefitsResponse {
    calculationMethodAmount?: number | undefined;
    calculationMethodUnitType?: QuantityUnitType | undefined;
    type?: BenefitType | undefined;
    calculationMethodName?: string | undefined;
}

export interface CompanyAdministrationPersonResponse {
    externalId?: number;
    officialId?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
}

export interface CompanyInsuranceBenefitResponse {
    hasDisabled?: boolean;
    hasPremiumFree?: boolean;
}

export interface EmploymentPriceOffer {
    employmentUniqueId?: string | undefined;
    totalPremium?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}